// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-intl-tel-input/dist/main.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Global Style file where all index file will be imported
*/
.padding-1 {
  padding: 1rem;
}

.pt-1 {
  padding-top: 1rem;
}

.pb-1 {
  padding-top: 1px;
}

.pl-1 {
  padding-left: 1px;
}

.pb-1 {
  padding-right: 1px;
}

.padding-2 {
  padding: 2rem;
}

.pt-2 {
  padding-top: 2rem;
}

.pb-2 {
  padding-top: 2px;
}

.pl-2 {
  padding-left: 2px;
}

.pb-2 {
  padding-right: 2px;
}

.padding-3 {
  padding: 3rem;
}

.pt-3 {
  padding-top: 3rem;
}

.pb-3 {
  padding-top: 3px;
}

.pl-3 {
  padding-left: 3px;
}

.pb-3 {
  padding-right: 3px;
}

.padding-4 {
  padding: 4rem;
}

.pt-4 {
  padding-top: 4rem;
}

.pb-4 {
  padding-top: 4px;
}

.pl-4 {
  padding-left: 4px;
}

.pb-4 {
  padding-right: 4px;
}

.padding-5 {
  padding: 5rem;
}

.pt-5 {
  padding-top: 5rem;
}

.pb-5 {
  padding-top: 5px;
}

.pl-5 {
  padding-left: 5px;
}

.pb-5 {
  padding-right: 5px;
}

.padding-6 {
  padding: 6rem;
}

.pt-6 {
  padding-top: 6rem;
}

.pb-6 {
  padding-top: 6px;
}

.pl-6 {
  padding-left: 6px;
}

.pb-6 {
  padding-right: 6px;
}

.padding-7 {
  padding: 7rem;
}

.pt-7 {
  padding-top: 7rem;
}

.pb-7 {
  padding-top: 7px;
}

.pl-7 {
  padding-left: 7px;
}

.pb-7 {
  padding-right: 7px;
}

.padding-8 {
  padding: 8rem;
}

.pt-8 {
  padding-top: 8rem;
}

.pb-8 {
  padding-top: 8px;
}

.pl-8 {
  padding-left: 8px;
}

.pb-8 {
  padding-right: 8px;
}

.padding-9 {
  padding: 9rem;
}

.pt-9 {
  padding-top: 9rem;
}

.pb-9 {
  padding-top: 9px;
}

.pl-9 {
  padding-left: 9px;
}

.pb-9 {
  padding-right: 9px;
}

.padding-10 {
  padding: 10rem;
}

.pt-10 {
  padding-top: 10rem;
}

.pb-10 {
  padding-top: 10px;
}

.pl-10 {
  padding-left: 10px;
}

.pb-10 {
  padding-right: 10px;
}

.align-column {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.borderBottom {
  border-bottom: 1px solid #a8bac9;
}

/**
* index.scss will be the main file
* where rest of the files will be imported
* and this index.scss will imported
* in the main Style file
*/
/**
* A Typical Style file
*/
.max_homepage_wrapper {
  background-color: #f5f5f5;
}
.swiper {
  height: 355px;
}

.max__right-home-container .max__right-card {
  height: 100%;
  width: 100%;
  border-radius: 1.25rem;
  background-color: #fff8dd;
  padding: 1.25rem 1.25rem 5px 1.25rem;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  margin: 1.875rem 0 0 0;
}
.max__right-home-container .max__right-card .max-home__badge-container {
  width: 100%;
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/c_scale,h_166,q_auto:eco,w_360/v1665027832/Group_2x_cem3ax.png');
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 20px 20px;
}
@media (max-width: 998px) {
  .max__right-home-container .max__right-card .max-home__badge-container {
    padding: 60px 20px;
  }
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  h6 {
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 12px;
  color: rgba(255, 255, 255, 0.86);
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  h4 {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 16px;
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  h4
  strong {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.29px;
  line-height: 16px;
  color: #f1ba2d;
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  hr {
  height: 1px;
  width: 243px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  p {
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.22px;
  line-height: 16px;
}

.max__home-quote-container {
  padding: 1.25rem;
  display: flex;
}

.image_own {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 7px;
}

.image_own_learner {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

.image_opponent_learner {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

.image_opponent {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 7px;
}

.did_u_know_slider--wrapper .mySwiper {
  height: 230px;
}

.did_u_know_slider--wrapper .slick-slider .slick-dots {
  width: 10px;
  height: 10px;
  display: inline;
  position: static !important;
}
.did_u_know_slider--wrapper .slick-slider .slick-dots li button {
  width: 100%;
  height: 100%;
}

.cwr_login {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cwr_login h1 {
  text-align: center;
  width: 100%;
  font-size: 70px;
  line-height: 1.1;
  letter-spacing: -0.06em;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 30px;
}
.cwr_login button {
  padding: 0 3.5rem;
  height: 2.81rem;
  line-height: 2.8rem;
  border-radius: 7px;
  background-color: #0070f3;
  box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
}

.login_bg {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  background-repeat: no-repeat;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  float: left;
  background-size: cover;
}

.formdiv {
  width: 40%;
  margin: auto;
  text-align: center;
  background-color: #fff;
  border: 1px solid #979797;
  border-radius: 20px;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  margin-top: 7%;
  margin-bottom: 6%;
}

.welcome {
  color: #9d9d9d;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 18px;
}

.fordiv-wrapper {
  padding: 40px;
}

.logintext {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212121;
  font-family: Roboto;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 26px;
  height: 30px;
}

.login__logo {
  height: 29px;
  margin-left: 8px;
  margin-top: 6px;
}

.login_btn {
  padding-left: 17px;
  padding-right: 10px;
  margin-top: 38px;
}

.input_div input[type='email'],
.input_div input[type='password'],
.input_div input[type='text'] {
  /* background-color: transparent !important; */
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
}

.divider__height {
  margin-top: 36px;
}

.login_name {
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid #d9d9d9;
  outline: none;
  width: 100%;
  padding-bottom: 10px;
  background-color: transparent !important;
  background: none;
}
.login_name::after {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}
.login_name::before {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}

.login_password::before {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}

.login_password::after {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}

.input_div {
  padding-top: 45px;
}

.custom_div {
  padding-top: 40px;
}

.custom_div1 {
  padding-top: 70px;
}

.login_password {
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid #d9d9d9;
  outline: none;
  width: 100%;
  padding-bottom: 10px;
  background-color: transparent !important;
  background: none;
}

.login_button {
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  width: 100%;
  border: none;
  padding: 15px;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  outline: none !important;
}

.forgot_password {
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  padding-top: 20px;
}
.forgot_password .forgot_password-link {
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
}
.forgot_password:hover {
  color: #0e3a5e;
}

.login_with {
  display: flex;
  flex-direction: row;
}

.login_with:before {
  content: '';
  flex: 1 1;
  border: 1px solid #d9d9d9;
  opacity: 0.48;
  margin: auto;
  position: relative;
  left: -10px;
}

.login_with:after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid;
  margin: auto;
  border: 1px solid #d9d9d9;
  opacity: 0.48;
  position: relative;
  left: 10px;
}

.social_innerdiv {
  border-radius: 4px;
  background-color: #f0f6f7;
  padding: 15px;
}

.google_text {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  padding-left: 10px;
}

.verification {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  padding-top: 10px;
}

.css-1tcs2i1-MuiInputBase-root-MuiInput-root:before {
  border-bottom: 0px !important;
}

.css-1tcs2i1-MuiInputBase-root-MuiInput-root:after {
  border-bottom: 0px !important;
}

.Log_err {
  font-size: 12px;
  float: left;
  color: red;
}

.card_background {
  width: 40%;
  height: 500px;
  margin: auto;
  text-align: center;
  background-color: #fff;
  border: 1px solid #979797;
  border-radius: 20px;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  margin-top: 13%;
  margin-bottom: 8%;
}

.change_password_bg {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  background-repeat: no-repeat;
  height: 100vh;
  width: 100%;
  height: auto;
  float: left;
  background-size: cover;
}

.ml-login {
  border: 1px solid #979797;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  float: left;
  margin-top: 10%;
  width: 65%;
  justify-content: center;
  align-items: center;
}
.ml-login__title {
  color: #212121;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 32px;
  text-align: center;
}
.ml-login__sub-title {
  color: #212121;
  font-family: Roboto;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 26px;
}
.ml-login__body {
  flex: none;
  width: 80%;
}
.ml-login__btn-blk .react-ripples {
  width: 100%;
}
.ml-login__btn {
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  color: #ffffff;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
.ml-login__frgt-pwd-txt {
  color: #0e3a5e;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}
.ml-login__input-blk .form-control {
  padding-left: 0.5rem;
  margin-left: 3rem;
  width: 89%;
  border: none;
  border-bottom: 1.5px solid #d9d9d9;
  border-radius: 0;
  font-family: Roboto;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 20px;
}
.ml-login__input-blk .form-control:focus {
  box-shadow: none;
}
.ml-login__pwd-eye {
  position: absolute;
  top: 1px;
  right: 0 !important;
  z-index: 2;
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
}

.login_background {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  height: 100vh;
  width: 100%;
  background-size: cover;
  float: left;
}

.question_bg {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  width: 100%;
  height: 100vh;
  background-size: cover;
  float: left;
}

.reset_header {
  text-align: center;
  color: #212121;
  font-family: Roboto;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 26px;
}

.card__bg {
  width: 40%;
  height: 550px;
  margin: auto;
  text-align: center;
  background-color: #fff;
  border: 1px solid #979797;
  border-radius: 20px;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  margin-top: 8%;
  margin-bottom: 8%;
}

.reset_button {
  padding-left: 12px;
  padding-right: 12px;
}

/**
* Global mixin file
*/
/**
*
* Testing
*
**/
/**
* index.scss will be the main file
* where rest of the files will be imported
* and this index.scss will imported
* in the main Style file
*/
/**
* A Typical Style file
*/
.max_homepage_wrapper {
  background-color: #f5f5f5;
}
.swiper {
  height: 355px;
}

.max__right-home-container .max__right-card {
  height: 100%;
  width: 100%;
  border-radius: 1.25rem;
  background-color: #fff8dd;
  padding: 1.25rem 1.25rem 5px 1.25rem;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  margin: 1.875rem 0 0 0;
}
.max__right-home-container .max__right-card .max-home__badge-container {
  width: 100%;
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/c_scale,h_166,q_auto:eco,w_360/v1665027832/Group_2x_cem3ax.png');
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 20px 20px;
}
@media (max-width: 998px) {
  .max__right-home-container .max__right-card .max-home__badge-container {
    padding: 60px 20px;
  }
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  h6 {
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 12px;
  color: rgba(255, 255, 255, 0.86);
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  h4 {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 16px;
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  h4
  strong {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.29px;
  line-height: 16px;
  color: #f1ba2d;
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  hr {
  height: 1px;
  width: 243px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.max__right-home-container
  .max__right-card
  .max-home__badge-container
  .badge-content-area
  p {
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.22px;
  line-height: 16px;
}

.max__home-quote-container {
  padding: 1.25rem;
  display: flex;
}

.image_own {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 7px;
}

.image_own_learner {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

.image_opponent_learner {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

.image_opponent {
  height: 50px;
  width: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 7px;
}

.did_u_know_slider--wrapper .mySwiper {
  height: 230px;
}

.did_u_know_slider--wrapper .slick-slider .slick-dots {
  width: 10px;
  height: 10px;
  display: inline;
  position: static !important;
}
.did_u_know_slider--wrapper .slick-slider .slick-dots li button {
  width: 100%;
  height: 100%;
}

.cwr_login {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cwr_login h1 {
  text-align: center;
  width: 100%;
  font-size: 70px;
  line-height: 1.1;
  letter-spacing: -0.06em;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 30px;
}
.cwr_login button {
  padding: 0 3.5rem;
  height: 2.81rem;
  line-height: 2.8rem;
  border-radius: 7px;
  background-color: #0070f3;
  box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
}

.login_bg {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  background-repeat: no-repeat;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  float: left;
  background-size: cover;
}

.formdiv {
  width: 40%;
  margin: auto;
  text-align: center;
  background-color: #fff;
  border: 1px solid #979797;
  border-radius: 20px;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  margin-top: 7%;
  margin-bottom: 6%;
}

.welcome {
  color: #9d9d9d;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 18px;
}

.fordiv-wrapper {
  padding: 40px;
}

.logintext {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212121;
  font-family: Roboto;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 26px;
  height: 30px;
}

.login__logo {
  height: 29px;
  margin-left: 8px;
  margin-top: 6px;
}

.login_btn {
  padding-left: 17px;
  padding-right: 10px;
  margin-top: 38px;
}

.input_div input[type='email'],
.input_div input[type='password'],
.input_div input[type='text'] {
  /* background-color: transparent !important; */
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
}

.divider__height {
  margin-top: 36px;
}

.login_name {
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid #d9d9d9;
  outline: none;
  width: 100%;
  padding-bottom: 10px;
  background-color: transparent !important;
  background: none;
}
.login_name::after {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}
.login_name::before {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}

.login_password::before {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}

.login_password::after {
  border-bottom: 0px solid rgba(0, 0, 0, 0.87) !important;
}

.input_div {
  padding-top: 45px;
}

.custom_div {
  padding-top: 40px;
}

.custom_div1 {
  padding-top: 70px;
}

.login_password {
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid #d9d9d9;
  outline: none;
  width: 100%;
  padding-bottom: 10px;
  background-color: transparent !important;
  background: none;
}

.login_button {
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  width: 100%;
  border: none;
  padding: 15px;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  outline: none !important;
}

.forgot_password {
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  padding-top: 20px;
}
.forgot_password .forgot_password-link {
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
}
.forgot_password:hover {
  color: #0e3a5e;
}

.login_with {
  display: flex;
  flex-direction: row;
}

.login_with:before {
  content: '';
  flex: 1 1;
  border: 1px solid #d9d9d9;
  opacity: 0.48;
  margin: auto;
  position: relative;
  left: -10px;
}

.login_with:after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid;
  margin: auto;
  border: 1px solid #d9d9d9;
  opacity: 0.48;
  position: relative;
  left: 10px;
}

.social_innerdiv {
  border-radius: 4px;
  background-color: #f0f6f7;
  padding: 15px;
}

.google_text {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  padding-left: 10px;
}

.verification {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  padding-top: 10px;
}

.css-1tcs2i1-MuiInputBase-root-MuiInput-root:before {
  border-bottom: 0px !important;
}

.css-1tcs2i1-MuiInputBase-root-MuiInput-root:after {
  border-bottom: 0px !important;
}

.Log_err {
  font-size: 12px;
  float: left;
  color: red;
}

.card_background {
  width: 40%;
  height: 500px;
  margin: auto;
  text-align: center;
  background-color: #fff;
  border: 1px solid #979797;
  border-radius: 20px;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  margin-top: 13%;
  margin-bottom: 8%;
}

.change_password_bg {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  background-repeat: no-repeat;
  height: 100vh;
  width: 100%;
  height: auto;
  float: left;
  background-size: cover;
}

.ml-login {
  border: 1px solid #979797;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  float: left;
  margin-top: 10%;
  width: 65%;
  justify-content: center;
  align-items: center;
}
.ml-login__title {
  color: #212121;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 32px;
  text-align: center;
}
.ml-login__sub-title {
  color: #212121;
  font-family: Roboto;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 26px;
}
.ml-login__body {
  flex: none;
  width: 80%;
}
.ml-login__btn-blk .react-ripples {
  width: 100%;
}
.ml-login__btn {
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  color: #ffffff;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
.ml-login__frgt-pwd-txt {
  color: #0e3a5e;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}
.ml-login__input-blk .form-control {
  padding-left: 0.5rem;
  margin-left: 3rem;
  width: 89%;
  border: none;
  border-bottom: 1.5px solid #d9d9d9;
  border-radius: 0;
  font-family: Roboto;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 20px;
}
.ml-login__input-blk .form-control:focus {
  box-shadow: none;
}
.ml-login__pwd-eye {
  position: absolute;
  top: 1px;
  right: 0 !important;
  z-index: 2;
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
}

.login_background {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  height: 100vh;
  width: 100%;
  background-size: cover;
  float: left;
}

.question_bg {
  background-image: url(https://res.cloudinary.com/dysdy7hjr/image/upload/v1687959112/background_image_x91kyt.png);
  width: 100%;
  height: 100vh;
  background-size: cover;
  float: left;
}

.reset_header {
  text-align: center;
  color: #212121;
  font-family: Roboto;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 0.47px;
  line-height: 26px;
}

.card__bg {
  width: 40%;
  height: 550px;
  margin: auto;
  text-align: center;
  background-color: #fff;
  border: 1px solid #979797;
  border-radius: 20px;
  box-shadow: 0 20px 32px 0 rgba(0, 0, 0, 0.24);
  margin-top: 8%;
  margin-bottom: 8%;
}

.reset_button {
  padding-left: 12px;
  padding-right: 12px;
}

body,
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
  color: #777777;
  font-style: normal;
}

html,
body {
  min-height: 100% !important;
  position: relative;
}
html a,
body a {
  text-decoration: none;
}

#root {
  background-color: #f5f5f5;
}
@media (min-width: 1025px) {
  #root {
    height: 100%;
    min-height: 100vh;
  }
}

.margin-t {
  margin: 1.875rem 0 0 0;
}

.padd-20 {
  padding: 1.25rem;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a4a4a4;
  border-radius: 20px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a4a4a4;
}

header .max__navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 6.25rem;
  padding-left: 6.25rem;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  height: 80px;
}
header .max__navbar .max__menunav-list {
  display: flex;
  list-style-type: none;
  color: #777777;
  align-items: center;
}
header .max__navbar .max__menunav-list li {
  margin: 0 5px;
}
header .max__navbar .max__menunav-list svg {
  fill:#777777;
}
header .max__navbar .max__menunav-list a {
  border: none;
  border-radius: 20px;
  padding: 0.625rem;
  min-height: 2.5rem;
  min-width: 6.26rem;
  color: #777777;
  font-family: Roboto;
  font-size: 0.875rem;
  letter-spacing: 0;
  text-align: center;
  display: inline-block;
}
header .max__navbar .max__menunav-list .active {
  background-color: #fef4ec;
  color: #ff6633;
}
header
  .max__navbar
  .max__menunav-list
  .max__nav-search
  .max__nav-search-container
  button {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 0.625rem;
  background-color: #f5f5f5;
  border: none;
}
header
  .max__navbar
  .max__menunav-list
  .max__notification
  .max__nav-notification-container
  button {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 0.625rem;
  background-color: #ffeca2;
  border: none;
}
header .max__navbar .max__menunav-list .max__nav-user .max__nav-user-container {
  position: relative;
}
header
  .max__navbar
  .max__menunav-list
  .max__nav-user
  .max__nav-user-container
  button {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 0.625rem;
  background-color: #f5f5f5;
  border: none;
}
header .max__navbar .max__menunav-list .max__nav-search-container a {
  padding: 0;
}
header .question_navbar {
  padding-right: 5.25rem;
  padding-left: 5.25rem;
}

.nav-loading {
  width: 110px;
  height: 100%;
  background-color: #bab8b0;
  border-radius: 24px;
  animation: skeletonAnimation 1s infinite;
}

.nav-icon {
  margin-right: 6px;
  align-items: center;
  margin-bottom: 15px;
}

.home__navbar {
  position: sticky;
  top: 0;
  z-index: 50;
}

header .dropDownProfile {
  position: absolute;
  padding: 30px 26px;
  top: 0px;
  right: 6%;
  max-width: 210px;
  border-radius: 15px;
  z-index: 1;
  background-color: #ffffff;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.07);
}
header .dropDownProfile .dropdown__list-wrapper {
  padding: 0px;
  margin-bottom: 0px;
}
header .dropDownProfile .dropdown__list {
  display: flex;
  align-items: center;
  list-style: none;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  margin-top: 26px;
  cursor: pointer;
}
header .dropDownProfile .dropdown__list:first-child {
  margin-top: 0px;
}
header .dropDownProfile .dropdown__list .image-logo {
  margin-right: 8px;
}
header .dropDownProfile::before {
  content: ' ';
  position: absolute;
  top: -0.4rem;
  right: 1rem;
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  transform: rotate(45deg);
}

.dropblur {
  position: absolute;
  width: calc(100vw - 5px);
  background-color: transparent;
  height: 100vh;
  z-index: 100;
}

.user_profile-pic {
  width: 40px;
  height: 40px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 8px;
}

.search__wrapper {
  position: relative;
}
.search__wrapper .search__icon {
  position: absolute;
  top: 7px;
  left: 25px;
  height: 100%;
}
.search__wrapper .search__close {
  position: absolute;
  top: 7px;
  right: 11px;
  height: 100%;
}

.search__backdrop {
  position: absolute;
  width: calc(100vw - 5px);
  background-color: rgba(0, 0, 0, 0.4);
  height: 100vh;
  z-index: 100;
}
.search__backdrop .search__dropdown {
  position: absolute;
  overflow-y: auto;
  top: -5px;
  right: 215px;
  width: 500px;
  background-color: #ffffff;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.07);
  max-height: 400px;
  z-index: 9999;
  padding: 40px 25px 22px 25px;
  border-radius: 10px;
}
.search__backdrop .search__dropdown::before {
  content: ' ';
  position: absolute;
  top: -0.4rem;
  right: 1rem;
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  transform: rotate(135deg);
}
.search__backdrop .search__dropdown .search__header {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 24px;
}
.search__backdrop .search__dropdown .search__content {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  width: 100%;
  background-color: transparent;
  border: none;
}
.search__backdrop .search__dropdown .search__content:hover {
  background-color: #f5f5f5;
  border-radius: 10px;
}
.search__backdrop .search__dropdown .search__content .search__image {
  height: 56px;
  width: 56px;
  border-radius: 2px;
}
.search__backdrop .search__dropdown .search__content .search__image img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.search__backdrop .search__dropdown .search__content .search__text {
  text-align: left;
  margin-left: 25px;
}
.search__backdrop .search__dropdown .search__content .search__text h4 {
  color: #212121;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 14px;
  margin-bottom: 8px;
  max-width: 330px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search__backdrop .search__dropdown .search__content .search__text p {
  color: #0e3a5e;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin-bottom: 0px;
}

.search_box {
  background-color: #f5f5f5;
  width: 500px;
  height: 40px;
  border: none;
  border-radius: 8px;
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
  padding-left: 55px;
  padding-right: 35px;
}
.search_box::-moz-placeholder {
  font-weight: 500;
  color: #817f7f;
  font-family: 'Poppins';
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
}
.search_box::placeholder {
  font-weight: 500;
  color: #817f7f;
  font-family: 'Poppins';
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
}
.search_box:focus {
  outline: none;
}

.expand__searchbar {
  width: 500px;
  animation: expand 0.9s ease-in-out;
}

@keyframes expand {
  0% {
    width: 0px;
  }
  100% {
    width: 500px;
    opacity: 1;
  }
}
@keyframes skeletonAnimation {
  0% {
    opacity: 0.2;
    transform: translateY(0);
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.2;
    transform: translateY(0);
  }
}
.max_user-wrapper {
  margin: 1.875rem 0 0 0;
}
.max_user-wrapper .max_user_card {
  height: 139px;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 1.25rem;
}
@media (max-width: 992px) {
  .max_user-wrapper .max_user_card {
    width: 100%;
  }
}
.max_user-wrapper .max_user_card .max__user-container {
  position: relative;
  background-color: #ecfeee;
  height: 100%;
  position: relative;
  padding: 1.25rem;
  border-radius: 14px;
  overflow: hidden;
}
.max_user-wrapper .max_user_card .max__user-container .max__user-theme-ovel {
  position: absolute;
  border-radius: 50px;
  height: 71px;
  width: 71px;
  background-color: #bdffc5;
  opacity: 0.5;
  top: -22px;
  right: -22px;
}
.max_user-wrapper .max_user_card .max__user-container h4 {
  color: #9d9d9d;
  font-family: Roboto;
  font-size: 1.375rem;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.375rem;
}
.max_user-wrapper .max_user_card .max__user-container .user_name {
  margin-right: 10px;
  display: inline-flex !important;
  text-transform: capitalize;
  color: #212121;
  font-family: Roboto;
  font-size: 1.625rem;
  font-weight: 900;
  letter-spacing: 0.029rem;
  line-height: 1.4;
}

.wax__home-challenges-wrapper {
  margin: 3.125rem 0 0 0;
  min-height: 360px;
  width: 100%;
}
@media (max-width: 800px) {
  .wax__home-challenges-wrapper {
    width: 100%;
  }
}
.wax__home-challenges-wrapper .wax__home-challenges-slider-wrapper {
  width: 100%;
  margin-top: 1.25rem;
}
@media (max-width: 800px) {
  .wax__home-challenges-wrapper .wax__home-challenges-slider-wrapper {
    width: 100%;
  }
}
.wax__home-challenges-wrapper .wax__home-challenges-head h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
}
.wax__home-challenges-wrapper .wax__home-challenges-head button {
  background-color: #f5f5f5;
  border: none;
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}

.swiper-pagination-bullet {
  height: 5px;
  width: 13px;
  border-radius: 3px;
  background-color: #c1dbda;
  opacity: 1;
}

.swiper-pagination-bullet-active {
  background-color: #167f7d;
  height: 5px;
  width: 30px;
  border-radius: 3px;
}

.image__container {
  width: 100%;
  height: 200px;
}

.max-home_challenges__card-wrapper {
  background: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
}
.max-home_challenges__card-wrapper .max-home_challenges__card-container {
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/q_auto:eco/v1664801059/flash_i9thnf.png');
  background-repeat: no-repeat;
  background-size: cover;
  width: 100% !important;
  height: 100% !important;
  border-radius: 8px 8px 0px 0px;
}
.max-home_challenges__card-wrapper .left_challenges-container {
  position: relative;
  height: 195px;
  width: 227.55px;
  display: 'flex';
  justify-content: 'center';
  flex-direction: 'column';
}
.max-home_challenges__card-wrapper
  .left_challenges-container
  .left_challenge_icon-container {
  position: absolute;
  top: 30%;
  bottom: -50%;
  right: 32%;
  height: 4.375rem;
  width: 4.383rem;
  border-radius: 0.972rem;
  background-color: 'transprent';
  display: flex;
  justify-content: center;
  align-items: center;
}
.max-home_challenges__card-wrapper .left_challenges-container p {
  display: flex;
  justify-content: center;
  height: 150%;
  align-items: center;
  color: #ffffff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max-home_challenges__card-wrapper .remain_members {
  position: relative;
  bottom: 112px;
}
.max-home_challenges__card-wrapper .right_challenges-container {
  height: 185px;
  width: 228px;
  transform: scaleX(-1) scaleY(-1);
}
.max-home_challenges__card-wrapper .right_challenges-container p {
  display: flex;
  justify-content: center;
  height: 40%;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  transform: rotate(180deg);
}
.max-home_challenges__card-wrapper
  .right_challenges-container
  .right_challenge_icon-container {
  position: absolute;
  top: 30%;
  bottom: -50%;
  right: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4.375rem;
  width: 4.383rem;
  border-radius: 0.972rem;
  background-color: 'transprent';
  transform: rotate(180deg);
}
.max-home_challenges__card-wrapper .max-challenges-content-container {
  padding: 1.25rem 1.25rem 1.875rem 1.25rem;
}
.max-home_challenges__card-wrapper
  .max-challenges-content-container
  .time-details
  h3 {
  margin: 1.125rem 0 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 16px;
}
.max-home_challenges__card-wrapper
  .max-challenges-content-container
  .time-details
  .time-details-text
  h6 {
  color: #777777;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max-home_challenges__card-wrapper
  .max-challenges-content-container
  .time-details
  .time-details-text
  h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
}
.max-home_challenges__card-wrapper
  .max-challenges-content-container
  .time-details
  .time-details-text
  h5
  strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
}
.max-home_challenges__card-wrapper
  .max-challenges-content-container
  .time-details
  .time-details-text
  h5
  small {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
}

.max-home__quote-container {
  display: flex;
  align-items: center;
}

.max-home__quote-container {
  margin-top: 20px;
  height: 166px;
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
}
.max-home__quote-container .max-home__quote-content p {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.22px;
  line-height: 18px;
  width: 207px;
  padding-left: 10px;
  align-items: center;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}

.max-card_wrapper {
  border-radius: 10px;
}

.banner_image {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
.banner_image_content {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

.wax__home-quest-wrapper {
  margin: 3.125rem 0 0 0;
  padding: 1.875rem 1.25rem 1.875rem 1.25rem;
  min-height: 360px;
  height: 313px;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
}
.wax__home-quest-wrapper
  .wax__home-quest-container
  .wax__home-quest-slider-wrapper {
  margin-top: 24px;
}
.wax__home-quest-wrapper .wax__home-quest-container div h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
}
.wax__home-quest-wrapper .wax__home-quest-container div h6 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: #0e3a5e;
}

.max__home__empty {
  margin: 3.125rem 0 0 0;
  padding: 0px;
  min-height: 360px;
  height: 313px;
  width: 100%;
  border-radius: 20px;
  background-color: transparent;
}
.max__home__empty .wax__home-quest-container .wax__home-quest-slider-wrapper {
  margin-top: 24px;
}
.max__home__empty .wax__home-quest-container div h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
}
.max__home__empty .wax__home-quest-container div h6 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: #0e3a5e;
}

.mySwiperQuest {
  height: 260px !important;
}

.max-home__quest-wrapper {
  height: '';
  width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  padding: 28px 20px 28px 20px;
  z-index: 1;
  position: relative;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 18px;
  animation: cardfade 0.5s ease-in-out;
}
.max-home__quest-wrapper .wax__home-challenges-slider-wrapper {
  margin-top: 24px;
}
.max-home__quest-wrapper .max-home__questcard-container .quest-time-details h3 {
  margin-top: 20px;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  text-align: left;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  h6 {
  color: #5d5c5c;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  .completed_text {
  color: #212121 !important;
  font-family: Roboto;
  font-size: 12px !important;
  font-style: italic !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  line-height: 12px !important;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  .completed_text
  .points__earned {
  margin-top: 5px;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  .completed_text
  .points__earned-image {
  width: 14px;
  height: 14px;
  margin-bottom: 4px;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  .completed_text
  .challenge__dayscount {
  color: #212121 !important;
  font-family: Roboto;
  font-weight: 900;
  font-size: 14px !important;
  font-style: italic !important;
  letter-spacing: 0 !important;
  line-height: 14px !important;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  .completed_text
  strong {
  color: #212121 !important;
  font-family: Roboto;
  font-size: 14px !important;
  font-style: italic !important;
  letter-spacing: 0 !important;
  line-height: 14px !important;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  .completed_text
  .squad__points {
  color: #212121 !important;
  font-family: Roboto;
  font-size: 14px !important;
  font-style: italic !important;
  letter-spacing: 0 !important;
  line-height: 14px !important;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  h5
  strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-time-details-text
  h5
  small {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-home-content-container {
  margin-top: 24px;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-home-content-container
  .quest-home__progress {
  display: flex;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-home-content-container
  .quest-home__progress
  p {
  height: 24px;
  width: 88px;
  border-radius: 12px;
  background-color: #fff8dd;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  margin-left: 9px;
  padding-left: 12px;
}
.max-home__quest-wrapper
  .max-home__questcard-container
  .quest-time-details
  .quest-home-content-container
  .quest-home__progress
  .quest {
  height: 24px;
  width: 68px;
  border-radius: 12px;
  background-color: #9effd4;
}
.max-home__quest-wrapper .quest-time-details-text h6 {
  color: #5d5c5c;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}

@keyframes cardfade {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ml-cert-chip,
.ml-quest-chip {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
}

.ml-cert-chip {
  background-color: #9ed5ff;
}

.ml-quest-chip {
  background-color: #9effd4;
}

.backdrop1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.91);
  opacity: 0.7;
}

.modal1 {
  position: fixed;
  /* top: 20vh; */
  right: 0;
  height: 100vh;
  width: 470px;
  background-color: white;
  border-radius: 14px 0 0 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  z-index: 30;
  animation: slide-down 300ms ease-out forwards;
  z-index: 999999;
}

@keyframes slide-down {
  from {
    opacity: 0;
    transform: translateX(20%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.max__home-challenges-sidebar .sidebar-head {
  padding: 0 1.875rem;
  margin: 3.125rem 0 0 0;
  display: flex;
  justify-content: space-between;
}
.max__home-challenges-sidebar .sidebar-head h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
}
.max__home-challenges-sidebar .sidebar-head svg {
  cursor: pointer;
}
.max__home-challenges-sidebar hr {
  margin: 1.875rem 0 0 0;
  height: 1px;
  border: 1px solid #979797;
  opacity: 0.45;
}
.max__home-challenges-sidebar .sidebar-content {
  padding: 0 1.875rem;
  margin: 2.625rem 0 0 0;
  overflow: scroll;
  height: 100vh;
}
.max__home-challenges-sidebar .sidebar-content h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 17px;
}
.max__home-challenges-sidebar .sidebar-content h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 17px;
}
.max__home-challenges-sidebar .sidebar-content .row {
  margin: 1.75rem 0 0 0;
}

.max__footer-wrapper {
  z-index: 9999999;
  left: 0;
  bottom: 0;
  margin: 3.185rem 0 0 0;
  background: #212121;
  height: 70px;
  color: #ffffff;
  width: 100%;
  padding-right: 6.25rem;
  padding-left: 6.25rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.max__footer-wrapper .max__footer-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  color: #ffffff;
}
.max__footer-wrapper .max__footer-container p {
  color: #ffffff;
  margin: 0;
}
.max__footer-wrapper .max__footer-container p .footer__link {
  color: #ffffff;
  margin-right: 10px;
}
.max__footer-wrapper .max__footer-container p .footer__link:hover {
  color: #ffffff;
}
.max__footer-wrapper .max__footer-container p .footer__link:last-child {
  margin-left: 10px;
}

.spacing__height {
  min-height: calc(100vh - 220px);
}

.profile_spacing {
  min-height: calc(100vh - 251px);
}

.help_spacing {
  min-height: calc(100vh - 200px);
}

.max__learn-wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;
}
.max__learn-wrapper h3 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
}
.max__learn-wrapper h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.max__learn-wrapper h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.max__learn-wrapper h6 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin: 0;
}
.max__learn-wrapper h6 strong {
  font-weight: 700;
}
.max__learn-wrapper > .container {
  padding-bottom: 100px;
}
.max__learn-wrapper > .infinte_scroll-wrapper {
  padding-bottom: 100px;
}

.max__learn-achieve-wrapper {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
}
.max__learn-achieve-wrapper .achieve-wrapper {
  overflow: hidden;
  position: relative;
  background-color: #ecfeee;
  border-radius: 20px;
  display: flex;
  padding: 2.25rem 1.563rem 2.25rem 1.563rem;
}
.max__learn-achieve-wrapper .achieve-wrapper h1 {
  margin-bottom: 0px;
  margin-top: 14px;
  color: #167f7d;
  font-family: Roboto;
  font-size: 34px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 34px;
}
.max__learn-achieve-wrapper .achieve-wrapper h1 small {
  color: #6b6b6b;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 13px;
}
.max__learn-achieve-wrapper .achieve-wrapper .half-circle {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 83px;
  height: 83px;
  border-radius: 50%;
  background-color: rgba(189, 255, 197, 0.5);
}

.max__learn-achieve-wrapper_no_points h2 {
  font-size: 18px;
}
.max__learn-achieve-wrapper_no_points .achieve-wrapper {
  background-color: #7cd1d0;
}
.max__learn-achieve-wrapper_no_points .achieve-wrapper .no_points_desc {
  font-family: Roboto;
  letter-spacing: 0.22px;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 10px;
}
.max__learn-achieve-wrapper_no_points .achieve-wrapper .half-circle {
  display: none;
}

.max-learn__topics-wrapper {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 1.875rem 1.25rem 1.875rem 1.25rem;
}
.max-learn__topics-wrapper button {
  background-color: #ffffff;
  border: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: #0e3a5e;
  cursor: pointer;
}
.max-learn__topics-wrapper .mySwiperTopics {
  height: 100%;
}
.max-learn__topics-wrapper .silder-topics-container {
  margin: 1.25rem 0px 0 0px;
}
.max-learn__topics-wrapper .silder-topics-container .row {
  display: flex;
  align-items: center;
}
.max-learn__topics-wrapper .silder-topics-container .icon_column {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 30px;
  border-radius: 50%;
  background-color: #f1f1f1;
  height: 30px;
}
.max-learn__topics-wrapper .silder-topics-container .icon_column:hover {
  cursor: pointer;
}
.max-learn__topics-wrapper .silder-topics-container .swiper-button-disabled {
  color: rgb(154, 153, 153);
}
.max-learn__topics-wrapper
  .silder-topics-container
  .swiper-button-disabled:hover {
  cursor: context-menu;
}
.max-learn__topics-wrapper .prev {
  color: black;
  font-weight: bold;
}
.max-learn__topics-wrapper .next {
  color: black;
  font-weight: bold;
}
.max-learn__topics-wrapper .hot-topic-prev {
  font-size: 21px;
  font-weight: 400;
}
.max-learn__topics-wrapper .hot-topic-next {
  font-size: 21px;
  font-weight: 400;
}
.max-learn__topics-wrapper .max-learn__topics-card {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  background-color: #f8f8f8;
  padding: 1.125rem 0.875rem 1.125rem 0.875rem;
}
.max-learn__topics-wrapper .max-learn__topics-card h5 {
  height: 40px;
  overflow: hidden;
}
.max-learn__topics-wrapper .max-learn__topics-card .topic-content {
  height: auto;
  width: 100%;
  border-radius: 6px;
  background-color: #ffffff;
}
.max-learn__topics-wrapper .max-learn__topics-card .topic-content p {
  padding: 7px 12px;
  margin: 0;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
}
.max-learn__topics-wrapper .max-learn__topics-card .topic-content p small {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}

/**
* Global mixin file
*/
/**
*
* Testing
*
**/
.max-learn__learning-wrapper {
  margin: 3.125rem 0 0 0;
}
.max-learn__learning-wrapper__header {
  padding: 0 20px;
}
.max-learn__learning-wrapper button {
  background-color: #f5f5f5;
  border: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: #0e3a5e;
  cursor: pointer;
}
.max-learn__learning-wrapper .learning-card-row {
  margin: 1.25rem 0 0 0;
}

.learn-category-wrapper {
  padding: 0 10px;
}

.max-learn__learning-card {
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 34px 20px;
}
.max-learn__learning-card .content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding-left: 20px;
}
.max-learn__learning-card .content p {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin: 0;
}
.max-learn__learning-card .content p strong {
  font-weight: 900;
  color: #212121;
}
.max-learn__learning-card .content-color {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
@media (min-width: 600px) and (max-width: 1024px) {
  .max-learn__learning-card .content-color {
    padding-left: 15px;
  }
}
.max-learn__learning-card .content-color p {
  color: #389f9e;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin: 0;
}
.max-learn__learning-card .content-color p strong {
  font-weight: 900;
  color: #389f9e;
}
.max-learn__learning-card .CircularProgressbar {
  height: 50px;
  width: 50px;
}

.mySwiperCatergory {
  height: 100%;
  width: 100%;
}

.max-learn__category-wrapper {
  margin: 4.688rem 0 0 0;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 30px 20px;
}
.max-learn__category-wrapper button {
  background-color: #ffffff;
  border: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: #0e3a5e;
  cursor: pointer;
}
.max-learn__category-wrapper .category-container {
  margin: 1.438rem 0 0 0;
}
.max-learn__category-wrapper .category-container .swiper-pagination {
  position: static;
}

.progressbar__learn-text {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: none;
  letter-spacing: 0;
  line-height: 12px;
  margin-top: 20px !important;
}

.progressbar__learn-text-color {
  color: #389f9e;
  font-family: Roboto;
  font-size: 12px;
  font-weight: none;
  letter-spacing: 0;
  line-height: 12px;
  margin-top: 20px !important;
}

.max-learn__catergory-card {
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  background-color: 0;
  padding: 20px 20px;
}
.max-learn__catergory-card__category_subject {
  color: #707070;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
}
.max-learn__catergory-card .detail-header-title {
  font-size: 20px;
  font-weight: bold;
  position: relative;
  z-index: 9999999;
}
.max-learn__catergory-card .card_level_wrapper {
  display: inline-block;
  border-radius: 17px;
  background: linear-gradient(
    153.63deg,
    #fbdc6d 0%,
    #fcc765 45.92%,
    #fca157 100%
  );
  padding: 7px 15px;
  margin-top: 20px;
}
.max-learn__catergory-card .card_level_wrapper .card_level {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 0;
  letter-spacing: 0.22px;
  line-height: 12px;
}
.max-learn__catergory-card .card_level_wrapper .card_level strong {
  font-weight: 700px;
  color: #212121;
}
.max-learn__catergory-card .card_quiz_button {
  cursor: pointer;
  border-radius: 10px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  padding: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.max-learn__catergory-card .card_quiz_button div {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}
.max-learn__catergory-card .card_quiz_button button {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  border: none;
  background: none;
}
.max-learn__catergory-card .quarter-circle {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
}

.category_detail {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 0;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 20px;
  line-break: anywhere;
}

.category_row {
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 20px;
}
.category_row__heading {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  margin-top: 26px;
  margin-bottom: 36px;
}
.category_row__col {
  padding-bottom: 20px;
}

.list_bread {
  margin-top: 30px;
  margin-bottom: 20px;
}
.list_bread__key1 {
  color: #999999;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.list_bread__key1:hover {
  text-decoration: none;
  color: #999999;
}
.list_bread__key2 {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}

.continue-card {
  padding-left: 0;
}

.max__todo-wrapper {
  margin-top: 1.875rem;
}
.max__todo-wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;
}
.max__todo-wrapper h3 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
}
.max__todo-wrapper h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.max__todo-wrapper h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.max__todo-wrapper h6 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin: 0;
}
.max__todo-wrapper h6 strong {
  font-weight: 700;
}

.max__todo-activity-tab {
  border: none;
  animation: bottomToTop 0.5s;
}
.max__todo-activity-tab li {
  margin-right: 25px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.max__todo-activity-tab li button {
  height: 50px;
  width: 273px;
  border: 1px solid #212121 !important;
  border-radius: 25px !important;
  color: #212121 !important;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}
.max__todo-activity-tab li .active {
  border-radius: 25px;
  /* background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%); */
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: #ffffff !important;
  border: none !important;
}

@keyframes bottomToTop {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }
  100% {
    opacity: 1;
  }
}
.max__activity-quest-card {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  border: none !important;
  cursor: pointer;
}

.max__todo-activity-wrapper {
  height: 700px;
  width: 100%;
  border-radius: 20px;
  background-color: #fff8dd;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 1.75rem 1.25rem 3.25rem 1.25rem;
  position: relative;
}
.max__todo-activity-wrapper .scroll-activity {
  height: 600px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-top: 30px;
  position: relative;
}
.max__todo-activity-wrapper .scroll-activity .activity-card {
  margin-bottom: 20px;
  position: relative;
}
.max__todo-activity-wrapper .scroll-activity .time p {
  display: flex;
  align-items: center;
  color: #898989;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 12px;
  margin: 15px 0;
}
.max__todo-activity-wrapper .scroll-activity .time svg {
  margin-right: 5px;
}
.max__todo-activity-wrapper .scroll-activity h3 {
  margin-bottom: 30px;
}
.max__todo-activity-wrapper .scroll-activity .vl {
  border-left: 2px dotted rgba(42, 119, 118, 0.65);
  height: 108%;
  position: absolute;
  left: 10px;
  z-index: 0;
}

.upcomming__todo-btn {
  background-color: #ffe8b9;
  padding: 22px 20px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
}

.upcomming__todo-text {
  margin-left: 8px;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.activity__card__wrapper {
  position: relative;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  padding: 24px 20px 24px 20px;
  z-index: 10;
  border: none;
  width: 100%;
  text-align: left;
}
.activity__card__wrapper .activity__card__chip {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.activity__card__wrapper .activity__text__wrapper {
  margin-top: 22px;
  margin-bottom: 21px;
}
.activity__card__wrapper .activity__text__wrapper .activity_title {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
}
.activity__card__wrapper .activity__points__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.activity__card__wrapper .activity__points__container .activity__points__text {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  text-align: right;
  margin-bottom: 5px;
}
.activity__card__wrapper .activity__points__container .activity__points {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 14px;
  text-align: right;
  margin-bottom: 0px;
}
.activity__card__wrapper .activity__points__container .activity__points b {
  color: #212121;
  font-family: Roboto;
  font-style: italic;
  letter-spacing: 0;
}
.activity__card__wrapper
  .activity__points__container
  .activity__points
  .points_img {
  margin-bottom: 3px;
  margin-right: 5px;
}

.qcl-empty-header {
  color: #212121 !important;
  font-family: Roboto !important;
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 16px !important;
  text-align: center !important;
  margin-bottom: 0.6rem !important;
}

.qcl-empty-subheader {
  color: #212121 !important;
  font-family: Roboto !important;
  font-size: 12px !important;
  letter-spacing: 0 !important;
  line-height: 16px !important;
  text-align: center !important;
}

.mx-infi-scroll .infinite-scroll-component__outerdiv {
  width: 100%;
}
.mx-infi-scroll .infinite-scroll-component {
  overflow: auto !important;
}
.mx-infi-scroll .infi-scroll-comp {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: min-content;
}

@media screen and (max-width: 425px) {
  .mx-infi-scroll .infi-scroll-comp {
    grid-template-columns: repeat(1, 1fr);
  }
  .analytics__header {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .max__profile-wrapper .profile__tab-layout {
    padding-left: 10px !important;
  }
  .your__squard-points {
    padding-left: 23% !important;
    border-right: none !important;
  }
  .your__squad-member {
    border-right: none !important;
  }
}
.ml-empty-uc svg {
  display: block;
}

.max__ranking-wrapper {
  text-align: center;
}
.max__ranking-wrapper .bread__crumbs-wrapper {
  margin: 1.25rem 0 1.25rem 0;
  padding: 0px;
  list-style: none;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list {
  padding: 0 10px 0 10px;
  color: #4f4e4e;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13px;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list:first-child {
  padding-left: 0px;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list:nth-child(2) {
  border-right: 1px solid #4f4e4e;
  border-left: 1px solid #4f4e4e;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list-active {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 13px;
  padding-left: 10px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content {
    margin-bottom: 40px;
  }
}
@media (min-width: 350px) and (max-width: 994px) {
  .email_icon_ic{
    float:left;
    width:10%
  }
  .emailio_ic{
    float:left;
    width:80%;
  }
}
.max__ranking-wrapper .achievements__content .ranking__top-wrapper {
  position: relative;
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/v1665560515/ranking_bg_aigoui.svg');
  padding: 3.125rem 1.5rem 0 1.5rem;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  height: 477px;
}
@media (min-width: 760px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content .ranking__top-wrapper {
    max-width: 70%;
    margin: auto;
  }
}
.max__ranking-wrapper .achievements__content .topper-details .topper__name {
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 12px;
  margin: 5px 0 0 0;
}
.max__ranking-wrapper .achievements__content .topper-details .topper__points {
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffd568;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  margin: 5px 0;
}
.max__ranking-wrapper
  .achievements__content
  .topper-details
  .topper__points
  .points-gem {
  width: 12px;
  height: 12px;
  margin-right: 2px;
}
.max__ranking-wrapper .achievements__content .first-container {
  position: absolute;
  top: 70px;
  right: 38%;
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper .achievements__content .first-container {
    top: 40px;
    right: 35%;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper .achievements__content .first-container {
    top: 35px;
    right: 35%;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg {
  position: relative;
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .squad__container-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg
  .squad-container-first {
  height: 68px;
  width: 68px;
  border-radius: 7px;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .squad__container-bg
    .squad-container-first {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg
  .squad-container-first
  .first__crown {
  position: absolute;
  top: -24px;
  right: 50%;
  transform: translate(50%, 0px);
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg
  .squad-container-first
  .squad__ranking-firstimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg {
  position: relative;
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .container-color-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg
  .icon-container-first {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .container-color-bg
    .icon-container-first {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg
  .icon-container-first
  .first__crown {
  position: absolute;
  top: -24px;
  right: 50%;
  transform: translate(50%, 0px);
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg
  .icon-container-first
  .individual__ranking-firstimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.max__ranking-wrapper .achievements__content .second-container {
  position: absolute;
  top: 140px;
  left: 40px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content .second-container {
    top: 160px;
    left: 40px;
  }
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper .achievements__content .second-container {
    top: 100px;
    left: 30px;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper .achievements__content .second-container {
    top: 80px;
    left: 15px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .squad__container-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .squad__container-bg {
    top: 100px;
    left: 30px;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .squad__container-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .squad__container-bg
  .squad-container-second {
  height: 68px;
  width: 68px;
  border-radius: 7px;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .squad__container-bg
    .squad-container-second {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .squad__container-bg
  .squad-container-second
  .squad__ranking-secondimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .container-color-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .container-color-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .container-color-bg
  .icon-container-second {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .container-color-bg
    .icon-container-second {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .container-color-bg
  .icon-container-second
  .individual__ranking-secondimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.max__ranking-wrapper .achievements__content .third-container {
  position: absolute;
  top: 170px;
  right: 30px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content .third-container {
    top: 190px;
    right: 35px;
  }
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper .achievements__content .third-container {
    top: 130px;
    right: 15px;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper .achievements__content .third-container {
    top: 110px;
    right: 5px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .squad__container-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .squad__container-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .squad__container-bg
  .squad-container-third {
  height: 68px;
  width: 68px;
  border-radius: 7px;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .squad__container-bg
    .squad-container-third {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .squad__container-bg
  .squad-container-third
  .squad__ranking-thirdimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .container-color-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .container-color-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .container-color-bg
  .icon-container-third {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .container-color-bg
    .icon-container-third {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .container-color-bg
  .icon-container-third
  .individual__ranking-thirdimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.max__ranking-wrapper h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 23px;
}
.max__ranking-wrapper h1 {
  padding-right: 20px;
  color: #212121;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 38px;
  border-right: 1px solid;
}
.max__ranking-wrapper h1 strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
}
.max__ranking-wrapper h1 small {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__ranking-wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 38px;
  padding-left: 20px;
}
.max__ranking-wrapper h2 strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
}
.max__ranking-wrapper h2 small {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}

.ranking-card {
  position: relative;
  height: auto;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 1.25rem 1.875rem;
}
.ranking-card .rank__user {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ecfeee;
  padding: 1.875rem;
}
.ranking-card .rank__user .scroll-rank-user {
  overflow-x: hidden;
  height: 600px;
  padding: 1rem;
  padding-top: 0;
  overflow-y: scroll;
}
.ranking-card .rank__content-wrapper {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
  padding: 1.875rem;
}
.ranking-card .rank__content-wrapper .scroll-rank-user {
  overflow-x: hidden;
  height: 600px;
  padding: 1rem;
  padding-top: 0;
  overflow-y: scroll;
}
.ranking-card .select__input {
  position: absolute;
  top: 50px;
  right: 30px;
}
.ranking-card .select__input select {
  position: relative;
  border: 1px solid #000000;
  background-color: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 14px;
  padding-right: 39px;
  border-radius: 6px;
  color: #000000;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  -webkit-appearance: none;
}
.ranking-card .select__input .select__arrows {
  position: absolute;
  top: 8px;
  right: 10px;
  pointer-events: none;
}

.rank__points-image {
  width: 18px;
  height: 18;
  margin-right: 6px;
}

.max__ranking-position-card {
  margin-bottom: 5px;
}
.max__ranking-position-card .topper {
  background-color: #ffeca2 !important;
}
.max__ranking-position-card .rank-number {
  padding: 12px;
  border-radius: 10px;
  background-color: #ffffff;
}
.max__ranking-position-card .rank-number .ranking__topper {
  color: #ff6633;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
}
.max__ranking-position-card .rank-number .rankings__other {
  margin: 0;
  color: #2a4759;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
}
.max__ranking-position-card .rank-details-wrapper .rank-details-container {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  padding-right: 35px;
  border-radius: 10px;
  background-color: #ffffff;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking__learners-name {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  color: #2a4759;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-position-card
    .rank-details-wrapper
    .rank-details-container
    .ranking__learners-name {
    max-width: 100px;
  }
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .individual__ranking {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .individual__ranking-image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .squad__ranking {
  width: 36px;
  height: 36px;
  border-radius: 4px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .squad__ranking-image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 4px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking__points-topper {
  margin: 0;
  color: #ff6633;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking__points-others {
  margin: 0;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking--topper {
  display: flex;
  align-items: center;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking--topper
  p {
  color: #4f4e4e;
  font-family: Roboto;
  font-size: 14px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 0px;
}

.ranking__header-text {
  color: #212121;
  font-family: Roboto;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 15px;
}

.ranking-cardslide {
  opacity: 1;
  animation: bottomToTop 1.1s ease 0s;
}

@keyframes bottomToTop {
  0% {
    opacity: 0;
    transform: translateY(200px);
    visibility: hidden;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.display-hidden {
  visibility: hidden;
}

.max__notification-wrapper .max__notification-card {
  display: flex;
  justify-content: space-between;
}
.max__notification-wrapper .max__notification-card .time .oval {
  height: 12px;
  width: 12px;
  border: 1px solid #f0f0f0;
  background-color: #de5021;
  border-radius: 50%;
}

.max__help__tab {
  flex-wrap: nowrap;
  overflow-x: scroll;
  display: flex;
}
.max__help__tab li {
  margin-right: 25px;
}
.max__help__tab li button {
  min-height: 50px;
  min-width: 190px;
  width: 100%;
}

.max__help-wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;
}
.max__help-wrapper h3 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
}
.max__help-wrapper h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.max__help-wrapper h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.max__help-wrapper h6 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin: 0;
}
.max__help-wrapper h6 strong {
  font-weight: 700;
}
.max__help-wrapper .help__search-container {
  margin: 1.875rem 0 0 0;
}
.max__help-wrapper .help__search-container .help_heading {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 1.625rem;
}
.max__help-wrapper .help__search-container input {
  margin: 0 auto;
  height: 50px;
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 0 20px;
  font-size: 1rem;
  border: 0px solid transparent;
  outline: none;
}
.max__help-wrapper .help__search-container input:focus {
  outline: none !important;
}
.max__help-wrapper .help__search-container input::-moz-placeholder {
  color: #817f7f;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper .help__search-container input::placeholder {
  color: #817f7f;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper .help__search-container input:focus {
  border: 1px solid #1b1b1c;
  transition: 0.35s ease;
  color: #212121;
}
.max__help-wrapper
  .help__search-container
  input:focus::-webkit-input-placeholder {
  -webkit-transition: opacity 0.45s ease;
  transition: opacity 0.45s ease;
  opacity: 0;
}
.max__help-wrapper .help__search-container input:focus::-moz-placeholder {
  -moz-transition: opacity 0.45s ease;
  transition: opacity 0.45s ease;
  opacity: 0;
}
.max__help-wrapper .help__search-container input:focus:-ms-placeholder {
  -ms-transition: opacity 0.45s ease;
  transition: opacity 0.45s ease;
  opacity: 0;
}
.max__help-wrapper .help__search-container .search-icon {
  position: relative;
  float: right;
  width: 16px;
  height: 16px;
  top: -31px;
  right: 20px;
}
.max__help-wrapper .help-query-heading {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 24px;
}
.max__help-wrapper .help__accordion-contianer .accordion {
  margin-bottom: 20px;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-button:focus {
  box-shadow: none;
}
.max__help-wrapper .help__accordion-contianer .accordion .accordion-button {
  color: #2b615c;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
  background-color: #ededed;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item:last-of-type
  .accordion-collapse {
  box-shadow: 0 12px 14px 0 rgba(0, 0, 0, 0.06);
}
.max__help-wrapper .help__accordion-contianer .accordion .accordion-item {
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: none;
  border: none;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header {
  color: #2b615c;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion_body_tab {
  color: #8b8989;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  margin-top: 9px;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  box-shadow: none;
  background: #ededed;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button
  .help__accordion-header {
  display: flex;
  flex-direction: column;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button
  h3 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button:not(.collapsed) {
  box-shadow: none;
  background: #ffffff;
  background-color: #ffffff;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button:not(.collapsed)
  h3 {
  color: #2b615c;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button:not(.collapsed)
  .accordion_body_tab {
  display: none;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button:not(.collapsed)::after {
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/v1665652242/path9509_e8cdri.svg');
  color: #2b615c;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
  transform: rotate(-360deg);
  background-size: 10px 10px;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button::after {
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/v1665652242/path9509_e8cdri.svg');
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
  transform: rotate(-90deg);
  background-size: 10px 10px;
  background-position: center;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body {
  padding-top: 0;
}
.max__help-wrapper
  .help__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body
  .accordion_body_content {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  padding-bottom: 0px !important;
}
.max__help-wrapper .question-oval {
  padding: 10%;
  opacity: 0.36;
  background: linear-gradient(204.16deg, #ffd42b 0%, #f0e6be 100%);
  border-radius: 50%;
  position: absolute;
  right: 0px;
  top: 0px;
  border-start-end-radius: 20px;
  border-start-start-radius: 50%;
  border-end-end-radius: 30px;
  border-start-start-radius: 30px;
}
.max__help-wrapper .question_wrapper {
  position: relative;
  margin-top: 30px;
  height: auto;
  width: 100%;
  border-radius: 20px;
  background-color: #fff8dd;
  padding: 33px 46px;
}
.max__help-wrapper .question_wrapper .question-img-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.max__help-wrapper .question_wrapper .question-img-container h2 {
  text-align: center;
  margin-bottom: 33px;
}
.max__help-wrapper .question_wrapper form .question-from-control {
  position: relative;
  display: flex;
  flex-direction: column;
}
.max__help-wrapper .question_wrapper form .question-from-control__label {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  margin-bottom: 14px;
  margin-top: 14px;
}
.max__help-wrapper .question_wrapper form .question-from-control__select {
  background-color: #fff;
  padding-right: 10px;
  color: #a0a1a2;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select
  option[value=''][disabled] {
  color: #a0a1a2;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select
  [disabled] {
  color: #959595;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select
  option:not(:disabled) {
  color: #212121 !important;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select
  option {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select:invalid {
  color: #a0a1a2;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14px;
}
.max__help-wrapper .question_wrapper form .question-from-control__input,
.max__help-wrapper .question_wrapper form .question-from-control__select,
.max__help-wrapper .question_wrapper form .question-from-control__textarea {
  padding: 15px;
  border: none;
  box-shadow: none;
  border-radius: 4px;
}
.max__help-wrapper .question_wrapper form .question-from-control__input,
.max__help-wrapper .question_wrapper form .question-from-control__textarea {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__input::-moz-placeholder,
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select::-moz-placeholder,
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__textarea::-moz-placeholder {
  color: #a0a1a2;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__input::placeholder,
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__select::placeholder,
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__textarea::placeholder {
  color: #a0a1a2;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__help-wrapper .question_wrapper form .question-from-control__input,
.max__help-wrapper .question_wrapper form .question-from-control__select,
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__textarea:focus {
  border: none;
  box-shadow: none;
  outline: 0;
}
.max__help-wrapper .question_wrapper form .question-from-control__input,
.max__help-wrapper .question_wrapper form .question-from-control__select,
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control__textarea:focus-visible {
  border: none;
  box-shadow: none;
  outline: 0;
}
.max__help-wrapper .question_wrapper form .question-from-control__textarea {
  position: relative;
  resize: none;
  height: 166px;
}
.max__help-wrapper
  .question_wrapper
  form
  .question-from-control
  .textarea-number-container {
  position: absolute;
  bottom: 10px;
  right: 25px;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
}
.max__help-wrapper .question_wrapper form .question-from-control__error {
  color: #ff6633;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
  padding: 5px;
}
.max__help-wrapper .question_wrapper form .submit-container {
  margin-top: 34px;
}
.max__help-wrapper .question_wrapper form .submit-container .submit_button {
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  width: 100%;
  padding: 15px;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  border: none;
}

.help__search_wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 24px;
}
.help__search_wrapper .help__search_content {
  margin-top: 24px;
}

.max__profile-wrapper .margin-top-main {
  margin: 50px 0 0 0;
}
.max__profile-wrapper .profile__tab-layout {
  padding-left: 40px;
}
.max__profile-wrapper .avatar-container {
  height: auto;
  width: 100%;
  border-radius: 20px;
  background-color: #e7f9fd;
  padding: 40px 60px;
  max-width: 300px;
  margin: auto;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__profile-wrapper .avatar-container {
    padding: 20px;
  }
}
@media (min-width: 1280px) and (max-width: 1366px) {
  .max__profile-wrapper .avatar-container {
    padding: 30px 40px;
  }
}
.max__profile-wrapper .avatar-container .avatar-img-container {
  text-align: center;
  padding: 40px 30px;
  border-radius: 8px;
  background: linear-gradient(180deg, #894ef9 0%, #bdc7fb 100%);
  position: relative;
}
.max__profile-wrapper
  .avatar-container
  .avatar-img-container
  .loading_skeleton {
  height: 103px;
  width: 103px;
  border-radius: 50%;
  animation: skeleton 1s infinite alternate;
}
.max__profile-wrapper .avatar-container .avatar-img-container .profile_photo {
  height: 103px;
  width: 103px;
  border-radius: 50%;
  -o-object-fit: cover;
  object-fit: cover;
}
.max__profile-wrapper .avatar-container .avatar-img-container .edit {
  position: absolute;
  background: linear-gradient(167.68deg, #54afae 0%, #2a7776 100%);
  box-shadow: 0 2px 5px 0 rgba(34, 145, 143, 0.33);
  padding: 10px 15px;
  border-radius: 50%;
  right: -15px;
  bottom: -25px;
}
.max__profile-wrapper .avatar-container .user__profile-name {
  margin: 1.25rem 0 0 0;
  text-align: center;
  word-wrap: break-word;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
}
@keyframes skeleton {
  0% {
    background-color: hsl(200, 20%, 70%);
  }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
}
.max__profile-wrapper .overall-container {
  margin: 40px 0 0 0;
  height: auto;
  width: 100%;
  border-radius: 10px;
  background-color: #ffeca2;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
  padding: 25px 30px;
}
@media (max-width: 999px) {
  .max__profile-wrapper .overall-container {
    margin: auto;
    margin-top: 30px;
    max-width: 450px;
  }
}
.max__profile-wrapper .overall-container .overall__subheader {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
}
.max__profile-wrapper .overall-container .overall__score {
  color: #212121;
  font-family: Roboto;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: 0.65;
  line-height: 36px;
}
.max__profile-wrapper .overall-container .overall__score-txt {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25;
  line-height: 14px;
}
.max__profile-wrapper .overall-container .your__achivement {
  margin: 0;
  padding-left: 5px;
  align-self: center;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__profile-wrapper .overall-container .your__achivement strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__profile-wrapper .overlall-target-container {
  height: auto;
  width: 100%;
  border-radius: 10px;
  background-color: rgba(255, 177, 71, 0.2509803922);
  border-radius: 0 0 10px 10px;
  background-color: #ffdc8b;
  padding: 13px 25px;
  display: flex;
  position: relative;
}
@media (max-width: 999px) {
  .max__profile-wrapper .overlall-target-container {
    margin: auto;
    margin-bottom: 10px;
    max-width: 450px;
  }
}
.max__profile-wrapper .overlall-target-container p {
  margin: 0;
  padding-left: 5px;
  align-self: center;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__profile-wrapper .overlall-target-container p strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__profile-wrapper .overlall-target-container .stars {
  position: absolute;
  top: 0;
  right: 0;
}
.max__profile-wrapper .profile__standing {
  color: #212121;
  font-family: Roboto;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: 0.25;
  line-height: 14px;
}
.max__profile-wrapper .profile__standing .standing {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.25;
  line-height: 14px;
}
.max__profile-wrapper .max__profile-tab li button {
  height: 100%;
  padding: 18px 64px;
  width: 100%;
}
.max__profile-wrapper .max__profile-activity-tab {
  border: none;
  animation: bottomToTop 0.5s;
}
.max__profile-wrapper .max__profile-activity-tab li {
  margin-right: 12px;
}
.max__profile-wrapper .max__profile-activity-tab li button {
  height: 40px;
  width: 120px;
  border: 1px solid #212121 !important;
  border-radius: 20px !important;
  color: #212121 !important;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}
.max__profile-wrapper .max__profile-activity-tab li .active {
  border-radius: 25px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  color: #ffffff !important;
  border: none !important;
}
.max__profile-wrapper .white-block {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  padding: 1.5rem 1.25rem;
}
.max__profile-wrapper .ml-pbi-black {
  color: #212121;
}
.max__profile-wrapper .ml-pbi-grey {
  color: #6d6b6b;
}
.max__profile-wrapper .ml-pbi {
  margin: 0;
  margin-top: 1.8rem;
}
.max__profile-wrapper .ml-pbi .basic-info-title {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
}
.max__profile-wrapper .ml-pbi__user-details {
  padding-left: 0;
}
@media (max-width: 600px) {
  .max__profile-wrapper .ml-pbi__user-details {
    padding: 0;
    margin-bottom: 1.5rem;
  }
}
.max__profile-wrapper .ml-pbi__company-details {
  padding-right: 0;
}
@media (max-width: 600px) {
  .max__profile-wrapper .ml-pbi__company-details {
    padding: 0;
  }
}
.max__profile-wrapper .ml-pbi__text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.max__profile-wrapper .ml-pbi .bio-desc {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  text-align: justify;
  word-wrap: break-word;
  margin: 0;
  margin-top: 1rem;
}
.max__profile-wrapper .ml-pbi .usd-row {
  margin: 0;
  margin-bottom: 1.5rem;
}
.max__profile-wrapper .ml-pbi .usd-row:last-child {
  margin: 0;
}
.max__profile-wrapper .ml-pbi span {
  display: inline-block;
  word-wrap: break-word;
}
.max__profile-wrapper .ml-pbi .basic-info-edit-btn {
  margin-left: 1rem;
  height: 16px;
  width: 16px;
  cursor: pointer;
}
.max__profile-wrapper .profile__accordion-contianer .accordion .accordion-item {
  margin-bottom: 16px;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  border: none;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  button {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 22px;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button:focus {
  border: none;
  box-shadow: none;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button::after {
  margin-left: 20px;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-header
  .accordion-button:not(.collapsed) {
  background-color: #ffffff;
  border: none;
  box-shadow: none;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body
  .details-container {
  background-color: #f5f5f5;
  padding: 20px 15px 0px 15px;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body
  .details-container
  .learning__data {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(151, 151, 151, 0.37);
  margin-bottom: 20px;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body
  .details-container
  .title__header {
  color: #858585;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 16px;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body
  .details-container
  h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  padding-top: 4px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.max__profile-wrapper
  .profile__accordion-contianer
  .accordion
  .accordion-item
  .accordion-body
  .details-container
  h4
  .percentage-bar {
  width: 30px;
}
.max__profile-wrapper .chip--wrapper {
  margin-top: 22px;
}
.max__profile-wrapper .chip--wrapper--chip {
  background-color: #ffffff;
  padding: 10px 12px;
  margin-top: 24px;
  border-radius: 6px;
}
.max__profile-wrapper .chip--wrapper--chip .title {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 12px;
}
.max__profile-wrapper .chip--wrapper--chip .tag {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}
.max__profile-wrapper .learning__chart .chart__header {
  color: #858585;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 20px;
}

.detail__card-wrapper {
  margin: auto;
  padding: 2.5rem;
  border-radius: 20px;
  border: 1px solid #e2e2e2;
  background-color: #ffffff;
  box-shadow: 0 12px 84px 0 rgba(0, 0, 0, 0.1);
}
@media (max-width: 650px) {
  .detail__card-wrapper {
    padding: 1.5rem;
  }
}
.detail__card-wrapper-left {
  position: relative;
  width: 100%;
  height: 600px;
  border-radius: 20px;
  -o-object-fit: cover;
  object-fit: cover;
}
.detail__card-wrapper .detail__card-center {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.detail__card-wrapper .detail__card-between {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.detail__card-wrapper .detail__card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detail__card-wrapper .detail__card__header-heading {
  color: #9d9d9d;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 18px;
}
.detail__card-wrapper .detail__card__header-duration {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 12px;
  transform: rotate();
}
.detail__card-wrapper .detail__card__body {
  margin-top: 47px;
  padding-right: 15%;
}
.detail__card-wrapper .detail__card__body-header {
  word-break: break-all;
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
}
.quest-decription-text-questdetails {
  word-break: break-all;
}
.detail__card-wrapper .detail__card__body-points {
  margin-top: 30px;
  color: #5f5d5d;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 18px;
}
.detail__card-wrapper .detail__card__body-points-img {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.detail__card-wrapper .detail__card__body-points .wrapper {
  display: flex;
}
.detail__card-wrapper .detail__card__body-points-key {
  word-wrap: break-word;
  margin-bottom: 18px;
}
.detail__card-wrapper .detail__card__body-points-quiz-key {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
}

.quiz-me-wrapper {
  width: 80%;
  height: 94vh;
  margin-bottom: 4rem;
}
.quiz-me-wrapper .quiz-me-btn button {
  width: 264px;
}

.width-100 {
  width: 100%;
}
@media (min-width: 1281px) and (max-width: 1679px) {
  .width-100 {
    width: 85%;
  }
}
@media (min-width: 1680px) {
  .width-100 {
    width: 75%;
  }
}
@media (min-width: 1920px) {
  .width-100 {
    max-width: 1200px;
  }
}
@media (min-width: 1280px) and (max-width: 1340px) {
  .width-100 {
    width: 100%;
  }
}

.button {
  margin-top: 46px;
}

.exam__detail__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.detail__card__center {
  padding: 90px;
}
@media (max-width: 600px) {
  .detail__card__center {
    padding: 5px;
  }
}
@media (min-width: 1000px) and (max-width: 1023px) {
  .detail__card__center {
    padding: 30px;
  }
}
@media (min-width: 851px) and (max-width: 999px) {
  .detail__card__center {
    padding: 120px;
  }
}

.partcipation {
  padding-right: 15%;
}

.partcipation__detail {
  display: flex;
  align-items: center;
  background-color: #ecfeef;
  border-radius: 8px;
  width: 100%;
  padding: 16px 25px;
}

.partcipation__detail-img {
  width: 30px !important;
  height: 30px !important;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
  margin-left: -6px;
}

.partcipation__detail-img-container {
  padding-left: 6px;
  text-align: left;
  display: flex;
  flex-direction: row;
}

.partcipation__detail-members {
  margin-left: 10px;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 13px;
}

.partcipation__detail-total {
  display: inline-flex;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(180deg, #4ef9c9 0%, #dafff4 100%);
  margin-left: -6px;
  justify-content: center;
  align-items: center;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13px;
}

.member__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.member__wrapper:last-child {
  margin-bottom: 0px;
}
.member__wrapper .member-profile {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.member__wrapper .member-profile-img {
  height: 34px;
  width: 34px !important;
  border-radius: 50%;
  margin-right: 8px;
  -o-object-fit: cover;
  object-fit: cover;
}
.member__wrapper .member-profile p {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0px;
}
.member__wrapper .member-points {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.member__wrapper .member-points-img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
.member__wrapper .member-points span {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.member__wrapper .nudge__button {
  color: #fff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  border: none;
  padding: 9px 16px;
  border-radius: 6px;
  background: linear-gradient(167.68deg, #54afae 0%, #2a7776 100%);
}

.our__team {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 20px;
  background: linear-gradient(72.96deg, #0a0101 0%, #bf482e 100%);
}

.opponent__team {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 20px;
  background: linear-gradient(72.96deg, #0a0101 0%, #0b98d4 100%);
}

.team__logo {
  width: 120px;
  height: 120px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 27px;
  padding: 15px 15px;
}
.team__logo-main-image {
  border-radius: 15px;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.team__name {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #ffffff;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
}

.points__data {
  padding: 20px;
  background-color: #ecfeee;
  border-radius: 20px;
  overflow: hidden;
}
@media (min-width: 300px) and (max-width: 450px) {
  .points__data {
    margin-top: 30px;
  }
  .analytics__header {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .your__squard-points {
    padding-left: 24% !important;
    border-right: none !important;
  }
  .your__squad-member {
    border-right: none !important;
  }
  .ml-pbi__company-details {
    margin-bottom: 32px;
  }
  .analytics__modal .analytics__container .analytics__body .analytics__content {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .level_main_cont {
    margin-top: 30px;
  }
  .close__button {
    top: 1rem !important;
    right: 0rem !important;
  }
  .formdiv {
    width: 93% !important;
  }
  .lock_icon {
    float: left !important;
  }
  .forgot_password .forgot_password-link {
    font-size: 13px !important;
  }
  .logintext {
    font-size: 18px !important;
  }
}
@media (min-width: 450px) and (max-width: 768px) {
  .points__data {
    margin-top: 30px;
  }
  .analytics__header {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .your__squard-points {
    padding-left: 16% !important;
    border-right: none !important;
  }
  .your__squad-member {
    border-right: none !important;
  }

  .ml-pbi__company-details {
    margin-top: 30px;
    padding-right: 15px;
    padding-left: 0px;
  }
  .analytics__modal .analytics__container .analytics__body .analytics__content {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .level_main_cont {
    margin-top: 30px;
  }
  .analytics__modal {
    height: 200px !important;
  }
  .close__button {
    top: 4rem !important;
    right: 2rem !important;
  }
  .lock_icon {
    float: left !important;
  }
  .forgot_password .forgot_password-link {
    font-size: 13px !important;
  }
  .formdiv {
    width: 70% !important;
  }
  .lock_just {
    justify-content: left !important;
  }
  .logintext {
    font-size: 18px !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .points__data {
    margin-top: 30px;
  }
  .analytics__header {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .your__squard-points {
    padding-left: 12% !important;
    border-right: none !important;
  }
  .your__squad-member {
    border-right: none !important;
  }
  .analytics__modal {
    height: 910px !important;
  }
  .close__button {
    top: 8rem !important;
    right: 2rem !important;
  }
  .formdiv {
    width: 70% !important;
  }
}
.points__data-graph {
  width: 130px;
  height: 100px;
}
.points__data-text {
  display: inline-block;
  vertical-align: middle;
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}
.points__data-small-points {
  color: #6b6b6b;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 13px;
}
.points__data h3 {
  color: #167f7d;
  font-family: Roboto;
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 32px;
  text-align: center;
}

.circular-progress {
  margin-top: -52px;
}

.opponent-wrapper-slick {
  min-height: 260px !important;
}

.slick-dots {
  position: absolute;
  right: -90%;
  top: 50%;
  transform: translateY(-50%);
  list-style: none;
  text-align: center;
  margin: 0px 3px;
  padding: 11% 1% 11% 1.5%;
  border-left: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (max-width: 650px) {
  .slick-dots {
    right: -80%;
  }
}
@media (min-width: 1000px) and (max-width: 1239px) {
  .slick-dots {
    right: -75%;
  }
}
.slick-dots::-webkit-scrollbar {
  width: 0px;
}

.opponent_wrapper-slick {
  margin-bottom: 10px;
}

.detail__card-wrapper ul li li {
  margin-bottom: 0px;
  width: 8px !important;
  height: 8px !important;
  border-radius: 50%;
  background-color: grey !important;
}
.detail__card-wrapper li .active-slider {
  height: 25px !important;
  width: 8px !important;
  border-radius: 4px !important;
  background-color: #fff !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.member__listing-modal {
  overflow-y: auto;
  height: 350px;
}

.team__members {
  margin-top: 20px;
}
.team__members-header {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 26px;
  margin-bottom: 20px;
}

.max-width {
  max-width: 128px;
}

.detail_team_margin {
  margin-top: 8%;
}

.width-60 {
  width: 90%;
  max-width: 1000px;
  padding: 50px;
}
@media (min-width: 1281px) and (max-width: 1679px) {
  .width-60 {
    width: 85%;
  }
}
@media (min-width: 1680px) {
  .width-60 {
    width: 75%;
  }
}
@media (min-width: 1920px) {
  .width-60 {
    max-width: 1100px;
  }
}
@media (min-width: 1100px) and (max-width: 1340px) {
  .width-60 {
    width: 100%;
  }
}
@media (min-width: 500px) and (max-width: 699px) {
  .width-60 {
    width: 90%;
  }
}
@media (min-width: 700px) and (max-width: 799px) {
  .width-60 {
    width: 80%;
  }
}
@media (min-width: 800px) and (max-width: 999px) {
  .width-60 {
    width: 65%;
  }
}

.pl-30 {
  padding-left: 30px;
}
@media (min-width: 400px) and (max-width: 899px) {
  .pl-30 {
    padding-left: 10px;
  }
}

.team__info__image-des {
  width: 100%;
  position: absolute;
  top: 20%;
  display: flex;
  justify-content: space-between;
  padding: 70px;
}
@media (min-width: 1281px) and (max-width: 1480px) {
  .team__info__image-des {
    padding: 50px;
  }
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .team__info__image-des {
    padding: 50px;
  }
}
@media (min-width: 1000px) and (max-width: 1239px) {
  .team__info__image-des {
    padding: 35px;
  }
}
@media (max-width: 650px) {
  .team__info__image-des {
    padding: 14px;
  }
}

.team__info--name {
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 10px;
  min-height: 40px;
}

.team__info__points-wrapper {
  margin-top: 20px;
}

.team__info__points-text {
  color: #ffd568;
}

.team__info__points-img {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}

.team__info-logo-image {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 18px;
}

.team__info-individual-logo-image {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.team__info-individual {
  text-align: center;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin: auto;
}

.team__info--image {
  text-align: center;
  border-radius: 18px;
  width: 80px;
  height: 80px;
  margin: auto;
}

.team__info--our-team {
  background-color: #ff5e7b;
}

.team__info--opponent-team {
  background-color: #5ec6ff;
}

#progress {
  background-image: linear-gradient(to right, 20% #e4ffff, 80% #167f7d);
}

.filled__custombutton {
  border: none;
  border-radius: 10px;
  padding: 19.5px 0;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  text-align: center;
  width: 100%;
  font-weight: 500;
}

.filled__disabled {
  border: none;
  border-radius: 10px;
  padding: 19.5px 0;
  background-color: #c0c0c0;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  text-align: center;
  width: 100%;
  font-weight: 500;
  cursor: not-allowed !important;
}

.padding-1 {
  padding: 1px !important;
}

.padding-2 {
  padding: 2px !important;
}

.padding-3 {
  padding: 3px !important;
}

.padding-4 {
  padding: 4px !important;
}

.padding-5 {
  padding: 5px !important;
}

.padding-6 {
  padding: 6px !important;
}

.padding-7 {
  padding: 7px !important;
}

.padding-8 {
  padding: 8px !important;
}

.padding-9 {
  padding: 9px !important;
}

.padding-10 {
  padding: 10px !important;
}

.completion__wrapper {
  padding: 40px;
}

.completion__content {
  position: relative;
  border-radius: 20px;
}
.completion__content--welcomenote {
  color: #9d9d9d;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 18px;
}
.completion__content--thanknote {
  margin-top: 12px;
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 26px;
}

.content__padding {
  padding: 77px 130px 68px 130px;
}
@media (min-width: 1025px) and (max-width: 1366px) {
  .content__padding {
    padding: 77px 70px 68px 70px;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  .content__padding {
    padding: 77px 100px 68px 100px;
  }
}
@media (min-width: 400px) and (max-width: 799px) {
  .content__padding {
    padding: 77px 20px 68px 20px;
  }
}
@media (min-width: 800px) and (max-width: 1023px) {
  .content__padding {
    padding: 77px 60px 68px 60px;
  }
}

.completion__points-earned {
  position: relative;
  width: 100%;
  border-radius: 10px;
  padding: 44px 57px 99px 44px;
  margin-bottom: 36px;
  box-shadow: 0 15px 24px 0 rgba(0, 0, 0, 0.14);
}
@media (min-width: 400px) and (max-width: 1024px) {
  .completion__points-earned {
    max-width: 500px;
    margin: auto;
    margin-bottom: 30px;
  }
}

.completion__points--text {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0.33px;
  line-height: 18px;
  margin-bottom: 8px;
}

.completion__points--myscore {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.22px;
  line-height: 12px;
}

.completion__points--points {
  color: #212121;
  font-family: Roboto;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: 0.65px;
  line-height: 36px;
  margin-right: 4px;
}

.completion__leading--info {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(255, 177, 71, 0.25);
  border-radius: 0px 0px 10px 10px;
  padding: 16px 55px;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 14px;
}
.completion__leading--info strong {
  color: #212121;
}

.leading__team--logo {
  margin-right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
}

.leading__individual--logo {
  margin-right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  -o-object-fit: cover;
  object-fit: cover;
}

.leading__stars {
  position: absolute;
  bottom: 16px;
  right: 0px;
}
.leading__stars svg {
  width: 40px;
  height: 40px;
}

.opponents__list {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 18px;
  margin-bottom: 24px;
}

.score__details__section {
  padding-left: 71px;
}
@media (min-width: 400px) and (max-width: 1024px) {
  .score__details__section {
    padding: 20px 20px 0px 20px;
  }
}

.score__card__wrapper {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
}

.score__card__header {
  padding: 33px 34px 28px 34px;
  border-bottom: 1px solid rgba(151, 151, 151, 0.24);
}

.score__card-text {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 25px;
}

.member__detail__score {
  padding: 20px 34px 33px 34px;
}

.completion__close-btn {
  position: absolute;
  top: 40px;
  right: 40px;
  border: none;
  background-color: transparent;
}
@media (min-width: 1025px) and (max-width: 1366px) {
  .completion__close-btn {
    top: 20px;
    right: 20px;
  }
}

.report__alert {
  background-color: #ffe8b9;
  border-radius: 8px;
  padding: 15px 45px 15px 15px;
  margin-top: 26px;
  display: flex;
}
.report__alert svg {
  transform: rotate(180deg);
  margin-right: 9px;
}

.confidence_modal {
  padding-bottom: 1rem 0;
  height: 450px;
}
.confidence_modal .slider {
  margin: 5rem 0;
}

.example-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.completion__footer {
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px solid rgba(151, 151, 151, 0.25);
}

.footer__wrapper {
  padding: 0px 130px 0px 130px;
}

.slider_footer {
  margin-top: 159px;
  padding: 0 48px;
  border-top: none;
}

.slider_text {
  width: 60px;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
}

.challenge__outline-btn {
  padding: 21px 87px 21px 87px;
  border: 1px solid;
  border-radius: 10px;
  background-color: #f8f8f8;
  margin-right: 20px;
  color: #ff6633;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}

.challenge__filled-btn {
  padding: 21px 87px 21px 87px;
  border: none;
  border-radius: 10px;
  background-color: #ff6633;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}

.mb-22 {
  margin-bottom: 22px !important;
}
.mb-22:last-child {
  margin-bottom: 0px;
}

.accordian {
  padding: 15px 25px;
  border-radius: 8px;
  background-color: #f0f1f2;
  margin-bottom: 20px;
  cursor: pointer;
}
.accordian:last-child {
  margin-bottom: 0px;
}
.accordian__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.accordian .accordian_squad_member {
  margin-top: 1.5rem;
  border-top: 1px solid rgba(151, 151, 151, 0.24);
  padding: 20px 0px 33px 0px;
}

.accordian__team__detail {
  display: flex;
  align-items: center;
}

.accordian__team__detail__logo {
  border-radius: 7px;
  margin-right: 10px;
}
.accordian__team__detail__logo .accordian__team__logo--image {
  height: 38px;
  width: 38px;
  border-radius: 7px;
}

.accordian__team--name {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 1025px) and (max-width: 1366px) {
  .accordian__team--name {
    max-width: 140px;
  }
}

.accordian__team__points__detail {
  display: flex;
  align-items: center;
  justify-content: end;
}

.team__detail__points--image {
  margin-right: 4px;
  height: 18px;
  width: 18px;
}

.team__detail__points {
  color: #e7a006;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 18px;
}

.accordian__toggle-btn {
  cursor: pointer;
  border: none;
  border-radius: 50%;
  padding: 2px;
  background-color: #d8d8d8;
  margin-left: 20px;
  transition: all 0.4s ease;
}
.accordian__toggle-btn.open {
  transform: rotate(180deg);
}

.opponent-accordian {
  padding: 15px 25px;
}

.ml-edit-user-details {
  width: 100% !important;
  right: 0 !important;
  top: 0 !important;
  left: auto !important;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  z-index: 9999 !important;
  background-color: transparent !important;
  padding: 0 !important;
}
.ml-edit-user-details__modal-dialog {
  margin: 0;
  position: fixed;
  right: 0;
  width: 29.375rem;
  min-height: 100vh;
}
@media (max-width: 600px) {
  .ml-edit-user-details__modal-dialog {
    width: 100% !important;
    padding: 1.5rem !important;
  }
}
.ml-edit-user-details__modal-content {
  min-height: 100vh;
}
.ml-edit-user-details__modal-header {
  padding: 2.5rem;
  padding-bottom: 1.5rem;
}
.ml-edit-user-details__modal-header .edit_btn {
  background-color: transparent;
  border: none;
}
.ml-edit-user-details__modal-header .modal-title {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
}
.ml-edit-user-details__modal-header .btn-close {
  width: 0.8rem !important;
  height: 0.8rem !important;
  color: #212121 !important;
  opacity: 1;
}
.ml-edit-user-details__modal-body {
  padding: 2.5rem;
  padding-bottom: 1.5rem;
  overflow-y: auto;
}
.ml-edit-user-details__modal-body .modal__body-header {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 20px;
}
.ml-edit-user-details__modal-footer {
  padding: 0;
  border-top: none !important;
  justify-content: center;
}
.ml-edit-user-details__modal-footer .btn {
  width: 100%;
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  padding: 1.375rem;
  border: none;
  color: #ffffff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}

.ml-edit-user-detail-form .form__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 150px);
}
.ml-edit-user-detail-form .ml-form-group {
  margin: 0;
  margin-bottom: 1.938rem;
}
.ml-edit-user-detail-form .ml-form-group textarea {
  resize: none;
}
.ml-edit-user-detail-form .phone__number-wrapper .PhoneInput {
  padding: 0px !important;
}
.ml-edit-user-detail-form
  .phone__number-wrapper
  .PhoneInput
  .PhoneInputCountry {
  padding-bottom: 17px !important;
  border-bottom: 1.5px solid #d9d9d9 !important;
}
.ml-edit-user-detail-form
  .phone__number-wrapper
  .PhoneInput
  .PhoneInputCountry
  .PhoneInputCountrySelectArrow {
  border-color: #212121 !important;
}
.ml-edit-user-detail-form
  .phone__number-wrapper
  .PhoneInput
  .PhoneInputCountry
  .PhoneInputCountrySelect {
  color: #212121 !important;
  font-family: Roboto !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  line-height: 16px !important;
}
.ml-edit-user-detail-form .phone__number-wrapper .PhoneInput .PhoneInputInput {
  width: 100%;
  color: #212121 !important;
  font-family: Roboto !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  line-height: 16px !important;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 1.5px solid #d9d9d9 !important;
  padding-bottom: 17px;
  outline: none;
}
.ml-edit-user-detail-form .phone__number-wrapper .react-tel-input {
  color: #212121;
  font-family: Roboto !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  line-height: 16px !important;
  padding: 0px !important;
}
.ml-edit-user-detail-form
  .phone__number-wrapper
  .react-tel-input
  .form-control:focus {
  box-shadow: none;
}
.ml-edit-user-detail-form .phone__number-wrapper .react-tel-input input {
  width: 100%;
  color: #212121 !important;
  font-family: Roboto !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  line-height: 16px !important;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 1.5px solid #d9d9d9 !important;
  padding-bottom: 17px;
  outline: none;
}
.ml-edit-user-detail-form
  .phone__number-wrapper
  .react-tel-input
  .flag-dropdown {
  padding-bottom: 17px;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 1.5px solid #d9d9d9 !important;
  background-color: transparent;
}
.ml-edit-user-detail-form
  .phone__number-wrapper
  .react-tel-input
  .flag-dropdown
  .selected-flag {
  padding-bottom: 17px;
}
.ml-edit-user-detail-form .ml-form-text-title {
  color: #727a92;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 16px;
  margin: 0;
  margin-bottom: 0.875rem;
}
.ml-edit-user-detail-form input::-webkit-outer-spin-button,
.ml-edit-user-detail-form input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ml-edit-user-detail-form input[type='number'] {
  -moz-appearance: textfield;
}
.ml-edit-user-detail-form .ml-form-inputs {
  border: none;
  border-bottom: 1.5px solid #d9d9d9;
  border-radius: 0px;
  padding: 0;
  padding-bottom: 1rem;
  padding-right: 1.4rem;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
}
.ml-edit-user-detail-form .selectbox__wrapper {
  position: relative;
}
.ml-edit-user-detail-form .select__icon {
  position: absolute;
  right: 0px;
  pointer-events: none;
}
.ml-edit-user-detail-form .select__input {
  width: 100%;
  padding-bottom: 1rem;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  border-bottom: 1.5px solid #d9d9d9;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  position: relative;
}
.ml-edit-user-detail-form .select__input:focus {
  outline: none;
  border-bottom: 1.5px solid #212121;
  border-top: none;
  border-left: none;
  border-right: none;
}
.ml-edit-user-detail-form .select__input option {
  color: #212121;
}
.ml-edit-user-detail-form .ml-form-inputs:focus {
  box-shadow: none;
}

.ml-edit-user-detail-form .ml-form-group .password_input {
  position: relative;
}
.ml-edit-user-detail-form .ml-form-group .password_input .password__icon {
  position: absolute;
  display: inline-block;
  top: 0px;
  right: 0px;
  border: none;
  background-color: transparent;
}
.ml-edit-user-detail-form .ml-form-group .password_input .change__password {
  position: absolute;
  display: inline-block;
  top: 3px;
  right: 32px;
  border: none;
  background-color: transparent;
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}
.ml-edit-user-detail-form .ml-form-group .password_input .want_to_change {
  position: absolute;
  width: -moz-fit-content;
  width: fit-content;
  text-align: end;
  top: 3px;
  right: 0px;
  border: none;
  background-color: transparent;
  color: #0e3a5e;
  font-family: Roboto;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}

.form_error-message {
  margin-top: 10px;
  color: red;
  font-size: 14px;
}

.ml-modal-blur {
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.chip__wrapper {
  padding: 8px 15px;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
  border-radius: 12px;
  margin-left: 12px;
}

.completed__color {
  background-color: #ecfeee;
}

.inprogress__color {
  background-color: #fff8dd;
}

.notstarted__color {
  background-color: #f0f0f0;
}

.quest__color {
  background-color: #9effd4;
}

.certs__color {
  background-color: #9ed5ff;
}

.challenge__color {
  background-color: #fef1ab;
}

.individual__image-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.squad__image-container {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  position: relative;
}

.challenge__crown {
  position: absolute;
  bottom: 20px;
  right: 50%;
  transform: translate(50%, 0%);
}

.squad__image-img {
  -o-object-fit: cover;
  object-fit: cover;
  width: 30px;
  height: 30px;
  border-radius: 8px;
}

.individual__image-img {
  -o-object-fit: cover;
  object-fit: cover;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.squad__versus-img {
  margin-left: 14px;
  margin-right: 14px;
}

.indivial__opponent-img {
  display: inline;
}

.image__grid {
  margin-right: 4px;
}

.more__opponents {
  color: #5d5c5c;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}

.your__squad-header {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 15px;
  margin-top: 30px;
}

.your__squad-member {
  border-right: 1px solid rgba(151, 151, 151, 0.3);
}

.your__squad-text {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  text-transform: capitalize;
}

.your__squad-subtext {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
}

.squad_challenge-header {
  margin-top: 30px;
  margin-bottom: 15px;
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 22px;
}

.your__squad-details {
  padding: 12px 56px 12px 12px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 5px;
}
.your__squad-details .total__points {
  color: #ff6633;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}

.star__icon {
  position: absolute;
  top: 0px;
  right: 0px;
}

.points__earned-image {
  width: 15px;
  height: 15px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-right: 2px;
}

.table_btn {
  background-color: transparent;
  border: none;
  width: 100%;
}

.table__row-wrapper {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  padding: 24px 20px;
  margin-bottom: 16px;
}

.your_Squad_img-wrapper {
  text-align: left;
}

.your__squad-image {
  height: 50px;
  width: 50px;
  border-radius: 8px;
  margin-right: 20px;
}

.your__squad-name {
  width: 20%;
  padding: 24px 20px;
}

.your__squad__members-img {
  width: 40%;
  padding: 24px 20px;
}

.your__squard-points {
  border-right: 1px solid rgba(151, 151, 151, 0.3);
  text-align: left;
  padding-left: 30px;
}
.your__squard-points svg {
  margin-right: 8px;
  margin-bottom: 8px;
}

.your__squard-standing svg {
  margin-right: 8px;
}

.squad__back-btn {
  border: none;
  background-color: transparent;
  color: #212121;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 30px;
}
.squad__back-btn svg {
  margin-right: 15px;
  fill: #212121;
}

.squad_standing-container {
  margin-top: 30px;
}

.squad-text {
  display: inline-block;
  margin-left: 6px;
  margin-top: 4px;
  color: #212121;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 24px;
}

.squad-subheader {
  color: #515b73;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 12px;
  text-align: center;
}

.squad__logo-image {
  border-radius: 20px;
  min-height: 200px;
  padding: 1px 20px 1px 20px;
  max-width: 300px;
  margin: auto;
}
@media (max-width: 999px) {
  .squad__logo-image {
    margin-bottom: 30px;
  }
}

.squad__logo-container {
  margin-top: 40px;
  margin-bottom: 30px;
}

.squad__logo-background {
  background-color: #ffffff;
  height: 178px;
  width: 178px;
  padding: 15px;
  border-radius: 20px;
}

.squad__detail-teamname {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
  word-wrap: break-word;
  text-transform: capitalize;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
}

.squad__detail-logo {
  border-radius: 20px;
  width: 100%;
  height: 100%;
}

.squad-details-wrapper {
  margin-top: 30px;
}

.squad-details-container {
  padding: 12px 56px 12px 12px;
  border-radius: 10px;
  background-color: #ffffff;
  margin-bottom: 5px;
}

.squad__points-image {
  margin-right: 9px;
  height: 18px;
  width: 18px;
}

.squad__member-name {
  color: #2a4759;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 0px;
  margin-left: 10px;
}

.total__points {
  margin-bottom: 0px;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}

.ant-tooltip-inner {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.408px;
  color: #000000;
}

.grey2 {
  color: #5f747e;
}

.bankpay_checkout-main {
  display: flex;
}
@media (min-width: 600px) and (max-width: 1023px) {
  .bankpay_checkout-main {
    flex-direction: column;
  }
}
.bankpay_checkout-main .bankpay_checkout-maxspace-div {
  width: 50%;
  background-color: #ffffff;
}
@media (min-width: 600px) and (max-width: 1023px) {
  .bankpay_checkout-main .bankpay_checkout-maxspace-div {
    width: 100%;
    border-bottom: 12px solid #e5e5e5;
  }
}
.bankpay_checkout-main .bankpay_checkout-minspace-div {
  width: 50%;
  background-color: #fcfcfc;
  box-shadow: inset 4px 0px 0 rgba(0, 0, 0, 0.08);
}
@media (min-width: 600px) and (max-width: 1023px) {
  .bankpay_checkout-main .bankpay_checkout-minspace-div {
    width: 100%;
    background-color: #ffffff;
  }
}

.green {
  color: #129448;
}

.learning_modal_card_wrapper {
  padding: 20px;
}
.learning_modal_card_wrapper__row {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 5px 15px;
  margin-bottom: 18px;
}
.learning_modal_card_wrapper__row__content {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 20px;
}
.learning_modal_card_wrapper__row__content__title {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  padding-bottom: 16px;
}
.learning_modal_card_wrapper__row__content__level {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 14px;
}
.learning_modal_card_wrapper__row__content__level1 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.learning_modal_card_wrapper .CircularProgressbar {
  height: 90px;
  width: 90px;
  margin: 25px;
}

.topicsModalCard_wrapper {
  padding: 20px;
}
.topicsModalCard_wrapper__row {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 5px 15px;
  margin-bottom: 18px;
  background-color: white;
}
.topicsModalCard_wrapper__row__content {
  margin-top: 25px;
  margin-bottom: 25px;
  margin-left: 20px;
}
.topicsModalCard_wrapper__row__content__title {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  padding-bottom: 16px;
}
.topicsModalCard_wrapper__row__content__level {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 14px;
}
.topicsModalCard_wrapper__row__content__level1 {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.topicsModalCard_wrapper__row__content__total {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 13px;
  padding-left: 13px;
}
.topicsModalCard_wrapper__row__content__members {
  margin-top: 16px;
}

.max__ranking-wrapper {
  text-align: center;
}
.max__ranking-wrapper .bread__crumbs-wrapper {
  margin: 1.25rem 0 1.25rem 0;
  padding: 0px;
  list-style: none;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list {
  padding: 0 10px 0 10px;
  color: #4f4e4e;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13px;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list:first-child {
  padding-left: 0px;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list:nth-child(2) {
  border-right: 1px solid #4f4e4e;
  border-left: 1px solid #4f4e4e;
}
.max__ranking-wrapper .bread__crumbs-wrapper .bread__crumbs-list-active {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 13px;
  padding-left: 10px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content {
    margin-bottom: 40px;
  }
}
.max__ranking-wrapper .achievements__content .ranking__top-wrapper {
  position: relative;
  background-image: url('https://res.cloudinary.com/dysdy7hjr/image/upload/v1665560515/ranking_bg_aigoui.svg');
  padding: 3.125rem 1.5rem 0 1.5rem;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  height: 477px;
}
@media (min-width: 760px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content .ranking__top-wrapper {
    max-width: 70%;
    margin: auto;
  }
}
.max__ranking-wrapper .achievements__content .topper-details .topper__name {
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 12px;
  margin: 5px 0 0 0;
}
.max__ranking-wrapper .achievements__content .topper-details .topper__points {
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffd568;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  margin: 5px 0;
}
.max__ranking-wrapper
  .achievements__content
  .topper-details
  .topper__points
  .points-gem {
  width: 12px;
  height: 12px;
  margin-right: 2px;
}
.max__ranking-wrapper .achievements__content .first-container {
  position: absolute;
  top: 70px;
  right: 38%;
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper .achievements__content .first-container {
    top: 40px;
    right: 35%;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper .achievements__content .first-container {
    top: 35px;
    right: 35%;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg {
  position: relative;
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .squad__container-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg
  .squad-container-first {
  height: 68px;
  width: 68px;
  border-radius: 7px;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .squad__container-bg
    .squad-container-first {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg
  .squad-container-first
  .first__crown {
  position: absolute;
  top: -24px;
  right: 50%;
  transform: translate(50%, 0px);
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .squad__container-bg
  .squad-container-first
  .squad__ranking-firstimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg {
  position: relative;
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .container-color-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg
  .icon-container-first {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .first-container
    .container-color-bg
    .icon-container-first {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg
  .icon-container-first
  .first__crown {
  position: absolute;
  top: -24px;
  right: 50%;
  transform: translate(50%, 0px);
}
.max__ranking-wrapper
  .achievements__content
  .first-container
  .container-color-bg
  .icon-container-first
  .individual__ranking-firstimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.max__ranking-wrapper .achievements__content .second-container {
  position: absolute;
  top: 140px;
  left: 40px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content .second-container {
    top: 160px;
    left: 40px;
  }
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper .achievements__content .second-container {
    top: 100px;
    left: 30px;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper .achievements__content .second-container {
    top: 80px;
    left: 15px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .squad__container-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .squad__container-bg {
    top: 100px;
    left: 30px;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .squad__container-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .squad__container-bg
  .squad-container-second {
  height: 68px;
  width: 68px;
  border-radius: 7px;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .squad__container-bg
    .squad-container-second {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .squad__container-bg
  .squad-container-second
  .squad__ranking-secondimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .container-color-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .container-color-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .container-color-bg
  .icon-container-second {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .second-container
    .container-color-bg
    .icon-container-second {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .second-container
  .container-color-bg
  .icon-container-second
  .individual__ranking-secondimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.max__ranking-wrapper .achievements__content .third-container {
  position: absolute;
  top: 170px;
  right: 30px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-wrapper .achievements__content .third-container {
    top: 190px;
    right: 35px;
  }
}
@media (min-width: 1280px) and (max-width: 1439px) {
  .max__ranking-wrapper .achievements__content .third-container {
    top: 130px;
    right: 15px;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper .achievements__content .third-container {
    top: 110px;
    right: 5px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .squad__container-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .squad__container-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .squad__container-bg
  .squad-container-third {
  height: 68px;
  width: 68px;
  border-radius: 7px;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .squad__container-bg
    .squad-container-third {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .squad__container-bg
  .squad-container-third
  .squad__ranking-thirdimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .container-color-bg {
  background-color: rgba(216, 216, 216, 0.26);
  height: 85px;
  width: 85px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .container-color-bg {
    height: 65px;
    width: 65px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .container-color-bg
  .icon-container-third {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .max__ranking-wrapper
    .achievements__content
    .third-container
    .container-color-bg
    .icon-container-third {
    height: 48px;
    width: 48px;
  }
}
.max__ranking-wrapper
  .achievements__content
  .third-container
  .container-color-bg
  .icon-container-third
  .individual__ranking-thirdimage {
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.max__ranking-wrapper h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 23px;
}
.max__ranking-wrapper h1 {
  padding-right: 20px;
  color: #212121;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 38px;
  border-right: 1px solid;
}
.max__ranking-wrapper h1 strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
}
.max__ranking-wrapper h1 small {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}
.max__ranking-wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 38px;
  padding-left: 20px;
}
.max__ranking-wrapper h2 strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
}
.max__ranking-wrapper h2 small {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
}

.ranking-card {
  position: relative;
  height: auto;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 1.25rem 1.875rem;
}
.ranking-card .rank__user {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ecfeee;
  padding: 1.875rem;
}
.ranking-card .rank__user .scroll-rank-user {
  overflow-x: hidden;
  height: 600px;
  padding: 1rem;
  padding-top: 0;
  overflow-y: scroll;
}
.ranking-card .rank__content-wrapper {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
  padding: 1.875rem;
}
.ranking-card .rank__content-wrapper .scroll-rank-user {
  overflow-x: hidden;
  height: 600px;
  padding: 1rem;
  padding-top: 0;
  overflow-y: scroll;
}
.ranking-card .select__input {
  position: absolute;
  top: 50px;
  right: 30px;
}
.ranking-card .select__input select {
  position: relative;
  border: 1px solid #000000;
  background-color: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 14px;
  padding-right: 39px;
  border-radius: 6px;
  color: #000000;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  -webkit-appearance: none;
}
.ranking-card .select__input .select__arrows {
  position: absolute;
  top: 8px;
  right: 10px;
  pointer-events: none;
}

.rank__points-image {
  width: 18px;
  height: 18;
  margin-right: 6px;
}

.max__ranking-position-card {
  margin-bottom: 5px;
}
.max__ranking-position-card .topper {
  background-color: #ffeca2 !important;
}
.max__ranking-position-card .rank-number {
  padding: 12px;
  border-radius: 10px;
  background-color: #ffffff;
}
.max__ranking-position-card .rank-number .ranking__topper {
  color: #ff6633;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
}
.max__ranking-position-card .rank-number .rankings__other {
  margin: 0;
  color: #2a4759;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
}
.max__ranking-position-card .rank-details-wrapper .rank-details-container {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  padding-right: 35px;
  border-radius: 10px;
  background-color: #ffffff;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking__learners-name {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  color: #2a4759;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
@media (min-width: 500px) and (max-width: 994px) {
  .max__ranking-position-card
    .rank-details-wrapper
    .rank-details-container
    .ranking__learners-name {
    max-width: 100px;
  }
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .individual__ranking {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .individual__ranking-image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .squad__ranking {
  width: 36px;
  height: 36px;
  border-radius: 4px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .squad__ranking-image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 4px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking__points-topper {
  margin: 0;
  color: #ff6633;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking__points-others {
  margin: 0;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking--topper {
  display: flex;
  align-items: center;
}
.max__ranking-position-card
  .rank-details-wrapper
  .rank-details-container
  .ranking--topper
  p {
  color: #4f4e4e;
  font-family: Roboto;
  font-size: 14px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 0px;
}

.ranking__header-text {
  color: #212121;
  font-family: Roboto;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 15px;
}

.ranking-cardslide {
  opacity: 1;
  animation: bottomToTop 1.1s ease 0s;
}

@keyframes bottomToTop {
  0% {
    opacity: 0;
    transform: translateY(200px);
    visibility: hidden;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.display-hidden {
  visibility: hidden;
}

/**
* Global mixin file
*/
/**
*
* Testing
*
**/
.category_detail_wrapper .detail_left_col {
  position: relative;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  padding: 20px;
  height: 364px;
  width: 330px;
}
.category_detail_wrapper .detail_right_col {
  padding-left: 20px;
}
.category_detail_wrapper .detail_right_col .subject_description {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 34px;
  margin-top: 10px;
}

.category_subject__wrapper {
  border-radius: 8px;
  background-color: white;
  padding: 15px;
  margin-bottom: 20px;
}
.category_subject__wrapper .subject_icon {
  border-radius: 10px;
  background-color: #f3f3f3;
  padding: 13px 13px;
}
@media (min-width: 600px) and (max-width: 1024px) {
  .category_subject__wrapper .right_col_wrapper {
    padding-left: 6px;
  }
}
.category_subject__wrapper .topic_wrapper {
  display: flex;
}
.category_subject__wrapper .topic_wrapper__total {
  color: #2a7776;
  font-family: Roboto;
  font-size: 12px;
  font-weight: none;
  letter-spacing: 0;
  line-height: 16px;
  padding: 2px 10px;
  background-color: rgb(235, 254, 238);
  border-radius: 4px;
}
.category_subject__wrapper .topic_name {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 32px;
}

.topic-card-wrapper {
  border-radius: 8px;
  background-color: #ffffff;
  padding: 15px;
}
.topic-card-wrapper .card-name {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
}
.topic-card-wrapper .card-number {
  color: #707070;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  padding-top: 15px;
}

.flash-card-wrapper {
  padding: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flash-card-wrapper .swiper-slide {
  height: 100vh;
}
.flash-card-wrapper .flash_card {
  width: 80%;
  padding: 2.5rem;
  padding-bottom: 6rem;
  height: 100%;
}
.flash-card-wrapper__close_button {
  top: 9rem;
}
.flash-card-wrapper .mySwiperCatergory {
  position: relative;
  margin-bottom: 4rem;
}

.flash-card-wrapper-h .swiper-slide {
  height: 70vh;
}

.leftClassName {
  background-color: #dfdada;
  border-radius: 20px;
}

.flashCardClassName {
  background: none;
}
.flashCardClassName img {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.rightClassName h3 {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
}
.rightClassName h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 200px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 10px;
}
.rightClassName h5.content-desc {
  display: -webkit-box;
  -webkit-line-clamp: 16;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.swiper_pagination_flashCard {
  float: right;
  display: flex;
  justify-content: end;
  align-items: center;
  height: 50px;
  margin-top: 48px;
  bottom: 39px;
  right: 170px;
  z-index: 999999;
  position: absolute;
}
.swiper_pagination_flashCard .swiper-button-disabled {
  background-color: #f1f1f1 !important;
}
.swiper_pagination_flashCard .swiper-button-disabled:hover {
  cursor: context-menu !important;
}
.swiper_pagination_flashCard .swiper-button-disabled span {
  font-size: 30px !important;
  color: rgb(154, 153, 153) !important;
}
.swiper_pagination_flashCard .previous {
  height: 50px;
  width: 50px;
  border-radius: 30px;
  background-color: #e4fcfc;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
}
.swiper_pagination_flashCard .previous:hover {
  cursor: pointer;
}
.swiper_pagination_flashCard .previous span {
  font-size: 30px;
  color: #2a7776;
}
.swiper_pagination_flashCard .next {
  height: 50px;
  width: 50px;
  border-radius: 30px;
  background-color: #e4fcfc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper_pagination_flashCard .next:hover {
  cursor: pointer;
}
.swiper_pagination_flashCard .next span {
  font-size: 30px;
  color: #2a7776;
}
.swiper_pagination_flashCard .complete-btn {
  height: 50px;
  width: 50px;
  border-radius: 50px;
  background-color: #fff;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  border: none;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper_pagination_flashCard .complete-btn:hover {
  cursor: pointer;
}
.swiper_pagination_flashCard .complete-btn span {
  font-size: 30px;
  color: #2a7776;
}
.swiper_pagination_flashCard .page_index {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 300px;
  letter-spacing: 0;
  line-height: 24px;
}

.sidebar__modal {
  width: 100% !important;
  right: 0 !important;
  left: auto !important;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.sidebar__modal__modal-dialog {
  margin: 0;
  position: fixed;
  right: 0;
  width: 29.375rem;
  min-height: 100vh;
}
@media (max-width: 600px) {
  .sidebar__modal__modal-dialog {
    width: 100% !important;
    padding: 1.5rem !important;
  }
}
.sidebar__modal__modal-content {
  min-height: 100vh;
}
.sidebar__modal__modal-header {
  padding: 2.5rem;
  padding-bottom: 1.5rem;
}
.sidebar__modal__modal-header .modal-title {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
}
.sidebar__modal__modal-header .mark-all-read {
  background: none;
  color: #0e3a5e;
  border: none;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  margin-left: 8.5rem;
}
.sidebar__modal__modal-header .btn-close {
  width: 0.8rem !important;
  height: 0.8rem !important;
  color: #212121 !important;
  opacity: 1;
}
.sidebar__modal__modal-body {
  padding: 2rem;
  padding-bottom: 1.5rem;
  padding-right: 10px;
}
.sidebar__modal__modal-body .modal__infintescroll-wrapper {
  height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}
.sidebar__modal__modal-body .modal__body-header {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 20px;
}
.sidebar__modal__modal-footer {
  padding: 0 2.5rem 1.8rem 2.5rem;
  border-top: none !important;
  justify-content: center;
}
.sidebar__modal__modal-footer .btn {
  width: 100%;
  border-radius: 4px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  padding: 1.375rem;
  color: #ffffff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}

.infinite-scroll-component {
  overflow: hidden !important;
}

.feedback_modal {
  height: auto;
  width: 676px;
  border-radius: 20px;
  background-color: #ffffff;
  margin: auto;
}
.feedback_modal .feedback-wrappers {
  padding: 50px;
}
.feedback_modal .feedback_header {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.feedback_modal .feedback_header .feedback_name {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
  padding-top: 16px;
}
.feedback_modal .select__wrapper {
  margin-top: 50px;
}
.feedback_modal .select__wrapper .feedback_text {
  margin-top: 8px;
  margin-bottom: 0px;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
}
.feedback_modal .select__wrapper .select__input-feedback {
  width: 100%;
  position: relative;
}
.feedback_modal .select__wrapper .select__input-feedback .select-input {
  width: 100%;
}
.feedback_modal .select__wrapper .select__input-feedback .select-input {
  background: transparent;
  -webkit-appearance: none;
  font-size: 11px;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-bottom: 1px solid #979797;
  padding-bottom: 8px;
  outline: none;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14px;
}
.feedback_modal .select__wrapper .select__input-feedback .select-input:invalid {
  color: #959595;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14px;
}
.feedback_modal
  .select__wrapper
  .select__input-feedback
  .select-input
  [disabled] {
  color: #959595;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14px;
}
.feedback_modal
  .select__wrapper
  .select__input-feedback
  .select-input
  option:after {
  padding-top: 10px;
  padding-bottom: 10px;
}
.feedback_modal
  .select__wrapper
  .select__input-feedback
  .select-input
  option:not(:disabled) {
  color: #212121 !important;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 14px;
}
.feedback_modal .select__wrapper .select__input-feedback .arrow_img {
  position: absolute;
  right: 0;
  top: 0;
  pointer-events: none;
}
.feedback_modal .feedback__limt-txt {
  position: absolute;
  bottom: 0px;
  right: 10px;
}
.feedback_modal .feedback_text_area {
  position: relative;
  padding-top: 30px;
  display: flex;
  justify-content: center;
}
.feedback_modal .feedback_text_area textarea {
  resize: none;
  color: #000000;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 18px;
  border: 1px solid #979797;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 20px;
  width: 100%;
  outline: none;
}
.feedback_modal .feedback_text_area textarea::-moz-placeholder {
  color: #979797;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 18px;
}
.feedback_modal .feedback_text_area textarea::placeholder {
  color: #979797;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22px;
  line-height: 18px;
}
.feedback_modal .error__feedback {
  margin-top: 15px;
  color: red;
  font-size: 14px;
  margin-left: 40px;
}
.feedback_modal .feedaback_submit_button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 26px;
}
.feedback_modal .feedaback_submit_button button {
  border-radius: 10px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  padding: 19px 69px;
  border: none;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
}

.black__out {
  background-color: transparent;
}

.notification_card_wrapper {
  padding: 22px 20px;
  border-radius: 5px;
  margin-bottom: 16px;
}
.notification_card_wrapper .card_title {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
  line-break: anywhere;
}
.notification_card_wrapper .icon_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border: 1px solid; */
  background: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
.notification_card_wrapper .notification_time {
  color: #878383;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 12px;
  text-align: right;
}

.no-new-notification {
  display: block;
  text-align: center;
  padding: 22px 0;
  color: #212121;
}

.purple {
  background-color: #ecf3fe;
}

.yellow {
  background-color: #fff8dd;
}

.green {
  background-color: #ecfeee;
}

.pink {
  background-color: #feecec;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading::after {
  content: '';
  width: 50px;
  height: 50px;
  border: 6px solid #dddddd;
  border-top-color: #ff6633;
  border-bottom-color: #ff6633;
  animation: loading 0.8s linear infinite;
  border-radius: 50%;
}

@keyframes loading {
  to {
    transform: rotate(1turn);
  }
}
.loading__wrapper {
  margin-top: 20vh;
  margin-bottom: 20vh;
}

.loader__container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader__container span {
  width: 12px;
  height: 12px;
  background-color: #f7fafc;
  margin-left: 1px;
  border-radius: 50%;
  animation: load 2.5s both infinite;
}
.loader__container span:nth-child(1) {
  animation-delay: 0s;
}
.loader__container span:nth-child(2) {
  animation-delay: 0.25s;
}
.loader__container span:nth-child(3) {
  animation-delay: 0.5s;
}
.loader__container span:nth-child(4) {
  animation-delay: 0.75s;
}

.loader-item {
  width: 100%;
  height: 20px;
  margin-bottom: 10px;
  background-color: #f2f2f2;
  animation: loader 1s infinite ease-in-out, blink 1s infinite;
}

.loader__orange {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader__orange span {
  width: 12px;
  height: 12px;
  background-color: #ff6633;
  margin-left: 1px;
  border-radius: 50%;
  animation: load 2.5s both infinite;
}
.loader__orange span:nth-child(1) {
  animation-delay: 0s;
}
.loader__orange span:nth-child(2) {
  animation-delay: 0.25s;
}
.loader__orange span:nth-child(3) {
  animation-delay: 0.5s;
}
.loader__orange span:nth-child(4) {
  animation-delay: 0.75s;
}

@keyframes load {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(0.8);
  }
}
@keyframes loader {
  0% {
    opacity: 0.2;
    transform: translateY(0);
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.2;
    transform: translateY(0);
  }
}
.loading_card {
  width: 100%;
  height: 180px;
  background-color: #bab8b0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  animation: skeletonAnimation 1s infinite;
  margin-bottom: 10px;
  border: none;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.loading_card-content {
  padding: 20px;
}

.user_card--wrapper {
  width: 100%;
  height: 100%;
  background-color: #bab8b0;
  border-radius: 14px;
  animation: skeletonAnimation 1s infinite;
}

.nav_card--wrapper {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #bab8b0;
  border-radius: 10px;
  animation: skeletonAnimation 1s infinite;
}

@keyframes skeletonAnimation {
  0% {
    opacity: 0.2;
    transform: translateY(0);
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.2;
    transform: translateY(0);
  }
}
.infinte_scroll-wrapper .infinite-scroll-component {
  overflow: hidden !important;
}

.congratulation_card {
  background-color: rgb(241, 236, 236);
  width: 100%;
  height: 100vh;
  padding: 40px;
}
.congratulation_card .score_card_wrapper {
  border-radius: 20px;
  background-color: #f8f8f8;
}
.congratulation_card .score_heading {
  flex-direction: column;
}
.congratulation_card .score_title {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.36;
  line-height: 26px;
  text-align: center;
}
.congratulation_card .trophy_img {
  width: 384px;
  height: 240px;
}
.congratulation_card .aware_level {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  text-align: center;
  margin-bottom: 48px;
  margin-top: 30px;
}
.congratulation_card .aware_level span {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.congratulation_card .learn-score-text {
  color: #212121;
  font-family: Roboto;
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 0.62px;
  line-height: 34px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.congratulation_card .score-txt {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  text-align: center;
}
.congratulation_card .score-txt-md {
  color: #212121;
  font-family: Roboto;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0.4px;
  line-height: 28px;
  text-align: center;
}
.congratulation_card .continue_exploring {
  width: 354px;
  border-radius: 10px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  border: none;
  height: 50px;
}
.congratulation_card .view_leaderboard_learn {
  background: -webkit-linear-gradient(#eee, #333) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.congratulation_card .view_leaderboard_learn {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 12px;
  background: none;
  border: none;
  padding-bottom: 64px;
}

.logout_modal {
  height: auto;
  width: 50%;
  border-radius: 20px;
  background-color: #ffffff;
  position: relative;
  top: 200px;
  margin: auto;
}
.logout_modal .logout_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 85px;
}
.logout_modal .logout_header_name {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  text-align: center;
  color: #212121;
  font-family: Roboto;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
}
.logout_modal .logout_button_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 80px;
}
.logout_modal .logout_button_wrapper .outlined__button {
  height: 52px;
  width: 30%;
  border-radius: 10px;
  background-color: #ffffff;
  margin: 10px;
  border: 2px solid #ff6633;
  color: #ff6633;
}
.logout_modal .logout_button_wrapper .filled__button {
  height: 52px;
  width: 30%;
  border-radius: 10px;
  background: linear-gradient(169.56deg, #ff6633 0%, #de5020 100%);
  color: #ffffff;
  border: none;
}

.avatar__selection-modal {
  height: auto;
  width: 50%;
  border-radius: 20px;
  background-color: #ffffff;
  position: relative;
  top: 200px;
  margin: auto;
}
@media (max-width: 999px) {
  .avatar__selection-modal {
    width: 80%;
  }
}
@media (min-width: 1001px) and (max-width: 1366px) {
  .avatar__selection-modal {
    width: 70%;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  .avatar__selection-modal {
    width: 60%;
  }
}
.avatar__selection-modal .avatar__selection-wrapper {
  padding: 50px;
}
.avatar__selection-modal .avatar__selection-wrapper .avatar__selection-header {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
  color: #212121;
}
.avatar__selection-modal .avatar__selection-wrapper .avatar__pics-section {
  margin-top: 50px;
  margin-bottom: 50px;
  max-height: 250px;
  overflow-y: auto;
}
.avatar__selection-modal
  .avatar__selection-wrapper
  .avatar__pics-section
  .images__avatar {
  position: relative;
  display: inline-block;
  background-color: transparent;
  border: none;
}
.avatar__selection-modal
  .avatar__selection-wrapper
  .avatar__pics-section
  .images__avatar
  .avatars_image {
  width: 80px;
  height: 80px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-right: 20px;
  margin-bottom: 20px;
  border-radius: 50%;
  background-color: #f4f4f4;
}
.avatar__selection-modal
  .avatar__selection-wrapper
  .avatar__pics-section
  .images__avatar
  .avatars_image--img {
  width: 50px;
  height: 50px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 15px;
}
.avatar__selection-modal
  .avatar__selection-wrapper
  .avatar__pics-section
  .images__avatar
  .selection_tick {
  position: absolute;
  top: 0px;
  right: 20px;
}
.avatar__selection-modal .avatar__selection-wrapper .button__container {
  margin-top: 30px;
}
.avatar__selection-modal .avatar__selection-wrapper .outlined__button {
  width: 100%;
  position: relative;
  padding-top: 19px;
  padding-bottom: 19px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #ff6633;
  color: #ff6633;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
}
.avatar__selection-modal
  .avatar__selection-wrapper
  .outlined__button
  .file_input {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.avatar__selection-modal .avatar__selection-wrapper .filled__button {
  width: 100%;
  padding-top: 19px;
  padding-bottom: 19px;
  border-radius: 10px;
  background-color: #ff6633;
  border: 1px solid #ff6633;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
}

.image_loader {
  width: 76px;
  height: 76px;
  margin-right: 30px;
  margin-bottom: 20px;
  border: none;
  border-radius: 50%;
  animation: blink 1s infinite alternate;
}

.orange__bg {
  background: linear-gradient(180deg, #fc7c3a 0%, #ffbe96 100%);
  box-shadow: 0 13px 16px 0 rgba(236, 91, 15, 0.3);
}

.pink__bg {
  background: linear-gradient(
    180deg,
    rgba(255, 140, 217, 0.3) 0%,
    #ffdef6 100%
  );
  box-shadow: 0 13px 16px 0 rgba(181, 64, 142, 0.3);
}

.yellow__bg {
  background: linear-gradient(180deg, #f9c94e 0%, #fbe1c8 100%);
  box-shadow: 0 13px 16px 0 rgba(166, 131, 42, 0.3);
}

.blue__bg {
  background: linear-gradient(180deg, #894ef9 0%, #bdc7fb 100%);
  box-shadow: 0 13px 16px 0 rgba(140, 84, 249, 0.31);
}

@keyframes blink {
  0% {
    background-color: hsl(200, 20%, 70%);
  }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
}
.privacy_terms_wrapper {
  margin: 100px;
}
.privacy_terms_wrapper .title_date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(151, 151, 151, 0.35);
  padding-bottom: 49px;
  margin-bottom: 49px;
}
.privacy_terms_wrapper .title_date .title {
  color: #212121;
  font-family: Roboto;
  font-size: 50px;
  font-weight: bold;
  letter-spacing: 0px;
  line-height: 50px;
}
.privacy_terms_wrapper .title_date .date {
  color: #000000;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 14px;
}
.privacy_terms_wrapper .privacy_terms_content {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
}
.privacy_terms_wrapper .privacy_terms_content ul {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
}
.privacy_terms_wrapper .privacy_terms_content .filled__circle {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
  list-style: disc outside none;
}
.privacy_terms_wrapper .privacy_terms_content .empty__circle {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
  list-style: circle outside none;
}
.privacy_terms_wrapper .privacy_terms_content .square__circle {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
  list-style: square outside none;
}
.privacy_terms_wrapper .privacy_terms_heading {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0px;
  line-height: 23px;
  padding-bottom: 16px;
  margin-top: 16px;
}
.privacy_terms_wrapper .privacy_terms_subheading {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  padding-bottom: 40px;
}

.privacy__header {
  color: #212121;
  font-family: Roboto;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 24px;
  margin-bottom: 20px;
}

.privacy__paragraph {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  margin-bottom: 10px;
}
.privacy__paragraph b {
  color: #212121;
}

.privacy__points {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  list-style: disc outside none;
}

.privacy__anchor-link {
  color: blue;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 28px;
}
.privacy__anchor-link span {
  color: blue;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 28px;
  cursor: pointer;
}
.privacy__anchor-link span:hover {
  text-decoration: underline;
}

.privacy__normal__points {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
}
.privacy__normal__points b {
  color: #212121;
}

.welcome__header {
  color: #212121;
  font-family: Roboto;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
}

.welcome__note {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
}

.section__container {
  margin-top: 32px;
}

a {
  cursor: pointer;
}

.privacy__address {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 10px;
}
.privacy__address b {
  color: #212121;
}
.privacy__address a {
  color: blue !important;
  color: blue;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 10px;
}

.table__container {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 20px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.table__container th {
  padding: 15px;
  color: #212121 !important;
}
.table__container td {
  padding: 15px;
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
}

.ml-toast_container {
  width: auto !important;
  color: #ffffff !important;
}
.ml-toast_container .Toastify__toast--default {
  padding: 1.5rem 0.5rem !important;
  padding-right: 1.5rem !important;
  border: 1px solid #979797;
  border-radius: 10px;
  background-color: #0e3a5e;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 22px;
}
.ml-toast_container .Toastify__close-button {
  color: #ffffff !important;
  align-self: center;
  opacity: 1;
}

.Toastify {
  color: #ffffff !important;
}
.Toastify span {
  padding-left: 10px;
  color: #ffffff !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 350px;
}
.Toastify button {
  color: #ffffff !important;
}
.Toastify button svg {
  fill: #ffffff !important;
}
.Toastify .Toastify__toast-container {
  color: #ffffff !important;
}

.badges__heading {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
}

.badges__wrapper {
  display: flex;
  align-items: center;
}

.badges__image {
  animation: cardfade 0.5s ease-in-out;
}

.imageShade {
  opacity: 1;
  animation: imageFade 0.5s ease-in-out;
}

.badges__count {
  color: #838282;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -1px;
  line-height: 18px;
  margin-left: 6px;
}

.badges__title {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 18px;
}

.badges__tagline {
  color: #6f6f6f;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
}

@keyframes imageFade {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.max__profile-tab-card-container .details-card {
  overflow-y: scroll;
  max-height: 80vh;
  padding: 30px;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
}

.analytics__header {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 22px;
}

.analytics__topicheader {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 16px;
  margin-bottom: 15px;
}

.performance__card {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 18px;
  cursor: pointer;
}
.performance__card__content .performance__card__details {
  padding: 24px 26px 20px 20px;
}
.performance__card__title {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 22px;
  margin-top: 18px;
  word-break: break-all;
}
.performance__card__description {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
}
.performance__card__description .challenge__history {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 12px;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.performance__card__footer {
  position: relative;
  background-color: rgba(255, 177, 71, 0.25);
  border-radius: 0 0 8px 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 20px;
  padding-right: 30px;
}
.performance__card__footer p {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.22px;
  line-height: 12px;
  margin-bottom: 0px;
}
.performance__card__footer p .image__icon {
  width: 12px;
  height: 12px;
}
.performance__card__footer p .image__icon svg {
  margin-bottom: 3px;
}
.performance__card__footer .performance__points {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.22px;
  line-height: 12px;
}
.performance__card__footer .performance__points small {
  color: #212121;
}
.performance__card__footer-star {
  position: absolute;
  top: 0px;
  right: 0px;
}

.analytics__wrapper {
  padding: 24px 12px 24px 20px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 18px;
  border: none;
  text-align: left;
  display: block;
  width: 100%;
}
.analytics__wrapper .analytics__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.analytics__wrapper .analytics__container h2 {
  width: 80%;
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 22px;
  margin-bottom: 0px;
}

.analytics__modal {
  background-color: #ffffff;
  width: 82%;
  border-radius: 20px;
}
.analytics__modal .analytics__container {
  background-color: #ffffff;
  border-radius: 20px;
}
.analytics__modal .analytics__container .analytics__header {
  border-radius: 20px 20px 0 0;
  background-color: #f8f8f8;
  padding: 25px 32px 25px 32px;
}
.analytics__modal .analytics__container .analytics__header .learn__text {
  color: #999999;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16px;
}
.analytics__modal .analytics__container .analytics__header .topic__text {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 26px;
}
.analytics__modal .analytics__container .analytics__body {
  border-radius: 0 0 20px 20px;
  background-color: #ffffff;
  padding: 32px;
}
.analytics__modal .analytics__container .analytics__body .analytics__content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  -moz-column-gap: 19px;
  column-gap: 19px;
}

.level__container {
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}

.level__header {
  border-radius: 10px 10px 0 0;
  padding: 16px;
}

.level__header-head {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 22px;
  text-transform: capitalize;
  margin-bottom: 17px;
}

.level-subtext {
  color: #606060;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16px;
  margin-top: 8px;
}

.level__subtext {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 17px;
}

.level__completed {
  margin-top: 15px;
}
.level__completed p {
  margin-bottom: 9px;
}
.level__completed svg {
  margin-right: 5px;
}

.level__active {
  color: #67b031;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16px;
}

.level__inactive {
  color: #939498;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16px;
}

.level__body {
  padding: 20px 8px 20px 8px;
  border-radius: 0px 0px 10px 10px;
}
.level__body .learning__chart .chart__header {
  color: #858585;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 20px;
}

.awareness {
  background-color: rgba(235, 145, 8, 0.07);
}

.awareness__text {
  color: #eb9108;
  color: #eb9108;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 17px;
}

.awareness__graph {
  border-radius: 10px;
  background-color: rgba(235, 145, 8, 0.03);
}

.explanatory {
  background-color: rgba(97, 162, 238, 0.07);
}

.explanatory__text {
  color: #61a2ee;
  color: #61a2ee;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 17px;
}

.explanatory__graph {
  background-color: rgba(97, 162, 238, 0.03);
}

.practioner {
  background-color: rgba(178, 88, 167, 0.07);
}

.practioner__text {
  color: #b258a7;
  color: #b258a7;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 17px;
}

.practioner__graph {
  background-color: rgba(178, 88, 167, 0.03);
}

.auto__center {
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  bottom: 0;
}

.x_axis__title {
  font-size: 12px !important;
  font-family: 'Roboto';
  font-weight: 400;
}

.y_axis__title {
  color: rgba(147, 148, 152, 0.5);
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
}

.y_axis__text {
  color: rgba(34, 37, 43, 0.6);
  font-size: 12px;
  font-family: 'Roboto';
  font-weight: 600;
}

.custom_tooltip {
  border-radius: 4px !important;
  min-width: 150px !important;
  min-height: 80px !important;
  border: 1px solid #eb9108;
  background-color: #fefbf7;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.28);
  padding: 13px 15px 21px 12px;
}
.custom_tooltip .custom__tooltip-title {
  margin-bottom: 7px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}
.custom_tooltip .custom__tooltip-subheader {
  color: #212121;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  margin-bottom: 2px;
}
.custom_tooltip .custom__tooltip-content {
  color: #212121;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
  margin-bottom: 0px;
}

.Unrealized_Potential {
  color: #f58222;
  margin-bottom: 7px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}

.inflight {
  color: #044578;
  margin-bottom: 7px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}

.pro {
  color: #3a9e9e;
  margin-bottom: 7px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}

.graduated {
  color: #7bd2d1;
  margin-bottom: 7px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}

.legend__wrapper {
  margin-bottom: 0px;
  padding-left: 0px;
}
.legend__wrapper li {
  display: inline;
  list-style: none;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  margin-right: 10px;
}
.legend__wrapper span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.Unrealized {
  color: #f58222;
}

.Unrealized_bg {
  background-color: #f58222;
}

.InFlight {
  color: #044578;
}

.InFlight_bg {
  background-color: #044578;
}

.Graduted {
  color: #3a9e9e;
}

.Graduted_bg {
  background-color: #3a9e9e;
}

.Pro {
  color: #7bd2d1;
}

.Pro_bg {
  background-color: #7bd2d1;
}

.empty__wrapper {
  overflow: hidden;
  position: relative;
  border-radius: 8px;
}
.empty__wrapper .empty__home {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
  height: 300px;
}
.empty__wrapper .empty__home--wrapper {
  max-width: 320px;
  text-align: center;
}
.empty__wrapper .empty__home .empty__home--text {
  margin-top: 27px;
}
.empty__wrapper .empty__home .empty__home--text_header {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-bottom: 8px;
}
.empty__wrapper .empty__home .empty__home--text_subHeader {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
}
.empty__wrapper .empty__circle {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 83px;
  height: 83px;
  border-radius: 50%;
  background-color: rgba(231, 241, 251, 0.5);
}

.empty__squadChallenge {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
}
.empty__squadChallenge-wrapper {
  text-align: center;
}
.empty__squadChallenge-wrapper .empty__squadChallenge-text {
  margin-top: 40px;
}
.empty__squadChallenge-wrapper .empty__squadChallenge-text-header {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 8px;
  text-align: center;
}
.empty__squadChallenge-wrapper .empty__squadChallenge-text-subHeader {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 16px;
  max-width: 250px;
  text-align: center;
  margin: auto;
}

.category__empty__squadChallenge {
  height: 450px;
}

.empty__card {
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.03);
}
.empty__card__title {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
}
.empty__card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
}
.empty__card-action {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
}
.empty__card .empty__card-wrapper {
  text-align: center;
}
.empty__card .empty__card-wrapper .empty__card-text {
  margin-top: 40px;
  text-align: center;
}
.empty__card .empty__card-wrapper .empty__card-text .empty__card__header {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 6px;
}
.empty__card .empty__card-wrapper .empty__card-text .empty__card__subHeader {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 16px;
  width: 320px;
  margin: auto;
}

.empty__search {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 240px;
}
.empty__search .empty__search_wrapper {
  text-align: center;
}
.empty__search .empty__search_wrapper .empty__search_content {
  margin-top: 16px;
}
.empty__search .empty__search_wrapper .empty__search_content h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
}
.empty__search .empty__search_wrapper .empty__search_content p {
  margin-top: 8px;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 16px;
  max-width: 280px;
}

.max__learn-quest-detail-wrapper {
  min-height: 100vh;
  background-color: #f8f8f8 !important;
}
.max__learn-quest-detail-wrapper h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 26px;
  text-align: start;
  position: relative;
  z-index: 10;
}
.max__learn-quest-detail-wrapper h3 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  text-align: start;
}
.max__learn-quest-detail-wrapper h4 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  text-align: start;
}
.max__learn-quest-detail-wrapper .text-breadcrums-small {
  color: #999999;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 13px;
  margin: 0 8px 0 0;
}
.max__learn-quest-detail-wrapper .text-breadcrums-strong {
  color: #212121;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 13px;
  margin: 0 0 0 8px;
}
.max__learn-quest-detail-wrapper .text-breadcrums-container {
  margin-top: 35px;
  margin-bottom: 10px;
}
.max__learn-quest-detail-wrapper p {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  z-index: 10;
}
.max__learn-quest-detail-wrapper .card-text {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  font-style: italic;
  margin-bottom: 0;
}
.max__learn-quest-detail-wrapper .text-card-time {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  font-style: italic;
  margin-bottom: 5px;
  text-align: right;
}
.max__learn-quest-detail-wrapper .text-card-time strong {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14px;
  font-style: italic;
}
.max__learn-quest-detail-wrapper .inprogress {
  padding: 6px 13px;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  border-radius: 12px;
  background-color: #fff8dd;
}
.max__learn-quest-detail-wrapper .yet-to-start {
  padding: 6px 13px;
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  border-radius: 12px;
  background-color: #fafafc;
}
.max__learn-quest-detail-wrapper .text-overflow-h4 {
  overflow: hidden;
  height: 60px;
}
.max__learn-quest-detail-wrapper .ml__quest-details-card-section {
  overflow: hidden;
  overflow-y: scroll;
}
.max__learn-quest-detail-wrapper .max__learn-quest-container {
  margin-top: 35pxmax__learn-quest-detail-wrapper;
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .max_quest-wrapper {
  margin: 0;
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .max_quest-wrapper
  .max_quest_card {
  height: 100%;
  min-height: 200px;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 1.25rem;
}
@media (max-width: 992px) {
  .max__learn-quest-detail-wrapper
    .max__learn-quest-container
    div
    .max_quest-wrapper
    .max_quest_card {
    width: 100%;
  }
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .max_quest-wrapper
  .max_quest_card
  .max__quest-container {
  background-color: #fff8dd;
  height: 100%;
  position: relative;
  padding: 1.25rem;
  overflow: hidden;
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .max_quest-wrapper
  .max_quest_card
  .max__quest-container
  .max__quest-theme-ovel {
  border-radius: 100px;
  height: 140px;
  width: 140px;
  background-color: #f4e396;
  opacity: 0.5;
  position: absolute;
  top: -50px;
  right: -40px;
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .max_quest-wrapper
  .max_quest_card
  .max__quest-container
  .description {
  min-height: 100px;
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .ml__quest-card {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 16px;
}
.max__learn-quest-detail-wrapper
  .max__learn-quest-container
  div
  .ml__quest-card
  .inner-section {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: #fff8dd;
  padding: 30px 20px;
}

.ml__quest-detail-container {
  margin-top: 160px;
}

.max__learn-quest-listing-card {
  border: none;
  outline: none;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  width: 100%;
}

.completed {
  background-color: #ecfeee !important;
}

.yet_to_start {
  border-radius: 10px;
  background-color: #f3f2f5;
  box-shadow: none !important;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
}

.in_progress {
  background-color: #ffffff !important;
}

.active-now {
  background-color: #ffffff !important;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1) !important;
}

.max__learn-quest-listing-card-count {
  position: absolute;
  right: 0;
  bottom: 0;
}
.max__learn-quest-listing-card-count
  .flash-card-wrapper-h
  .flash-card-wrapper
  .swiper-slide {
  height: 65vh !important;
}
.max__learn-quest-listing-card-count .completed {
  background: #d3f7d7 !important;
  border-radius: 20px 0 10px;
}
.max__learn-quest-listing-card-count .completed p {
  margin: 0 !important;
  padding: 10px 15px !important;
  color: #afafaf;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 22px;
}
.max__learn-quest-listing-card-count .yet_to_start {
  background: #e5e5e5 !important;
  border-radius: 20px 0 10px;
}
.max__learn-quest-listing-card-count .yet_to_start .start-text {
  color: #212121;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  background-color: #fafafc;
  padding: 10px;
}
.max__learn-quest-listing-card-count .yet_to_start p {
  margin: 0 !important;
  padding: 10px 15px !important;
  color: #afafaf;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 22px;
}
.max__learn-quest-listing-card-count .in_progress {
  background: #f3f2f5 !important;
  border-radius: 20px 0 10px;
}
.max__learn-quest-listing-card-count .in_progress p {
  margin: 0 !important;
  padding: 10px 15px !important;
  color: #afafaf;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 22px;
}
.max__learn-quest-listing-card-count .active-now {
  background: #fff !important;
  border-radius: 20px 0 10px;
}
.max__learn-quest-listing-card-count .active-now p {
  margin: 0 !important;
  padding: 10px 15px !important;
  color: #afafaf;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 22px;
}

.start-upc-user-name {
  color: #9d9d9d;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
}

.start-upc-txt {
  color: #212121;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
}

.start-upc-date {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 12px;
}

.start-upc-desc {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}

.text-report-quest {
  font-size: 16px;
  font-weight: 600;
  text-decoration: underline;
  color: #0e3a5e;
  cursor: pointer;
}

body {
  background-color: #7bbac9;
}
body .ml__flash-card-container {
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin: 50px auto 0;
  width: 100%;
  height: 500px;
}
body .ml__flash-card-container .controls {
  display: flex;
  justify-content: center;
}
body .ml__flash-card-container .controls div {
  padding: 12px 14px;
  cursor: pointer;
  border: 1px solid #fff;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  margin: 0 5px;
  border-radius: 10px;
}
body .ml__flash-card-container .controls div.disabled {
  opacity: 0;
  cursor: default;
}
body .ml__flash-card-container .slider {
  position: relative;
  width: 100%;
  height: 100%;
}
body .ml__flash-card-container .slider .slide {
  position: absolute;
  top: 25%;
  left: 10%;
  width: 80%;
  height: 50%;
  background-color: red;
  border: 1px solid #fff;
  border-radius: 15px;
  opacity: 0;
  transition: all 0.7s ease-out;
  display: flex;
  align-items: end;
  justify-content: end;
  padding: 35px;
}
body .ml__flash-card-container .slider .slide--active {
  opacity: 1;
  z-index: 9;
}
body .ml__flash-card-container .slider .slide:nth-child(n-3) {
  transform: translate(0, -10%) scale(2);
  opacity: 0.9;
}
body .ml__flash-card-container .slider .slide:nth-child(n) {
  transform: translate(0, -10%) scale(0.8);
  opacity: 0.8;
}
body .ml__flash-card-container .slider .slide:nth-child(n) {
  transform: translate(0, -10%) scale(0.7);
  opacity: 0.7;
}
body .ml__flash-card-container .slider .prev,
body .ml__flash-card-container .slider .next {
  opacity: 0.3;
} /*# sourceMappingURL=styles.css.map */
`, "",{"version":3,"sources":["webpack://./src/styles/styles.scss","webpack://./src/styles/variables/_variables.scss","webpack://./src/styles/styles.css","webpack://./src/styles/home/index.scss","webpack://./src/styles/home/home.scss","webpack://./src/styles/common/_mixin.scss","webpack://./src/styles/home/login.scss","webpack://./src/styles/responsive/breakpoints.scss","webpack://./src/styles/header/navbar.scss","webpack://./src/styles/common/_button.scss","webpack://./src/styles/home/user.scss","webpack://./src/styles/home/challenges.scss","webpack://./src/styles/home/badge.scss","webpack://./src/styles/home/quest.scss","webpack://./src/styles/common/siderbar.scss","webpack://./src/styles/common/footer.scss","webpack://./src/styles/learn/learn.scss","webpack://./src/styles/learn/learn-head.scss","webpack://./src/styles/learn/learning.scss","webpack://./src/styles/learn/category.scss","webpack://./src/styles/todo/todo.scss","webpack://./src/styles/todo/activities.scss","webpack://./src/styles/todo/activitylog.scss","webpack://./src/styles/todo/quest-cert.scss","webpack://./src/styles/ranking/ranking.scss","webpack://./src/styles/common/notifications.scss","webpack://./src/styles/common/help/help.scss","webpack://./src/styles/profile/profile.scss","webpack://./src/styles/profile/_avatar.scss","webpack://./src/styles/profile/_overall.scss","webpack://./src/styles/profile/_profiletab.scss","webpack://./src/styles/profile/_profile-accordion.scss","webpack://./src/styles/questions/detailCard.scss","webpack://./src/styles/common/buttons/buttons.scss","webpack://./src/styles/abstaracts/_variable.scss","webpack://./src/styles/Challenges/challenges-completed.scss","webpack://./src/styles/common/accordian.scss","webpack://./src/styles/modals/_userDetailsEdit.scss","webpack://./src/styles/modals/index.scss","webpack://./src/styles/common/chip.scss","webpack://./src/styles/common/avatar.scss","webpack://./src/styles/profile/your-squad.scss","webpack://./src/styles/reusableClasses/index.scss","webpack://./src/styles/learn/modalLearningCard.scss","webpack://./src/styles/learn/topicsModalCard.scss","webpack://./src/styles/learn/detailCategory.scss","webpack://./src/styles/learn/topicCard.scss","webpack://./src/styles/learn/flashCard.scss","webpack://./src/styles/common/modal/sidebar-modal.scss","webpack://./src/styles/questions/feedback-modal.scss","webpack://./src/styles/common/modal/notification-modal_card.scss","webpack://./src/styles/common/loading.scss","webpack://./src/styles/common/pagination.scss","webpack://./src/styles/learn/score.scss","webpack://./src/styles/common/modal/logout-modal.scss","webpack://./src/styles/profile/avatar-modal.scss","webpack://./src/styles/common/terms_and_privacy.scss","webpack://./src/styles/common/toastify.scss","webpack://./src/styles/profile/badges.scss","webpack://./src/styles/profile/analyics.scss","webpack://./src/styles/common/emptyscreens.scss","webpack://./src/styles/quests/quests.scss","webpack://./src/styles/quests/flashCard.scss"],"names":[],"mappings":"AAAA;;CAAA;ACwBE;EACE,aAAA;AClBJ;;ADqBE;EACE,iBAAA;AClBJ;;ADqBE;EACE,gBAAA;AClBJ;;ADqBE;EACE,iBAAA;AClBJ;;ADqBE;EACE,kBAAA;AClBJ;;ADCE;EACE,aAAA;ACEJ;;ADCE;EACE,iBAAA;ACEJ;;ADCE;EACE,gBAAA;ACEJ;;ADCE;EACE,iBAAA;ACEJ;;ADCE;EACE,kBAAA;ACEJ;;ADnBE;EACE,aAAA;ACsBJ;;ADnBE;EACE,iBAAA;ACsBJ;;ADnBE;EACE,gBAAA;ACsBJ;;ADnBE;EACE,iBAAA;ACsBJ;;ADnBE;EACE,kBAAA;ACsBJ;;ADvCE;EACE,aAAA;AC0CJ;;ADvCE;EACE,iBAAA;AC0CJ;;ADvCE;EACE,gBAAA;AC0CJ;;ADvCE;EACE,iBAAA;AC0CJ;;ADvCE;EACE,kBAAA;AC0CJ;;AD3DE;EACE,aAAA;AC8DJ;;AD3DE;EACE,iBAAA;AC8DJ;;AD3DE;EACE,gBAAA;AC8DJ;;AD3DE;EACE,iBAAA;AC8DJ;;AD3DE;EACE,kBAAA;AC8DJ;;AD/EE;EACE,aAAA;ACkFJ;;AD/EE;EACE,iBAAA;ACkFJ;;AD/EE;EACE,gBAAA;ACkFJ;;AD/EE;EACE,iBAAA;ACkFJ;;AD/EE;EACE,kBAAA;ACkFJ;;ADnGE;EACE,aAAA;ACsGJ;;ADnGE;EACE,iBAAA;ACsGJ;;ADnGE;EACE,gBAAA;ACsGJ;;ADnGE;EACE,iBAAA;ACsGJ;;ADnGE;EACE,kBAAA;ACsGJ;;ADvHE;EACE,aAAA;AC0HJ;;ADvHE;EACE,iBAAA;AC0HJ;;ADvHE;EACE,gBAAA;AC0HJ;;ADvHE;EACE,iBAAA;AC0HJ;;ADvHE;EACE,kBAAA;AC0HJ;;AD3IE;EACE,aAAA;AC8IJ;;AD3IE;EACE,iBAAA;AC8IJ;;AD3IE;EACE,gBAAA;AC8IJ;;AD3IE;EACE,iBAAA;AC8IJ;;AD3IE;EACE,kBAAA;AC8IJ;;AD/JE;EACE,cAAA;ACkKJ;;AD/JE;EACE,kBAAA;ACkKJ;;AD/JE;EACE,iBAAA;ACkKJ;;AD/JE;EACE,kBAAA;ACkKJ;;AD/JE;EACE,mBAAA;ACkKJ;;ADlIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACqIF;;ADlIA;EACE,gCAAA;ACqIF;;ACrNA;;;;;CAAA;ACAA;;CAAA;AAIA;EACE,yBHHgB;ACgOlB;AEtNA;EACE,aAAA;AFwNF;;AErNE;ECPA,YDSgB;ECRhB,WDQsB;ECPtB,sBDO4B;ECN5B,yBJTmB;EGgBjB,oCAAA;EACA,6CAAA;EACA,sBAAA;AF0NJ;AEtNI;EACE,WAAA;EACA,yIAAA;EAEA,qBAAA;EACA,4BAAA;EACA,kBAAA;AFuNN;AEtNM;EAPF;IAQI,kBAAA;EFyNN;AACF;AEvNQ;;;;;ECTN,cAAA;EACA,mBDUyD;EACjD,eAAA;EF6NV,gBAAA;EE3NQ,sBAAA;EClBN,iBJtBc;EIuBd,gCAAA;AHgPF;AACA;;;;;EGlPE,cJtBc;EIuBd,mBAAA;EACA,eDmBwC;EClBxC,gBDkB8C;ECjB9C,sBDiBmD;EChBnD,iBDgB2D;AFwO7D;AACA;;;;;;EEhOQ,cAAA;EC9BN,mBJtBc;EIuBd,eAAA;EACA,gBD6BsC;EC5BtC,sBD4B4C;EC3B5C,iBAAA;EACA,cAAA;AHsQF;AACA;;;;;EAKE,WAAW;EEjJb,YAAA;EACE,0CAAA;AFmJF;AACA;;;;;EE9IA,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EFoJA,sBEpJA;EACA,iBAAA;AFmJF;;AEhJA;EACE,gBAAA;EACA,aAAA;AFqJF;;AAEA;EAFA,YAAA;EAIE,WAAW;EEpJb,oBAAA;EACE,iBAAA;EACA,kBAAA;AFsJF;;AAEA;EAHA,YAAA;EAKE,WAAW;EEpJX,oBAAA;EACE,iBAAA;EFkJJ,kBAAA;AAKA;;AAEA;EEjJM,YAAA;EACA,WAAA;EACA,oBAAA;EF+IN,iBAAA;EE7IQ,kBAAA;AFmJR;;AAFA;EAKE,YAAY;EIvVd,WAAA;EACE,oBAAA;EACA,iBAAA;EACA,kBAAA;AJyVF;;AAFA;EIpVE,aAAA;AJ0VF;;AAEA;EIxVI,WAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;AJsVJ;AIpVE;EAEE,WAAA;EACA,YAAA;AJyVJ;;AAEA;EIvVI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AJyVJ;AACA;EIvVI,kBAAA;EACA,WAAA;EJqVJ,eAAA;EAKE,gBAAgB;EItVlB,uBAAA;EACE,kCAAA;EACA,mBAAA;AJwVF;AACA;EIvVE,iBAAA;EACA,eAAA;EACA,mBAAA;EJoVF,kBAAA;EAME,yBAAyB;EIxV3B,gDAAA;EACE,WAAA;EAEA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;AJyVF;;AAEA;EIrVA,gHAAA;EACE,4BAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AJuVF;;AAEA;EItVA,UAAA;EACE,YAAA;EJmVF,kBAAA;EAME,sBAAsB;EIvVxB,yBAAA;EACE,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,iBAAA;AJyVF;;AAEA;EIvVE,cAAA;EACA,mBAAA;EACA,eAAA;EJoVF,iBAAA;EAME,iBAAiB;EIxVnB,iBAAA;EACE,mBAAA;AJ0VF;;AAHA;EAME,aAAa;AIzVf;;AJ4VA;EIzVE,aAAA;EJsVF,mBAAA;EAME,uBAAuB;EIzVvB,cAAA;EJ2VA,mBAAmB;EACnB,eAAe;EIzVb,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AJ2VJ;;AAEA;EAJA,YAAA;EAME,gBAAgB;EIzVlB,eAAA;AJ2VA;;AAEA;EI1VA,kBAAA;EACE,mBAAA;EACA,gBAAA;AJ4VF;;AAEA;;;EIxVE,8CAAA;EJuVF,cAAA;EItVE,mBAAA;EACE,eAAA;EJwVJ,gBAAA;EItVE,iBAAA;EACE,iBAAA;AJwVJ;;AInVA;EACE,gBAAA;AJsVF;;AInVA;EACE,sBAAA;EJsVF,YAAA;EAME,gCAAgC;EI1VlC,aAAA;EACE,WAAA;EJuVF,oBAAA;EAME,wCAAwC;EI1V1C,gBAAA;AJ4VA;AAJA;EAME,uDAAuD;AI1VzD;AJ4VA;EAJA,uDAAA;AAMA;;AAEA;EI3VE,uDAAA;AJ6VF;;AAEA;EI3VE,uDAAA;AJ6VF;;AAHA;EAME,iBAAiB;AI5VnB;;AJ+VA;EI5VE,iBAAA;AJ8VF;;AAEA;EI5VE,iBAAA;AJ8VF;;AAEA;EI5VE,sBAAA;EACA,YAAA;EJyVF,gCAAA;EAME,aAAa;EI7Vf,WAAA;EACE,oBAAA;EACA,wCAAA;EACA,gBAAA;AJ+VF;;AAEA;EI7VE,kBAAA;EACA,gEAAA;EJ0VF,WAAA;EIzVE,YAAA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EJ2VJ,wBAAA;AIzVE;;AJ4VF;EAME,cAAc;EI7VhB,mBAAA;EACE,eAAA;EACA,gBAAA;EJ0VF,iBAAA;EAME,iBAAiB;EI9VnB,kBAAA;EACE,iBAAA;AJgWF;AACA;EI9VE,cAAA;EACA,mBAAA;EACA,eAAA;EAEA,gBAAA;EJ0VF,iBAAA;EAME,iBAAiB;EI9VnB,kBAAA;AJgWA;AACA;EI9VE,cAAA;AJgWF;;AAEA;EI9VE,aAAA;EAEA,mBAAA;AJ0VF;;AIvVA;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EJ0VF,aAAA;EAME,YAAY;EI9Vd,kBAAA;EACE,WAAA;AJgWF;;AAEA;EI9VE,WAAA;EACA,SAAA;EACA,wBAAA;EJ2VF,YAAA;EAME,yBAAyB;EI/V3B,aAAA;EACE,kBAAA;EACA,UAAA;AJiWF;;AAEA;EI/VE,kBAAA;EACA,yBAAA;EJ4VF,aAAA;AAMA;;AAEA;EAJA,cAAA;EAME,mBAAmB;EI/VrB,eAAA;EACE,gBAAA;EJ4VF,iBAAA;EAME,iBAAiB;EI/VnB,kBAAA;AJiWA;;AAEA;EAJA,cAAA;EAME,mBAAmB;EI/VrB,eAAA;EACE,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,iBAAA;AJgWF;;AAEA;EI9VE,6BAAA;AJgWF;;AAHA;EAME,6BAA6B;AI9V/B;;AJiWA;EI9VE,eAAA;EACA,WAAA;EACA,UAAA;AJgWF;;AAHA;EAME,UAAU;EI9VZ,aAAA;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,iBAAA;AJgWF;;AI7VE;EACE,gHAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EAEA,WAAA;EJ0VJ,sBAAA;AIvVE;;AJ+VF;EI5VI,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6CAAA;EJyVJ,WAAA;EItVE,eAAA;EACE,UAAA;EACA,uBAAA;EJwVJ,mBAAA;AIpVI;AJ2VJ;EAJA,cAAA;EIlVE,eAAA;EACE,gBAAA;EACA,sBAAA;EAEA,iBAAA;EACA,kBAAA;AJwVJ;AACA;EItVI,cAAA;EACA,mBAAA;EJmVJ,eAAA;EIhVE,gBAAA;EACE,sBAAA;EACA,iBAAA;AJuVJ;AACA;EIrVI,UAAA;EACA,UAAA;AJkVJ;AI9UI;EACE,WAAA;AJqVN;AACA;EInVM,kBAAA;EACA,gEAAA;EACA,cAAA;EAGA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EJ8UN,iBAAA;AI5UM;AJmVN;EAJA,cAAA;EIzUE,eAAA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AJgVJ;AACA;EI9UI,oBAAA;EACA,iBAAA;EJ2UJ,UAAA;EAME,YAAY;EI7Ud,kCAAA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AJ0UF;AAMA;EI7UA,gBAAA;AJ+UA;AACA;EI7UE,kBAAA;EACA,QAAA;EACA,mBAAA;EJ0UF,UAAA;EAME,cAAc;EI7UhB,aAAA;EACE,cAAA;EACA,mBAAA;AJ+UF;;AAEA;EI7UE,gHAAA;EACA,aAAA;EJ0UF,WAAA;EAME,sBAAsB;EI7UxB,WAAA;AJ+UA;;AAEA;EI5UE,gHAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AJ8UF;;AAHA;EAME,kBAAkB;EI1UpB,cAAA;EACE,mBAAA;EACA,eAAA;EJuUF,gBAAA;EAME,sBAAsB;EK9uBxB,iBAAA;ALgvBA;;AKjaA;ELoaE,UAAU;EACV,aAAa;EACb,YAAY;EKtad,kBAAA;EJ/UA,sBAAA;EDwvBE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EC3vBhB,iBAAA;ACAA;;AF+vBA;EE3vBA,kBAAA;EACE,mBAAA;AFwvBF;;AAOA;;CAEC;AEtvBC;;;;ECJA;AHgwBF;;;;;CAKC;AACD;;CAEC;AACD;EAJA,yBAAA;AEjvBM;AFwvBN;EACE,aExvBM;AFyvBR;;AEtvBQ;ECbN,YAAA;EACA,WAAA;EACA,sBDasC;ECZtC,yBDY4C;ECX5C,oCDWiD;ECVjD,6CDUyD;EACjD,sBAAA;AFwvBV;AEtvBQ;EClBN,WAAA;EACA,yIAAA;EACA,qBDiBsC;EChBtC,4BDgB4C;ECf5C,kBAAA;AHgxBF;AAJA;EE5vBU;ICpBR,kBJtBc;EIuBd;AHwxBF;AACA;;;;;EEjwBQ,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EFkwBV,sBAAA;EEhwBQ,iBAAA;EC9BN,gCJtBc;AC4zBhB;AACA;;;;;EAKE,cAAc;EEtwBhB,mBAAA;EACE,eAAA;EACA,gBAAA;EFmwBF,sBAAA;EAME,iBAAiB;AEjrBnB;AFmrBA;;;;;;EAME,cAAc;EElrBhB,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EForBA,iBEprBA;EACA,cAAA;AF8qBF;AAQA;;;;;EAKE,WErrBA;EACA,YAAA;EF8qBF,0CAAA;AASA;AEprBA;;;;;EAIE,cAAA;EF8qBF,mBAAA;EAUE,eAAe;EEprBf,gBAAA;EACE,sBAAA;EF6qBJ,iBAAA;AAUA;;AAEA;EEjrBM,gBAAA;EACA,aAAA;AFmrBN;;AEhrBQ;EACE,YAAA;EACA,WAAA;EF0qBV,oBAAA;EAUE,iBAAiB;EIv3BnB,kBAAA;AJy3BA;;AAEA;EIv3BE,YAAA;EACA,WAAA;EJg3BF,oBAAA;EI/2BE,iBAAA;EACE,kBAAA;AJ03BJ;;AAEA;EIx3BI,YAAA;EACA,WAAA;EACA,oBAAA;EJi3BJ,iBAAA;EI/2BE,kBAAA;AJ03BF;;AAEA;EIv3BI,YAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AJy3BJ;;AAEA;EIv3BI,aAAA;AJy3BJ;;AAPA;EAUE,WAAW;EIt3Bb,YAAA;EACE,eAAA;EACA,2BAAA;AJw3BF;AACA;EIv3BE,WAAA;EACA,YAAA;AJy3BF;;AAEA;EIx3BA,kBAAA;EACE,aAAA;EAEA,sBAAA;EACA,mBAAA;EACA,uBAAA;AJy3BF;AACA;EIv3BE,kBAAA;EACA,WAAA;EACA,eAAA;EJ+2BF,gBAAA;EAWE,uBAAuB;EIr3BzB,kCAAA;EACE,mBAAA;AJu3BF;AACA;EIr3BE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EJ62BF,yBAAA;EAWE,gDAAgD;EIt3BlD,WAAA;EACE,YAAA;EJ82BF,aAAA;EAWE,eAAe;EIv3BjB,aAAA;EACE,mBAAA;EACA,uBAAA;EACA,kCAAA;AJy3BF;;AAEA;EIv3BE,gHAAA;EACA,4BAAA;EACA,wBAAA;EACA,mBAAA;EJ+2BF,WAAA;EAWE,WAAW;EIx3Bb,sBAAA;AJ03BA;;AAEA;EATA,UAAA;EAWE,YAAY;EIz3Bd,kBAAA;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;EJi3BF,6CAAA;EAWE,cAAc;EIz3Bd,iBAAA;AJ23BF;;AAEA;EIz3BI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EJi3BJ,mBAAA;AAWA;;AAEA;EATA,aAAA;AAWA;;AAEA;EI13BE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EJk3BF,sBAAA;EIj3BE,iBAAA;EACE,YAAA;AJm3BJ;;AAYA;EATA,YAAA;EAWE,gBAAgB;EIz3BlB,eAAA;AJ23BA;;AAEA;EIz3BA,kBAAA;EACE,mBAAA;EJi3BF,gBAAA;AAWA;;AAEA;;;EIx3BA,8CAAA;EACE,cAAA;EJk3BF,mBAAA;EAWE,eAAe;EI13BjB,gBAAA;EACE,iBAAA;EJk3BF,iBAAA;AAWA;;AAEA;EI33BE,gBAAA;AJ63BF;;AAEA;EI33BE,sBAAA;EACA,YAAA;EACA,gCAAA;EJm3BF,aAAA;EAWE,WAAW;EI53Bb,oBAAA;EACE,wCAAA;EACA,gBAAA;AJ83BF;AACA;EI53BE,uDAAA;AJ83BF;AACA;EI53BE,uDAAA;AJ83BF;;AAEA;EI53BE,uDAAA;AJo3BF;;AIl3BA;EACE,uDAAA;AJ+3BF;;AAEA;EI73BE,iBAAA;AJ+3BF;;AAEA;EATA,iBAAA;AIp3BE;;AJi4BF;EI93BI,iBAAA;AJg4BJ;;AAEA;EI93BI,sBAAA;EJs3BJ,YAAA;EIp3BE,gCAAA;EACE,aAAA;EJs3BJ,WAAA;EAWE,oBAAoB;EI73BtB,wCAAA;EACE,gBAAA;AJ+3BF;;AAEA;EI93BA,kBAAA;EACE,gEAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EAEA,eAAA;EJq3BF,gBAAA;EAWE,iBAAiB;EI93BnB,iBAAA;EACE,wBAAA;AJg4BF;;AAEA;EI93BE,cAAA;EACA,mBAAA;EACA,eAAA;EAEA,gBAAA;EJq3BF,iBAAA;EAWE,iBAAiB;EI73BnB,kBAAA;EACE,iBAAA;AJ+3BF;AACA;EATA,cAAA;EAWE,mBAAmB;EI93BrB,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AJg4BF;AACA;EI93BE,cAAA;AJs3BF;;AIp3BA;EACE,aAAA;EACA,mBAAA;AJi4BF;;AAEA;EI/3BE,WAAA;EACA,SAAA;EJu3BF,yBAAA;EAWE,aAAa;EI/3Bf,YAAA;EACE,kBAAA;EJu3BF,WAAA;AAWA;;AAEA;EATA,WAAA;EAWE,SAAS;EI/3BX,wBAAA;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EJu3BF,kBAAA;EAWE,UAAU;AI/3BZ;;AJk4BA;EI93BE,kBAAA;EACA,yBAAA;EACA,aAAA;AJg4BF;;AAEA;EI93BE,cAAA;EACA,mBAAA;EJs3BF,eAAA;EAWE,gBAAgB;EI93BlB,iBAAA;EACE,iBAAA;EACA,kBAAA;AJg4BF;;AAEA;EI93BE,cAAA;EACA,mBAAA;EJs3BF,eAAA;EAWE,iBAAiB;EI93BnB,iBAAA;EACE,kBAAA;EACA,iBAAA;AJg4BF;;AAEA;EI93BE,6BAAA;AJg4BF;;AAEA;EATA,6BAAA;AIp3BE;;AJi4BF;EI93BI,eAAA;EACA,WAAA;EACA,UAAA;AJg4BJ;;AI33BE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EJo3BJ,mBAAA;EIj3BE,6CAAA;EACE,eAAA;EACA,iBAAA;AJm3BJ;;AAYA;EATA,gHAAA;EI72BE,4BAAA;EACE,aAAA;EACA,WAAA;EAEA,YAAA;EACA,WAAA;EACA,sBAAA;AJw3BJ;;AAEA;EATA,yBAAA;EI32BE,mBAAA;EACE,yBAAA;EACA,6CAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EJ62BJ,mBAAA;AIz2BI;AJq3BJ;EIn3BM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EAGA,kBAAA;AJm3BN;AACA;EIj3BM,cAAA;EJy2BN,mBAAA;EIv2BM,eAAA;EACE,gBAAA;EJy2BR,sBAAA;EIp2BE,iBAAA;AJg3BF;AACA;EI92BI,UAAA;EACA,UAAA;AJg3BJ;AACA;EI92BI,WAAA;AJg3BJ;AATA;EAWE,kBAAkB;EI72BpB,gEAAA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EJq2BF,iBAAA;AAWA;AI72BA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EJq2BF,iBAAA;AAWA;AI72BA;EACE,oBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EJq2BF,eAAA;EAWE,iBAAiB;EI72BnB,iBAAA;AJ+2BA;AACA;EI52BE,gBAAA;AJ82BF;AACA;EI52BE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EJo2BF,aAAA;EAWE,cAAc;EI12BhB,mBAAA;AJ42BA;;AARA;EAWE,gHAAgH;EFlwClH,aAAA;EEowCE,WAAW;EFlwCX,sBAAA;EACA,WAAA;AEowCF;;AAEA;EFlwCE,gHAAA;EE0vCF,WAAA;EAWE,aAAa;EFlwCf,sBAAA;EEowCE,WAAW;AACb;;AARA;EFxvCE,kBAAA;EEowCA,cAAc;EFnwCZ,mBAAA;EE2vCJ,eAAA;EAWE,gBAAgB;EFlwClB,sBAAA;EAOE,iBAAA;AEovCF;;AAYA;EACE,UFtwCE;EEuwCF,aFrwCE;EE4vCF,YAAA;EACF,kBAAA;EAWE,sBAAsB;EFlwCxB,yBAAA;EACE,mBAAA;EE0vCF,6CAAA;EAWE,cAAc;EFlwChB,iBAAA;AEowCA;;AAEA;EF/vCA,kBAAA;EACE,mBAAA;AEiwCF;;AAEA;;EF9vCA,SAAA;EACE,UAAA;EEuvCF,sBAAA;EAWE,iCAAiC;EF/vCnC,cAAA;EACA,kBAAA;AEiwCA;;AARA;;EFpvCA,2BAAA;EACA,kBAAA;AEiwCA;AATA;;EM7zCE,qBAAA;AN00CF;;AAEA;EG50CE,yBAAA;AH80CF;AACA;EG50CE;IACA,YAAA;IGDE,iBAAA;EACA;ANg1CJ;;AARA;EMp0CI,sBAAA;ANg1CJ;;AAEA;EM90CM,gBAAA;ANs0CN;;AAYA;EATA,UAAA;EMr0CM,WAAA;ANi1CN;;AM70CM,UAAA;ANg1CN;EOn2CE,mBDqBQ;ANg1CV;;AAEA,WOp2CE;APq2CF;EOn2CE,mBAAA;EACA,mBDoBQ;ANi1CV;;AAEA,oBMj1CQ;ANw0CR;EMt0CM,mBAAA;ANk1CN;;AARA;EMp0CU,aAAA;EH7BR,8BG8BwB;EH7BxB,mBG6BgC;EH5BhC,WAAA;EACA,sBAAA;EG4BU,qBAAA;ENy0CZ,kBAAA;EMn0CU,iBAAA;EHrCR,yBGsCwB;EHrCxB,4BGqCgC;EHpChC,6CGoCwC;EHnCxC,YAAA;AHq3CF;AATA;EMl0CQ,aAAA;EACE,qBAAA;ENo0CV,cAAA;EMn0CU,mBAAA;AN+0CV;AACA;EG73CE,aAAA;AH+3CF;AACA;EATA,YAAA;AMj0CQ;AN60CR;EATA,YAAA;EM9zCE,mBAAA;EACE,iBAAA;EACA,kBAAA;ENg0CJ,kBAAA;EAWE,cAAc;EM/zChB,mBAAA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;ANi0CF;AATA;EAWE,yBAAyB;EM/zC3B,cAAA;ANi0CA;AACA;;;;;;EM3zCE,cAAA;EAEA,aAAA;ENuzCF,uBAAA;EAWE,yBAAyB;EM5zCzB,YAAA;AN8zCF;AACA;;;;;;EMtzCI,cAAA;EACA,aAAA;ENmzCJ,uBAAA;EMlzCI,yBAAA;EACE,YAAA;AN8zCN;AATA;EMlzCI,kBAAA;AN8zCJ;AACA;;;;;;EMvzCM,cAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;ENozCN,YAAA;AMnzCM;AN+zCN;EATA,UAAA;AMnzCM;AN+zCN;EATA,sBAAA;EMlzCI,qBAAA;AN8zCJ;;AAEA;EM5zCM,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,wCAAA;ANozCN;;AM5yCA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;ANyzCF;;AARA;EAWE,gBAAgB;EMxzClB,MAAA;EACE,WAAA;AN0zCF;;AAEA;EMzzCE,kBAAA;ENgzCF,kBAAA;EAYE,QAAQ;EM1zCV,SAAA;EACE,gBAAA;ENizCF,mBAAA;EMhzCE,UAAA;EACE,yBAAA;EACA,0CAAA;AN6zCJ;AACA;EAVA,YAAA;EMhzCE,kBAAA;AN6zCF;AACA;EM3zCI,aAAA;EACA,mBAAA;ENkzCJ,gBAAA;EAYE,cAAc;EM3zChB,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;ENkzCF,eAAA;AMjzCE;AN8zCF;EM5zCI,eAAA;AN8zCJ;AACA;EM5zCI,iBAAA;AN8zCJ;AACA;EM5zCI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ENmzCJ,WAAA;EMlzCI,YAAA;EACE,yBAAA;EACA,wBAAA;AN+zCN;;AAEA;EM7zCM,kBAAA;EACA,wBAAA;EACA,6BAAA;ENozCN,aAAA;EMlzCI,YAAA;AN+zCJ;;AAEA;EG7/CE,WAAA;EACA,YAAA;EACA,oBG2LyC;EACrC,iBAAA;ENyzCN,kBAAA;AMvzCI;;ANq0CJ;EMl0CM,kBAAA;ANo0CN;AACA;EMl0CM,kBAAA;ENyzCN,QAAA;EMxzCM,UAAA;EACE,YAAA;ANq0CR;AAVA;EMxzCM,kBAAA;EACE,QAAA;EACA,WAAA;EACA,YAAA;AN0zCR;;AAaA;EMp0CU,kBAAA;EACA,wBAAA;ENs0CR,oCMt0CQ;EN2zCV,aAAA;EMxzCM,YAAA;ANs0CN;AACA;EAXA,kBAAA;EMzzCQ,gBAAA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;ANu0CV;AACA;EAXA,YAAA;EMzzCQ,kBAAA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;ANu0CV;AAXA;EAaE,cAAc;EMj0ChB,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;ANm0CF;AACA;EG7jDE,aAAA;EACA,mBGyP6B;EHxP7B,mBGwPkC;EHvPlC,WAAA;EGwPA,6BAAA;EACA,YAAA;AN4zCF;AM3zCE;EACE,yBAAA;EACA,mBAAA;ANy0CJ;AACA;EMv0CI,YAAA;EACA,WAAA;EN6zCJ,kBAAA;AMn0CE;ANi1CF;EM/0CI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;ANi1CJ;AAnBA;EM3zCE,gBAAA;EACE,iBAAA;AN6zCJ;AAqBA;EM90CA,cAAA;EACE,oBAAA;EACA,eAAA;EN4zCF,gBAAA;EAqBE,iBAAiB;EM/0CnB,iBAAA;EACE,kBAAA;ENi1CA,gBMh1CE;EN6zCF,mBAAA;EM3zCA,gBAAA;ENi1CA,uBMh1CE;ANi1CJ;AACA;EAnBA,cAAA;EM1zCA,oBAAA;EACE,eAAA;ENg1CA,gBM/0CE;ENg1CF,iBM/0CE;EN4zCF,iBAAA;EM1zCA,kBAAA;ANg1CF;;AAEA;EACE,yBM90CE;EN+0CF,YM90CE;EN2zCF,YAAA;EACF,YAAA;EQxnDA,kBAAA;EACE,cAAA;ER0nDF,mBAAA;EQznDE,eAAA;ELOA,gBKLgB;ELMhB,iBKNuB;ELOvB,iBAAA;EACA,kBAAA;EKPE,mBAAA;ARipDJ;AAnBA;EQ5nDI,gBAAA;EALF,cAAA;ERwpDA,sBQlpDI;ER+nDJ,eAAA;EACF,iBAAA;EQ9nDI,iBAAA;ARopDJ;AACA;EQlpDM,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;ERgoDN,iBAAA;AQ9nDM;ARopDN;EQlpDQ,aAAA;ARopDR;;AAEA;EQlpDQ,YAAA;EACA,kCAAA;ARopDR;;AQjpDM;ELNJ;IACA,UAAA;EACA;EACA;IACA,YAAA;IACA,UAAA;EHuoDF;AQnoDM;ARypDN;EQvpDQ;IACA,YAAA;ILZN,wBJhBqB;EIiBrB;EACA;IACA,YAAA;EACA;EACA;IHkpDF,YAAA;IAqBI,wBAAwB;ESnsD5B;ATqsDA;AACA;ESnsDE,sBAAA;ATirDF;AShrDE;EAJF,aAAA;ET2sDE,WStsDE;ETmrDF,mBAAA;EACF,yBAAA;ESlrDE,6CAAA;EACE,gBAAA;ATwsDJ;AAnBA;ESlrDE;IACE,WAAA;ETwsDF;AACF;AAnBA;ESjrDI,kBAAA;ENMF,yBJhBqB;EIiBrB,YAAA;EACA,kBMPyC;ENQzC,gBMR+C;ENS/C,mBMToD;ENUpD,gBAAA;AH8qDF;AStrDI;EACE,kBAAA;EACA,mBAAA;ENCJ,YAAA;EACA,WAAA;EACA,yBMD6C;ENE7C,YAAA;EACA,UAAA;EACA,YAAA;AHwrDF;AAqBA;ES7sDA,cAAA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AT2rDF;AAqBA;ES9sDA,kBAAA;EACE,+BAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;ET4rDF,mBAAA;EAqBE,gBAAgB;ES9sDlB,wBAAA;EACE,gBAAA;ATgtDF;;AAEA;ES9sDA,sBAAA;EACE,iBAAA;EACA,WAAA;ATgtDF;AACA;EAnBA;IS3rDE,WAAA;EACE;ATitDJ;AACA;ES/sDI,WAAA;EACA,mBAAA;ATitDJ;AAnBA;ES1rDE;IACE,WAAA;EACA;ATgtDJ;AACA;EG/vDE,cAAA;EACA,mBAAA;EH6uDF,eAAA;ES3rDI,gBAAA;EAEE,iBAAA;EACA,iBAAA;ATgtDN;AACA;EG/wDE,yBMiEkB;ENhElB,YAAA;EACA,cAAA;EACA,mBAAA;EM+DI,eAAA;EACA,gBAAA;EACA,iBAAA;ET+rDN,iBAAA;AS7rDI;;ATotDJ;ESjtDM,WAAA;EACA,WAAA;EN5DJ,kBJkEM;EIjEN,yBAAA;EACA,UAAA;AHgxDF;;AAEA;EAnBA,yBAAA;ES/rDE,WAAA;EACE,WAAA;EACA,kBAAA;ATisDJ;;AAsBA;ESntDI,WAAA;EACA,aAAA;ATisDJ;;AAsBA;ESntDM,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;ATqtDN;AACA;EGtyDE,kHJkEM;EIjEN,4BAAA;EACA,sBMkF0B;ENjF1B,sBMiFgC;ENhFhC,uBMgFqC;EN/ErC,8BM+EwC;ATytD1C;AAnBA;ES5rDI,kBAAA;EAEE,aAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,wBAAA;ATitDN;AACA;;;EGl0DE,kBAAA;EACA,QAAA;EMmHI,YAAA;ETgsDN,UAAA;ES7rDE,gBAAA;EACE,eAAA;ET+rDJ,uBAAA;ES7rDM,8BAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ATmtDR;AACA;EGr0DE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBMiHiD;ENhHjD,cAAA;EACA,mBM+GyD;ETosD3D,eAAA;ESjsDQ,gBAAA;ENvHN,iBJlBmB;EImBnB,iBAAA;AH+0DF;AACA;EG70DE,kBMqHsD;ENpHtD,aAAA;AH2zDF;ASrsDQ;EN3HN,aAAA;EACA,YAAA;EACA,gCM0H6C;AT6tD/C;AACA;EGr1DE,aAAA;EMwHQ,uBAAA;ET4sDV,WAAA;ES3sDU,mBAAA;EN9HR,mBJhBqB;EIiBrB,gBAAA;EACA,uBM6H+C;EN5H/C,cAAA;EACA,mBM2H0D;EN1H1D,eAAA;EM2HU,gBAAA;ETktDZ,iBAAA;EShtDU,iBAAA;ENlIR,yBJhBqB;ACy3DvB;AACA;;;EGr2DE,kBM8H6D;EACnD,QAAA;ETutDZ,YAAA;EAqBE,UAAU;EUv4DZ,aAAA;EACE,uBAAA;EACA,mBAAA;EVq3DF,gBAAA;EAqBE,eAAe;EUr2DjB,uBAAA;EACE,8BAAA;EP/BA,yBOiCc;AVs2DhB;AACA;EGr4DE,yCJXc;ACk5DhB;AAnBA;;;;EGv2DE,sBOsByC;EPrBzC,mBOqB+C;EPpB/C,gBAAA;EACA,uBOmB4D;EAExD,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EVw1DN,iBAAA;AAqBA;AUz2DA;;;;;EAKE,cAAA;EACA,mBAAA;EACA,eAAA;EVu1DF,gBAAA;EUt1DE,iBAAA;EACE,iBAAA;AV42DJ;AACA;;;;;EW96DA,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;ERIA,iBQHc;ERId,iBQJqB;ERKrB,kBAAA;AHi7DF;AACA;;;;;;EGt6DE,cJhBqB;EIiBrB,mBAAA;EACA,eQX2C;ERY3C,gBQZiD;ERajD,iBQbsD;ERctD,iBQdyD;EXs6D3D,kBAAA;AWp6DM;AX27DN;;;;;;EWz7DQ,cAAA;EX26DR,mBAAA;EAsBE,eAAe;EW57DjB,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AX87DF;;AAEA;EG98DE,aAAA;EH27DF,mBAAA;AW16DI;;AX66DJ;EWz6DM,gBAAA;ERVJ,aAAA;EACA,WAAA;EACA,mBQS2C;ERR3C,yBQQiD;ERPjD,4CQOsD;AXo8DxD;AApBA;EW96DM,cAAA;ERbJ,mBJhBqB;EIiBrB,eAAA;EACA,gBQY2C;ERX3C,sBQWiD;ERVjD,iBQUsD;ERTtD,YAAA;EQUM,kBAAA;EXq7DR,mBAAA;EAsBE,aAAa;EWr8Df,mBAAA;EACE,kBAAA;AXk7DF;;AW/6DA;ERvCE,mBQyCc;AXs8DhB;;AAEA;EWv8DE,YAAA;EACA,aAAA;EACA,kBAAA;AXy8DF;AACA;EWv8DE,WAAA;EACA,YAAA;EXo7DF,oBAAA;EWn7DE,iBAAA;EACE,kBAAA;AXq7DJ;;AAuBA;EGh/DE,sBJhBqB;EIiBrB,0CAAA;EACA,iBQyC2C;ERxC3C,aAAA;EACA,WAAA;EACA,mBQsCyD;EACnD,yBAAA;EXu7DR,6CAAA;AWn7DQ;AX08DR;;;EGv/DE,gBQ8CqC;AX68DvC;AACA;EApBA,cAAA;EWx7DQ,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AX+8DV;AACA;EW78DU,cAAA;EX07DV,mBAAA;EWz7DU,eAAA;EACE,gBAAA;EX27DZ,iBAAA;EW17DY,iBAAA;EACE,cAAA;AXi9Dd;;AAnBA;EWz7DU,sBAAA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;AXg9DZ;AApBA;EWz7DU,gBAAA;AXg9DV;AACA;EW98DY,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EX27DZ,iBAAA;EWz7DU,iBAAA;AXg9DV;AACA;EW98DY,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EX27DZ,iBAAA;EWv7DQ,iBAAA;ER9FN,cJhBqB;AC6jEvB;;AAEA;EG3iEE,wBQ2FwD;AXk9D1D;;AAnBA;EW57DU,UAAA;ERlGR,WAAA;EACA,kBAAA;EACA,yBQiG+C;ERhG/C,yBQgGqD;ER/FrD,4BQ+F0D;ER9F1D,UAAA;EQ+FU,kBAAA;EXm8DZ,4CAAA;EWh8DU,mBAAA;ERvGR,oCJhBqB;AC+kEvB;AACA;EG7jEE,gBQqGqD;AX09DvD;AACA;EW19DY,gBAAA;EXu8DZ,cAAA;EWl8DM,mBAAA;EACE,eAAA;EXo8DR,gBAAA;EWl8DQ,iBAAA;EACE,iBAAA;EXo8DV,gBAAA;AWl8DU;AXy9DV;;;;;EWn9DY,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AXo8DZ;AWj8DU;;;;;EXu8DV,yBAAA;EW37DI,mBAAA;ER9IF,0BQ+IkB;ER9IlB,6BAAA;EACA,2BQ6I2B;ER5I3B,iBQ4IiC;ER3IjC,4BQ2IsC;AXs9DxC;AApBA;;;;;;EAME,eAAA;AAsBF;AACA;;;;;;EW98DE,WAAA;EACA,YAAA;EACA,kBAAA;AXq9DF;AACA;;;;;;EW98DA,yBAAA;EACE,mBAAA;EXg8DF,gBAAA;EAsBE,0BAA0B;EWn9D5B,6BAAA;EACE,4BAAA;EXg8DF,4BAAA;AAsBA;AY5pEA;;;;;;EAME,yBAAA;EACA,mBAAA;EACA,0BAAA;EZyoEF,6BAAA;EAsBE,4BAA4B;EY5pE9B,4BAAA;AZ8pEA;AACA;;;;;;EYtpEE,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,6BAAA;EZwoEF,4BAAA;EAsBE,4BAA4B;AYppE9B;AZspEA;;;;;EAKE,cYrpEE;EZspEF,mBYrpEE;EZioEF,eAAA;EACF,gBAAA;EY9nEE,iBAAA;EACE,iBAAA;EACA,kBAAA;AZqpEJ;AACA;;;;;;EG1qEE,cAAA;EACA,mBSwBoD;ETvBpD,eAAA;ESwBI,gBAAA;EZqoEN,iBAAA;EYnoEI,iBAAA;EACE,kBAAA;AZqoEN;AYloEE;;;;;;EAMA,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EZooEJ,iBAAA;EYloEI,kBAAA;AZypEJ;AACA;;;;EGpsEE,gBAAA;AHorEF;AYvoEI;;;;;ET9CF,aAAA;AHitEF;AApBA;;;;;;EattEE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EVPA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AH0vEF;AACA;;;;;;EG/uEE,YAAA;EACA,WAAA;EACA,mBUJ4C;EAC1C,yBAAA;Ab0vEJ;AApBA;EapuEI,cAAA;EACE,mBAAA;EAWA,eAAA;Eb4tEN,gBAAA;EatuEM,iBAAA;EACE,iBAAA;Ab6vER;;Aa3vEQ;EACE;IbyuEV,UAAA;IavuEQ,qBAAA;EACE;EbyuEV;IAsBI,UAAU;IavvEd,mBAAA;EACE;AbouEF;AAsBA;;EavvEE,cAAA;EbquEF,mBAAA;EAsBE,eAAe;EazvEjB,iBAAA;EACE,iBAAA;EbsuEF,kBAAA;EAsBE,oBAAoB;Ec9xEpB,mBAAA;AdgyEF;;AAEA;EG/wEE,yBWlB6C;AdmyE/C;;AAEA;EApBA,yBAAA;Ac7wEE;;AdqyEF;EGxxEE,eWZuC;EXavC,MAAA;EACA,OAAA;EACA,WAAA;EWdE,aAAA;EdoxEJ,WAAA;EclxEE,qCAAA;EXOA,YAAA;AHmyEF;;AAEA;EGjyEE,eAAA;EACA,eAAA;EWVE,QAAA;EdyxEJ,aAAA;EcvxEE,YAAA;EXGA,uBJhBqB;EIiBrB,4BAAA;EACA,yCWJuC;EXKvC,WAAA;EACA,6CWNkD;EXOlD,eAAA;AH4yEF;;AchzEE;EXDA;IACA,UAAA;IACA,0BAAA;EACA;EACA;IACA,UAAA;IWFE,wBAAA;EdmyEJ;AclyEI;AdyzEJ;EApBA,mBAAA;EcjyEE,sBAAA;EACE,aAAA;EdmyEJ,8BAAA;AcjyEE;AdwzEF;EApBA,cAAA;EAsBE,mBAAmB;Eer1ErB,eAAA;EZEE,gBYDc;EZEd,iBYFoB;EZGpB,iBAAA;EACA,SAAA;AHs1EF;AApBA;Eep0EE,eAAA;Af21EF;AACA;Eez1EI,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;Afs0EJ;Aer0EI;EACE,mBAAA;EACA,sBAAA;EZIJ,gBYHkB;EZIlB,aAAA;AHy1EF;AACA;EGv1EE,cAAA;EACA,mBYRyC;Ef40E3C,eAAA;Ee30EM,gBAAA;EZEJ,iBYDoB;EZEpB,iBAAA;AHi2EF;AACA;EG/1EE,cAAA;EACA,mBYN2C;Efk1E7C,eAAA;Ee/0EI,gBAAA;EACE,iBAAA;EACA,iBAAA;Afs2EN;AACA;Eep2EM,qBAAA;Afs2EN;;AAnBA;EAsBE,gBAAgB;Eel2EhB,OAAA;EACE,SAAA;Ef+0EJ,sBAAA;Ee70EE,mBAAA;EACE,YAAA;Ef+0EJ,cAAA;Ee90EI,WAAA;EACF,sBAAA;EACA,qBAAA;EZrBA,kBYsBc;EZrBd,iBAAA;EACA,aAAA;EACA,8BYmB6B;EZlB7B,mBYkBkC;EZjBlC,mBYiBqC;Af02EvC;AApBA;Eel1EI,aAAA;EACJ,8BAAA;Efo1EA,mBAAA;EAsBE,WAAW;Eer2Eb,cAAA;Afu2EA;AACA;EGp5EE,cAAA;EACA,SAAA;AHs5EF;AApBA;Eep1EE,cAAA;EACE,kBAAA;Af22EJ;AACA;Eez2EI,cAAA;Af22EJ;AACA;Eez2EI,iBAAA;Af22EJ;;Aev2EE;EACE,+BAAA;Afq1EJ;;AAuBA;EApBA,+BAAA;Aen1EI;;Af22EJ;EApBA,+BAAA;Ael1EI;;Af02EJ;EG94EE,cAAA;EAnCA,mBYyEkB;EZxElB,eYwEwB;EZvExB,gBAAA;EACA,iBAAA;EY0EI,iBAAA;Efs1EN,SAAA;Aer1EM;Af42EN;EApBA,cAAA;Eep1EI,mBAAA;EACE,eAAA;Efs1EN,gBAAA;Eer1EM,iBAAA;EACE,iBAAA;Efu1ER,SAAA;Aen1EE;Af02EF;Eex2EI,cAAA;Efq1EJ,mBAAA;Een1EE,eAAA;EACE,gBAAA;EACA,iBAAA;Efq1EJ,iBAAA;Een1EE,SAAA;Af02EF;AACA;EApBA,cAAA;Een1EE,mBAAA;EACF,eAAA;EACA,gBAAA;Efq1EA,iBAAA;Een1EE,iBAAA;EZzGA,SAAA;AHo9EF;AACA;EGl9EE,cAAA;EYwGE,mBAAA;Efw1EJ,eAAA;Eev1EI,gBAAA;EACE,iBAAA;EACA,iBAAA;Efy1EN,SAAA;Aev1EI;Af82EJ;EG79EE,gBYgHwB;Af+2E1B;AACA;EApBA,qBAAA;Ae31EM;Afk3EN;Eeh3EQ,qBAAA;Afk3ER;;AAEA;EGv9EE,YAAA;EACA,WAAA;EACA,mBYkGyD;Efk2E3D,yBAAA;Eej2EQ,6CAAA;Afw3ER;AACA;EG/9EE,gBYuG6C;EZtG7C,kBYsGmD;EZrGnD,yBYqGwD;EZpGxD,mBYoG2D;Efw2E7D,aAAA;EAsBE,0CAA0C;AK9/E5C;ALggFA;EKhgFA,kBAAA;EA+UA,gBAAA;ELorEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EKtrEjB,gBAAA;EWxUA,iBAAA;EACE,iBAAA;AhB4+EF;AgB3+EE;EACE,cAAA;EhB6+EJ,mBAAA;EgB3+EE,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AhBkgFJ;AACA;EgBhgFI,kBAAA;EACA,UAAA;EACA,YAAA;EhB6+EJ,WAAA;EgB3+EE,YAAA;EACE,kBAAA;EhB6+EJ,0CAAA;AAsBA;;AAEA;EApBA,eAAA;AAsBA;AgBjgFA;EAEE,yBAAA;AhBkgFF;AACA;EgBhgFE,mBAAA;EhB6+EF,sBAAA;EgB5+EE,cAAA;EbnBA,mBaoBuB;EbnBvB,eAAA;EACA,gBAAA;EamBE,iBAAA;EACA,iBAAA;EhBg/EJ,gBAAA;AgB/+EI;AhBsgFJ;EGrhFE,aAAA;AHuhFF;;AAEA;EGrhFE,YAAA;EaaI,WAAA;EhBs/EN,mBAAA;EgBr/EM,yBAAA;EACE,0CAAA;AhB4gFR;AApBA;EgBn/EE,yBAAA;EbhCA,YAAA;EACA,eAAA;EACA,gBAAA;EagCE,iBAAA;EhBu/EJ,iBAAA;EKt7EE,cAAA;EWnEA,eAAA;AhBihFF;AACA;EApBA,YAAA;AgBv/EI;AhB8gFJ;EG7iFE,yBAAA;AH+iFF;AACA;EG7iFE,aAAA;EACA,mBa4ByC;AhBmhF3C;AApBA;EgB7/EM,aAAA;EACE,uBAAA;EACA,mBAAA;EhB+/ER,YAAA;EgB3/EE,WAAA;EACE,kBAAA;EACA,yBAAA;EhB6/EJ,YAAA;AAsBA;AiBhlFA;EACE,eAAA;AjBklFF;AApBA;EAsBE,yBAAyB;AiBjlF3B;AjBmlFA;;;EGjlFE,oBAAA;AHqlFF;AACA;EiBplFE,YAAA;EjBikFF,iBAAA;AiBhkFE;AjBulFF;EiBrlFI,YAAA;EACA,iBAAA;AjBulFJ;AACA;EiBrlFI,eAAA;EACA,gBAAA;AjBulFJ;AApBA;EiBhkFE,eAAA;EACE,gBAAA;AjBkkFJ;AiBjkFI;EACE,YAAA;EjBmkFN,WAAA;EAsBE,mBAAmB;EiBrlFrB,yBAAA;EdRE,4CJhBqB;ACgnFvB;AACA;EG9lFE,YAAA;EACA,gBAAA;AHgmFF;AACA;EApBA,YAAA;EAsBE,WAAW;EiB3lFb,kBAAA;EdZE,yBcac;AjB6lFhB;AACA;EGxmFE,iBcU6B;EdT7B,SAAA;EACA,cAAA;EcSA,mBAAA;EjB6kFF,eAAA;EAsBE,gBAAgB;EiBjmFlB,iBAAA;EAKE,iBAAA;AjB+lFF;AACA;EGloFE,ccoCoB;EdnCpB,mBcmC0B;EdlC1B,eAAA;EcmCA,gBAAA;EjB6kFF,iBAAA;EiB5kFE,iBAAA;AjBmmFF;;AAEA;;CAEC;AACD;;;;EiBnmFI;AjBwmFJ;EiBtmFI,sBAAA;AjBmlFJ;AiBjlFE;EACE,eAAA;AjBwmFJ;AACA;EiBjmFI,yBAAA;EACA,YAAA;EjB8kFJ,eAAA;EiB7kFI,gBAAA;Ed7CF,iBc8CkB;Ed7ClB,iBAAA;EACA,cAAA;EACA,ec2CiC;AjBumFnC;AACA;EApBA,qBAAA;AiBnlFM;;AjB2mFN;EApBA,eAAA;AiBjlFE;;AjBymFF;EiBtmFI,mBAAA;EACA,uBAAA;EdtCF,6CAAA;EACA,kBAAA;AH+oFF;AACA;EApBA,aAAA;EiBplFI,uBAAA;Ed5DF,sBc6DkB;Ed5DlB,YAAA;EACA,kBc2D2B;AjB6mF7B;AACA;EGtqFE,cAAA;EHmpFF,mBAAA;EiBzlFE,eAAA;Ed/DA,gBcgEgB;Ed/DhB,iBAAA;EACA,iBc8DyB;Ed7DzB,SAAA;AHgrFF;AACA;EiBnnFI,gBAAA;EACA,cAAA;AjBgmFJ;AiB7lFE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AjBonFJ;AACA;EiBlnFI;IACA,kBAAA;EjB+lFJ;AAsBA;AiB/mFA;EdnFE,ccoFc;EdnFd,mBAAA;EACA,eckFuB;EdjFvB,gBciF6B;EdhF7B,iBcgFgC;Ed/EhC,iBc+EmC;EACnC,SAAA;AjBsnFF;AApBA;EAsBE,gBAAgB;EiBrnFlB,cAAA;AjBunFA;AACA;EiBrnFE,YAAA;EACA,WAAA;AjBkmFF;;AAuBA;EGptFE,YAAA;EACA,WAAA;AHstFF;;AAEA;EiB3nFI,sBAAA;EACA,YAAA;EjBwmFJ,WAAA;EiBtmFE,mBAAA;EACE,yBAAA;EjBwmFJ,6CAAA;EAsBE,kBAAkB;AiB1nFpB;AjB4nFA;EiB1nFE,yBAAA;EjBumFF,YAAA;EiBtmFE,eAAA;Ed1GA,gBc2GgB;Ed1GhB,iBAAA;EACA,iBcyGyB;EdxGzB,cAAA;EACA,eAAA;AHwuFF;AApBA;EiB5mFI,sBAAA;AjBmoFJ;AACA;EApBA,gBAAA;AiB3mFE;;AjBmoFF;EGlvFE,cAAA;EACA,mBc+G+B;Ed9G/B,eAAA;EACA,iBc6GwC;EjBknF1C,iBAAA;EAsBE,iBAAiB;EiBroFnB,2BAAA;AjBuoFA;;AAEA;EkB/wFA,cAAA;EACE,mBAAA;ElB4vFF,eAAA;EkB3vFE,iBAAA;EfeA,iBJhBqB;EIiBrB,iBAAA;EACA,2BehBuC;AlBoxFzC;;AAEA;EkBrxFI,gBAAA;ElBkwFJ,kBAAA;EkBhwFE,YAAA;EfWA,WAAA;EACA,kBAAA;EACA,mBeZuC;EfavC,kBeb6C;AlB0xF/C;AACA;EkB1xFI,cAAA;ElBuwFJ,mBAAA;EkBrwFE,eAAA;EfOA,iBJhBqB;EIiBrB,iBAAA;EACA,iBeRuC;AlB8xFzC;AACA;EGpxFE,eAAA;EeVE,iBAAA;ElB4wFJ,kBAAA;EkB1wFE,gBAAA;AlBiyFF;AACA;EG7xFE,qBeJuC;EfKvC,mBeL6C;EfM7C;;;;;GAJA;EACA,iBAAA;EACA,gBAAA;AHwyFF;AACA;EGtyFE,cAAA;EeFE,mBAAA;ElBsxFJ,eAAA;EkBrxFI,cAAA;EACE,sBAAA;ElBuxFN,iBAAA;AAsBA;AmBn0FA;EACE,kBAAA;EACA,cAAA;AnBgzFF;AmB9yFE;EACE,eAAA;EACA,mBAAA;EACA,gEAAA;EnBgzFJ,aAAA;EmB/yFI,aAAA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AnBs0FN;AACA;EGj0FE,cgBHkB;EhBIlB,mBAAA;EACA,egBL2B;EhBM3B,gBgBNiC;EhBOjC,iBgBPsC;EhBQtC,iBgBRyC;AnBszF3C;AmBpzFI;EACE,cAAA;EACA,mBAAA;EhBDJ,eJkEM;EIjEN,gBAAA;EACA,iBAAA;EACA,iBgBDgC;EhBEhC,YAAA;EACA,gBAAA;AH60FF;AACA;EApBA,kBAAA;EAsBE,UAAU;EmB70FZ,YAAA;EACE,YAAA;EnB+0FA,amB90FE;EnB+0FF,kBmB90FE;EnB0zFF,uBAAA;EmBxzFA,0BAAA;AnB+0FF;;AAnBA;EoB31FA,cAAA;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EpB61FF,gBAAA;EAsBE,oBAAoB;AoBj3FtB;;ApBo3FA;EGr3FE,mBiBE2B;EjBD3B,yBJTmB;EqBWnB,6CAAA;EACA,aAAA;ApBs3FF;AApBA;EoB/1FE,cAAA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EpBi2FJ,mBAAA;AoBh2FI;ApBu3FJ;EoBr3FM,oBAAA;ApBk2FN;;AAuBA;EoBp3FQ,gBAAA;EACA,mBAAA;ApBs3FR;AACA;EoBp3FQ,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EpBi2FR,iBAAA;EoB/1FM,iBAAA;ApBs3FN;AApBA;EoB91FI,qBAAA;EACE,cAAA;ApBg2FN;AoB71FI;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EpB+1FN,iBAAA;AAsBA;;AAEA;EoBj3FE,eAAA;ApBm3FF;;AAEA;EoBj3FE,oBAAA;ApBm3FF;AApBA;EAsBE,cAAc;EoBl3FhB,mBAAA;EACE,eAAA;EjB7CA,gBiB8Cc;EjB7Cd,iBAAA;EACA,iBiB4CuB;EjB3CvB,SAAA;AHk6FF;AACA;EApBA,cAAA;EAsBE,mBAAmB;EoBv3FrB,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;ApBy3FF;AACA;EoBv3FE,cAAA;EACA,mBAAA;EACA,eAAA;EpBo2FF,gBAAA;EoBn2FE,iBAAA;EACE,iBAAA;EACA,SAAA;ApB03FJ;AApBA;EoBn2FE,cAAA;EACE,mBAAA;EACA,eAAA;EpBq2FJ,gBAAA;EoBp2FI,iBAAA;EACE,iBAAA;EACA,SAAA;ApB23FN;AACA;EoBz3FM,cAAA;EACA,mBAAA;EpBs2FN,eAAA;EoBn2FE,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,SAAA;ApBq2FJ;AoBl2FI;EACE,gBAAA;ApBy3FN;;AAEA;EoBv3FM,YAAA;EACA,2BAAA;ApBy3FN;AACA;EoBv3FM,kBAAA;EpBo2FN,gBAAA;EoBl2FI,mBAAA;ApBy3FJ;AACA;EoBv3FM,YAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,cAAA;EpBo2FN,mBAAA;EoBn2FM,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;ApB03FR;AApBA;EoBn2FM,mBAAA;EACE,sEAAA;EACA,cAAA;EpBq2FR,mBAAA;EAsBE,eAAe;EqBhgGjB,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;ArBkgGF;;AAEA;EqB//FE;IrB4+FF,UAAA;IAsBI,0BAA0B;EqB//F9B;EACE;IACA,UAAA;EACA;ArBigGF;AACA;EqB//FE,kBAAA;ErB4+FF,yBAAA;EAsBE,6CAA6C;EqB9/F7C,uBAAA;EACE,eAAA;ArB2+FJ;;AAuBA;EApBA,aAAA;EqBx+FE,WAAA;EACE,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,wCAAA;ErB0+FJ,kBAAA;AAsBA;AqB5/FA;EAEI,aAAA;ErB6/FF,gBqB5/FI;ErBw+FJ,kBAAA;EACF,kBAAA;EqBn+FE,gBAAA;EACE,kBAAA;ArBq+FJ;AAsBA;EsBpiGA,mBAAA;EAwSE,kBAAA;AtB0uFF;AsBjhGE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EtBmhGJ,mBAAA;EsBlhGI,eAAA;EACE,iBAAA;EnBWJ,iBmBVkB;EnBWlB,iBAAA;EACA,cAAA;AH+hGF;AACA;EG7hGE,iBmBfyC;AtByhG3C;AsBxhGM;EACE,mBAAA;AtB0hGR;AsBxhGM;EACE,gDAAA;EACA,YAAA;EtB0hGR,kBAAA;EsBxhGM,UAAA;EnBEJ,UAAA;AH8iGF;;AAEA;EG5iGE,yBmBLwC;EnBMxC,kBmBN2C;EACrC,kBAAA;EtB+hGR,aAAA;EKn8FE,8BAAA;EiBxFA,mBAAA;EtBmjGA,YsBjjGI;AtBkjGN;;AsBhjGI;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AtB8hGN;;AAuBA;EACE,kBsBpjGM;EtBqjGN,kBsBpjGM;EtBgiGN,yBAAA;EACF,4CAAA;EsB5hGM,4BAAA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AtBmjGR;AACA;EG7kGE,aAAA;EACA,8BmByBkC;EnBxBlC,mBmBwBuC;AtBujGzC;AACA;EApBA,gBAAA;EsB7hGM,mBAAA;AtBojGN;AACA;EsBljGQ,cAAA;EACA,mBAAA;EnBvCN,emB6CoB;EnB5CpB,gBAAA;EACA,iBmB2C6B;EnB1C7B,iBmB0CmC;AtBkjGrC;AACA;EsBljGQ,aAAA;EtB+hGR,8BAAA;EsBriGQ,mBAAA;AtB4jGR;AACA;EsB1jGU,cAAA;EtBuiGV,mBAAA;EsBjiGI,eAAA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EtBmiGN,iBAAA;EK3/FE,iBAAA;EiB3CE,kBAAA;AtB8jGJ;AACA;EApBE,cAAA;EACF,mBAAA;EKjgGE,eAAA;EiB3CE,kBAAA;EtBokGF,iBsB3jGM;EtB4jGN,iBsB3jGM;EtBuiGN,iBAAA;EACF,kBAAA;AsBtiGM;AtB6jGN;EsB3jGQ,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AtB6jGR;AACA;;;;EsBnkGM,kBAAA;EtBwkGJ,iBsBhkGQ;AtBikGV;;AAnBA;EsB3iGQ,yBAAA;EACE,8BAAA;EACA,0BAAA;EACA,4BAAA;EtB6iGV,4BAAA;EK5hGE,4BAAA;EiBpBM,6BAAA;EtBwkGN,gCsBnkGU;AtBokGZ;;AAnBA;EsB9iGU,yBAAA;EACE,8BAAA;EACA,0BAAA;EACA,4BAAA;EACA,4BAAA;EtBgjGZ,6BAAA;AsB9iGU;;AtBskGV;EsBpkGY,WAAA;AtBskGZ;AACA;EArBA,yBAAA;AsB5iGM;AtBokGN;EsBlkGQ,aAAA;EACA,YAAA;EACA,qCAAA;EACA,2BAAA;AtBokGR;;AAEA;EArBA;IKxjGE,qCAAA;EiBEI;EtB+kGJ;IsBvkGQ,2BAAA;ItBmjGR,8BAAA;EACF;EsBjjGQ;IAGE,6BAAA;EACA;EACA;InB3FR,4BAAA;IACA,6BAAA;EACA;EH6oGF;IKtkGE,6BAAA;EiBaM;AtBklGR;AACA;EArBE,cAAA;AACF;;AAwBA;EsB1kGY,kBAAA;AtB4kGZ;AACA;EArBA,2BAAA;EsBpjGU,YAAA;EACE,gBAAA;AtB4kGZ;AACA;EsB3kGY,sBAAA;EACA,cAAA;EtBsjGZ,mBAAA;EsBjjGI,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AtBmjGN;AK7lGE;EiBuCE,iBAAA;AtBglGJ;AACA;EAtBE,+BAAA;EACF,8BAAA;AKnmGE;AL4nGF;EACE,csB7kGM;EtB8kGN,mBsB7kGM;EtBujGN,eAAA;EACF,gBAAA;EKzmGE,iBAAA;EiBuCE,iBAAA;EtB4lGF,kBsB/kGM;AtBglGR;AACA;EAtBA;IsBxjGM,mBAAA;EACE;AtBilGR;AACA;EsB/kGQ;InBpIN,UAAA;IACA;EACA;EH+rGF;IKxnGE,UAAA;IiBuDI,SAAA;EtB2lGJ;AACF;AACA;EAtBA,kBAAA;EK9nGE,4GAAA;EiBuDI,iCAAA;EtBimGJ,4BsBrlGQ;EtBslGR,qBsBrlGQ;EtB+jGR,WAAA;EACF,aAAA;AsB9jGQ;AtBulGR;EsBrlGU;IACA,cAAA;ItBgkGV,YAAA;EKzoGE;ALkqGF;AACA;EACE,esBxlGU;EtBkkGV,mBAAA;EACF,gBAAA;EsBjkGU,uBAAA;EACE,cAAA;EtB0lGV,mBsB1lGU;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EtBmkGZ,iBAAA;EsB/jGM,iBAAA;AtBylGN;AACA;EsBvlGQ,eAAA;EACA,mBAAA;EnBnKN,gBAAA;EACA,uBAAA;EACA,cAAA;EHquGF,mBAAA;EK9pGE,eAAA;EiBsFI,gBAAA;EtBmmGJ,iBsB5lGQ;EtB6lGR,iBsB5lGQ;EtBqkGR,aAAA;AACF;AsBpkGQ;;;;;EnBxKN,WAAA;EACA,YAAA;EHmvGF,iBAAA;AK5qGE;ALssGF;EACE,kBsBhmGU;EtBimGV,SsBhmGU;EtBykGV,UAAA;AACF;AsBxkGU;EACE;ItBkmGR,SsBlmGQ;IACA,UAAA;EACA;AtBmmGZ;AAxBA;EsBrkGI;IACE,SAAA;IACA,UAAA;EACA;AtBukGN;AK7rGE;;;;ELksGA,kBAAA;EACF,2CAAA;EKnsGE,YAAA;EiBmHE,WAAA;EtB4mGF,kBsBnmGM;EtBomGN,asBnmGM;EtB2kGN,uBAAA;EACF,mBAAA;AKzsGE;ALouGF;EACE;;;;IsBlmGI,YAAA;IACE,WAAA;EACA;AtBumGR;AACA;;;;;EK7uGE,YAAA;EiBmII,WAAA;EtBinGJ,kBsB1mGQ;AtB2mGV;AACA;EAxBA;;;;;IAKA,YAAA;IKnuGE,WAAA;EiB6IM;AtBknGR;AACA;;;;;;EsBzmGY,kBAAA;EACA,UAAA;EACA,UAAA;EtBslGZ,8BAAA;AsBllGM;AtB8mGN;;;;;;EGl1GE,oBAAA;EH+zGF,iBAAA;EKxvGE,WAAA;EiB6JI,YAAA;EtBwnGJ,kBsBjnGQ;AtBknGV;AACA;;;;EsB7mGU,kBAAA;EACA,2CAAA;EnBpPR,YAAA;EACA,WAAA;EACA,kBAAA;EH60GF,aAAA;EKtwGE,uBAAA;EiBuKM,mBAAA;AtB4nGR;AACA;EAzBE;;;;IA8BE,YsBvnGQ;IACA,WAAA;EACA;AtBwnGZ;AA1BA;;;;;EG32GE,YAAA;EACA,WAAA;EACA,kBmBoRqD;EtB6lGvD,aAAA;EsB1lGE,uBAAA;EACE,mBAAA;AtBunGJ;AACA;EGn5GE;;;;;IH83GF,YAAA;IsBhmGI,WAAA;EnBhSF;AH85GF;AACA;;;;;;EG/5GE,kBJhBqB;EIiBrB,UAAA;EACA,UAAA;EACA,8BmBiS+C;AtBqoGjD;AACA;;;;;;EGv6GE,oBmBqS6C;EnBpS7C,iBmBoSkD;EnBnSlD,WAAA;EmBoSE,YAAA;EtBgnGJ,kBAAA;AsB/mGI;AtB4oGJ;EGr7GE,kBAAA;EACA,UAAA;EACA,UAAA;AHu7GF;AACA;EA1BA;IsBpnGI,UAAA;InB7SF,UAAA;EACA;AH+7GF;AACA;EG77GE;IACA,UAAA;IHo6GF,UAAA;EA4BE;AsBnpGF;AtBqpGA;EGr9GE;IACA,SmBiUoB;InBhUpB,UAAA;EACA;AHu9GF;AA1BA;;;;EG97GE,2CmBmU4B;EnBlU5B,YAAA;EmBmUE,WAAA;EtBioGJ,kBAAA;EsBhoGI,aAAA;EACE,uBAAA;EACA,mBAAA;AtB6pGN;AACA;EsB3pGM;;;;InB3UJ,UmB+UsB;InB9UtB,UAAA;EACA;AH4+GF;AA1BA;EsBnoGI;;;;IAIE,YAAA;IACA,WAAA;EtBqoGN;AsBloGE;AtB+pGF;;;;;EsB1pGM,YAAA;EACA,WAAA;EACA,kBAAA;AtBgqGN;AACA;EsB9pGM;;;;;IAKA,YAAA;IACA,WAAA;EACA;AtBgqGN;AACA;;;;;;EsBzpGM,oBAAA;EtBqoGN,iBAAA;EA4BE,WAAW;EsB7pGb,YAAA;EACE,kBAAA;AtB+pGF;AACA;;;;EsB3pGE,2CAAA;EtBqoGF,YAAA;EsBpoGE,WAAA;EACE,kBAAA;EtBsoGJ,aAAA;EsBpoGE,uBAAA;EACE,mBAAA;AtBiqGJ;AACA;EA1BA;;;;IsBhoGM,YAAA;IACA,WAAA;EACA;AtBgqGN;AACA;;;;;EsB1pGM,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AtBqoGN;AsBhoGI;EACE;;;;;IAKA,YAAA;ItBkoGN,WAAA;EsBhoGM;AtB6pGN;AACA;;;;;;EGnjHE,oBmB4Z6B;EnB3Z7B,iBmB2ZmC;EnB1ZnC,WAAA;EACA,YAAA;EH+hHF,kBAAA;AKx8GE;ALq+GF;EACE,kBsBlqGQ;EtBwoGR,UAAA;EACF,WAAA;AsBtoGM;AtBmqGN;EsBjqGQ;IACA,UAAA;ItBwoGR,WAAA;EsBvoGQ;AtBoqGR;AACA;EsBlqGU;ItBoqGN,UsBpqGM;IACA,WAAA;EtByoGV;AsBtoGM;AtBoqGN;EsBlqGQ;IACA,UAAA;ItBwoGR,UAAA;EsBvoGQ;AtBqqGR;AACA;;;;EAzBA,2CAAA;EsBroGM,YAAA;EACE,WAAA;EnB3bN,kBmB4boB;EnB3bpB,aAAA;EACA,uBmB0b6B;EnBzb7B,mBmBybmC;AtBuqGrC;AACA;EA5BA;;;;IGvkHE,YAAA;IACA,WAAA;EACA;AHymHF;AACA;;;;;EAxBA,YAAA;EsBhpGQ,WAAA;EACE,kBAAA;AtB+qGV;AACA;EsB7qGU;;;;;ItBmrGN,YAAY;IsBzqGhB,WAAA;EACE;AtB2qGF;AACA;;;;;;EAvBA,oBAAA;EA8BE,iBAAiB;EsBzqGnB,WAAA;EACE,YAAA;EACA,kBAAA;AtB8oGF;AA8BA;;;;EAIE,2CsBvoGE;EtBwoGF,YsBvoGE;EtB2mGF,WAAA;EsBzmGA,kBAAA;EtBwoGA,asBvoGE;EtBwoGF,uBsBvoGE;EtB2mGF,mBAAA;AACF;AsBxmGA;EACE;;;;ICviBE,YAAA;IACA,WAAA;EvBqpHJ;AuBnpHM;AvBkrHN;;;;;EAxBA,YAAA;EA8BE,WAAW;EwBzrHb,kBAAA;EACE,aAAA;EACA,uBAAA;EAGA,mBAAA;AxB4pHF;AwBzpHE;EACE;;;;;IAIE,YAAA;IxB4pHN,WAAA;EA8BE;AwBrrHA;AxBurHF;;;;;;EwBprHI,oBAAA;ExB8pHJ,iBAAA;EwB5pHE,WAAA;ErBLA,YAAA;EACA,kBAAA;AHisHF;AACA;EG/rHE,cAAA;EACA,mBqBCqD;EACnD,eAAA;ExBmqHJ,gBAAA;EwBjqHE,iBAAA;ErBTA,iBJhBqB;AC0tHvB;AACA;EGxsHE,mBqBO6C;ErBN7C,cAAA;EACA,mBqBKqD;EACnD,eAAA;ExBwqHJ,gBAAA;EwBtqHE,iBAAA;ErBbA,iBJhBqB;EIiBrB,uBAAA;AHmtHF;AACA;EGjtHE,cAAA;EACA,mBqBSqD;EACnD,eAAA;ExB6qHJ,gBAAA;EwB3qHE,iBAAA;ErBjBA,iBJhBqB;AC4uHvB;AACA;EG1tHE,cAAA;EACA,mBqBckD;ErBblD,eAAA;EqBcE,gBAAA;ExBkrHJ,iBAAA;EwBjrHI,iBAAA;AxBgtHJ;AA5BA;EwBhrHE,cAAA;EACE,mBAAA;ExBkrHJ,eAAA;EwBjrHI,gBAAA;ErB1BF,iBJhBqB;EIiBrB,iBAAA;EACA,kBqByByC;AxBktH3C;AACA;EGzuHE,cAAA;EqBuBI,mBAAA;ExBwrHN,eAAA;EwBrrHI,gBAAA;EACE,iBAAA;ErB9CJ,iBqB+CkB;AxBotHpB;AACA;EGjwHE,cAAA;EqB6CI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ExB0rHN,iBAAA;AwBzrHM;;AxB4rHN;EwBxrHM,kBAAA;ErB1CJ,YAAA;EACA,WAAA;EACA,mBqByC6B;ErBxC7B,yBqBwCmC;ErBvCnC,yBqBuCwC;AxB2tH1C;AA5BA;EwBhsHM,YAAA;ErB1CJ,WAAA;EACA,mBAAA;EACA,yBqByC6B;ErBxC7B,iBqBwCmC;AxBkuHrC;AACA;EApCA,kBAAA;EwB7rHM,aAAA;EACE,aAAA;EACA,cAAA;EACA,kBzBhEe;AC+vHvB;AwB9rHQ;EACE,YAAA;EAAA,WAAA;EACA,mBAAA;ExBgsHV,sBAAA;EwB9rHQ,iBAAA;AxBsuHR;AACA;EwBruHU,kBAAA;ExBgsHV,aAAA;EwB9rHQ,aAAA;EACE,cAAA;EAAA,kBAAA;AxBwuHV;AAvCA;EwB3rHI,kBAAA;EACE,SAAA;EACA,WAAA;AxBquHN;AACA;EwBnuHM,kBAAA;EACA,yBAAA;ExB6rHN,6BAAA;EwB1rHE,iBAAA;ErBzEA,oBqB0EgB;ErBzEhB,kBAAA;EACA,mBqBwEyB;ErBvEzB,kBqBuE+B;ErBtE/B,cAAA;EACA,oBqBqEwC;EACtC,eAAA;ExBisHJ,gBAAA;EwB9rHI,iBAAA;EACE,iBAAA;ExBgsHN,wBAAA;AwB/rHM;AxByuHN;EAvCA,kBAAA;EwB/rHM,QAAA;ErBnFJ,WAAA;EACA,oBAAA;AH6zHF;;AAEA;EG3zHE,WAAA;EqBgFM,UAAA;ExBssHR,iBAAA;AwBpsHM;;AxBusHN;EwBpsHM,kBAAA;AxB8uHN;AACA;EwB3uHQ,oCAAA;AxB6uHR;AAvCA;EwBpsHQ,aAAA;ErBhGN,mBqBiGsB;ErBhGtB,yBAAA;AH+0HF;AACA;EG70HE,cAAA;EACA,mBqB4F6C;ExB2sH/C,eAAA;EwB1sHU,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AxBovHZ;AACA;EwBlvHY,SAAA;EACA,cAAA;ExB4sHZ,mBAAA;EwB1sHU,eAAA;ErB3GR,gBqB4GwB;ErB3GxB,iBAAA;EACA,iBqB0GiC;ErBzGjC,kBqByGuC;AxBuvHzC;AACA;EwBvvHY,aAAA;EACA,8BAAA;ExBitHZ,aAAA;EwBhtHY,mBAAA;EACE,mBAAA;EACA,yBAAA;AxBktHd;AwBhtHY;;;;ErBhHV,SAAA;EACA,mBqBgH8C;ErB/G9C,gBAAA;EHs0HF,uBAAA;EwBptHU,gBAAA;EACE,cAAA;EACA,mBzBvDJ;EyBwDI,eAAA;ExBstHZ,gBAAA;EwBrtHY,iBAAA;ErB3HV,iBqB4H0B;AxB+vH5B;AACA;EGz3HE;;;;IqB2HU,gBAAA;EACE;AxB4tHd;AwBztHU;;;;ErBhIR,WAAA;EACA,YAAA;EACA,kBqBgI4C;AxBuwH9C;AACA;;;;EwBnwHY,WAAA;ErBzIV,YAAA;EACA,oBAAA;EACA,iBqBwIiC;ErBvIjC,kBqBuIuC;AxB2wHzC;AACA;;;;EApCA,WAAA;EwBluHQ,YAAA;EACE,kBAAA;AxBouHV;AwBnuHU;;;;ErB/IR,WAAA;EACA,YAAA;EACA,oBqB8I6D;EACnD,iBAAA;ExB0uHZ,kBAAA;AwBnuHE;AxB6wHF;;;;EwBxwHI,SAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AxBquHJ;AwBnuHE;;;;ErBrLA,SAAA;EACA,cAAA;EACA,mBAAA;EqBuLE,eAAA;ExBwuHJ,gBAAA;EwBvuHI,iBAAA;EACE,iBAAA;AxBixHN;AACA;;;;EwB7wHQ,aAAA;ExB0uHR,mBAAA;AwBtuHM;AxBgxHN;;;;;EGv8HE,cJhBqB;EIiBrB,mBAAA;EACA,eqB0L6C;ErBzL7C,kBqByLmD;ErBxLnD,iBqBwLwD;ErBvLxD,iBqBuL2D;EACnD,kBAAA;AxBsxHV;;AwBnxHQ;EACE,cAAA;EACA,mBAAA;ErBlMR,gBqBmMsB;ErBlMtB,eAAA;EACA,iBqBiM+B;ErBhM/B,iBqBgMqC;ErB/LrC,iBqB+L0C;ErB9L1C,mBqB8L6C;AxBmvH/C;;AA0CA;EG/9HE,UAAA;EACA,mCqBmMiC;AxB8xHnC;;AAEA;EAvCA;IwBvvHU,UAAA;IrBvMR,4BqBwMwB;IrBvMxB,kBAAA;EACA;EACA;IACA,UAAA;IACA,wBqBmMiD;ExB8vHnD;AwB5vHU;AxBsyHV;EGh/HE,kBqB4MwB;AxBsyH1B;;AAEA;EGh/HE,aAAA;EACA,8BqBuMoD;AxBmwHtD;AwBjwHU;ErB9MR,YAAA;EACA,WAAA;EACA,yBqB6MiC;ErB5MjC,yBqB4MuC;ErB3MvC,kBqB2M4C;AxB+yH9C;;AwB7yHU;ErBjNR,iBqBkNwB;ErBjNxB,kBAAA;EACA,aAAA;AHkgIF;AACA;EGhgIE,kBqB6MiD;AxB6wHnD;AwB1wHQ;EAGE,gBAAA;EACA,gBAAA;EACA,WAAA;AxBkzHV;;AwB/yHQ;ErB7NN,cqB+NsB;ErB9NtB,mBAAA;EACA,eqB6N+B;ErB5N/B,gBqB4NqC;ErB3NrC,iBqB2N0C;ErB1N1C,iBqB0N6C;ExB8wH/C,SAAA;AwBzwHU;AxBmzHV;EGthIE,cAAA;EACA,mBqBmOiC;ErBlOjC,eAAA;EACA,gBAAA;EACA,iBqBgO+C;ExBgxHjD,iBAAA;EwBjxHU,SAAA;AxB2zHV;AACA;EG9hIE,cAAA;EACA,mBqBkOuC;ErBjOvC,eAAA;EACA,gBAAA;EHg/HF,iBAAA;EwB7wHQ,iBAAA;EAGE,SAAA;AxB6zHV;AACA;EA/CA,cAAA;EwB3wHQ,mBAAA;EAGE,eAAA;EACA,gBAAA;EACA,iBAAA;ExB2wHV,iBAAA;EwBzwHQ,SAAA;AxB2zHR;AACA;EwBzzHU,cAAA;ExB2wHV,mBAAA;EwBzwHQ,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;ErB9PR,SAAA;AH0jIF;AACA;EGxjIE,gBqB4PmD;AxB8zHrD;AACA;EA/CA,sBAAA;AwB9wHQ;AxBg0HR;EGhkIE,cAAA;EACA,mBqBgQ+B;ErB/P/B,eAAA;EACA,iBqB8P0C;ErB7P1C,iBqB6P6C;EACrC,iBAAA;ExBqxHV,uBAAA;AwBlxHM;AxBo0HN;EA/CA,cAAA;EwBnxHQ,YAAA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;ErB5QR,eJkEM;EIjEN,6BAAA;EACA,aAAA;AHklIF;AACA;EGhlIE,wBqBwQ4C;AxB00H9C;AA/CA;EAiDE,cAAc;EwBn0Hd,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AxBq0HJ;AACA;EwBn0HI,cAAA;ExBqxHJ,mBAAA;EwBnxHE,eAAA;EACE,gBAAA;ExBqxHJ,iBAAA;EAiDE,iBAAiB;AyBtnIjB;AzBwnIF;EA/CA,yBAAA;EyBtkIE,sBAAA;EACE,cAAA;AzBwkIJ;A0B9kIA;;;EvBME,sCuBL0B;EvBM1B,8BuBNgC;EAChC,UAAA;A1BmoIF;AACA;EA/CA,mCAAA;EKz+HE,8BAAA;EqB9GF,UAAA;A1B0oIA;AACA;EA/CA,kCAAA;EK9+HE,8BAAA;EqB9GF,UAAA;A1B+oIA;AACA;EA/CA,kBAAA;E0BtlIE,YAAA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;A1BwoIJ;AA/CA;E0BtlII,cAAA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;E1BwlIN,iBAAA;E0BtlII,mBAAA;A1BwoIJ;AACA;E0BtoIM,mBAAA;A1BwoIN;AACA;;;;E0BloIM,gBAAA;A1BuoIN;AACA;E0BroIM,cAAA;EACA,mBAAA;EACA,eAAA;E1BslIN,gBAAA;E0BnlIE,iBAAA;EACE,iBAAA;EACA,yBAAA;A1BsoIJ;AACA;;;;;E0BhoII,6CAAA;A1BqlIJ;A0BjlIA;EACE,kBAAA;E1BooIA,yB0BnoIE;E1BmlIF,gBAAA;E0BjlIA,YAAA;A1BooIF;AACA;;;;;EG3rIE,cwBHoB;ExBIpB,mBwBJ0B;ExBK1B,eAAA;EwBJA,gBAAA;EACA,iBAAA;EACA,iBAAA;A3BqpIF;AK5iIE;;;;;;ELmjIF,cAAA;E2BtpIE,oBAAA;ExBOA,eJhBqB;EIiBrB,gBAAA;EACA,iBwBRuC;ExBSvC,iBwBT6C;ExBU7C,eAAA;AHmsIF;AAhDA;;;;;;EGnpIE,cAAA;EACA,mBwBRwD;E3BkqI1D,eAAA;E2BhqIE,gBAAA;ExBCA,iBJhBqB;EIiBrB,iBAAA;EACA,gBwBFuC;ExBGvC,mBwBH6C;A3BstI/C;AACA;;;;;;;EGttIE,aAAA;EACA,sBwBKuC;A3BytIzC;AACA;;;;;;;EG9tIE,cAAA;EACA,mBwBKoD;ExBJpD,eAAA;EHqrIF,gBAAA;E2B7qIA,iBAAA;ExB3BE,iBwB4Bc;A3BguIhB;AACA;;;;;;E2B5tIE,gBAAA;E3BkrIF,mBAAA;EKzmIE,yBAAA;AL4pIF;AACA;;;;;;;E2B9tII,cAAA;EACA,mBAAA;ExB5BF,eJhBqB;EIiBrB,gBAAA;EACA,iBwB2BuC;ExB1BvC,iBwB0B6C;A3ByuI/C;AACA;;;;;;;EGnwIE,aAAA;AH2wIF;AAhDA;;;;;;E2BvrIA,0GAAA;ExBxCE,cJhBqB;EIiBrB,mBAAA;EACA,ewBuCqC;ExBtCrC,gBwBsC2C;ExBrC3C,iBAAA;EACA,iBwBoCsD;E3BmsIxD,0BAAA;E2BlsIE,0BAAA;A3BqvIF;AACA;;;;;;E4BhzII,0GAAA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;E5BswIN,gBAAA;E4BlwIA,iBAAA;EACE,iBAAA;EACA,yBAAA;E5BowIF,0BAAA;E4BnwIE,2BAAA;A5BszIF;AAhDA;;;;;E4BhwIM,cAAA;A5BuzIN;AACA;;;;;;E4BhzII,cAAA;EACE,mBAAA;EACA,eAAA;EzBVJ,gBJkEM;EIjEN,iBAAA;EACA,iByBS0B;EzBR1B,8ByBQgC;A5B0zIlC;AACA;E4B1zIM,YAAA;EACA,aAAA;E5B2wIN,gEAAA;E4BpwIA,kBAAA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,6BAAA;E5BswIF,8BAAA;E4BnwIA,2BAAA;EACE,+BAAA;A5BqwIF;A4BlwIA;EACE,kBAAA;E5BowIF,gBAAA;E4BjwIA,YAAA;EAEE,WAAA;EACA,mBAAA;E5BkwIF,yBAAA;E4BhwIE,kBAAA;A5BmzIF;AACA;E4BjzII,aAAA;EACA,uBAAA;EACA,sBAAA;A5BmzIJ;AAhDA;E4B/vIE,kBAAA;EACE,mBAAA;A5BiwIJ;AKvtIE;EuB3CA,kBAAA;E5BszIA,a4BlzII;E5BmzIJ,sB4BlzII;A5BmzIN;AAhDA;E4B/vIE,cAAA;EACE,mBAAA;E5BiwIJ,eAAA;EKhuIE,gBAAA;EuBlCA,iBAAA;E5BszIA,iB4BlzII;E5BkwIJ,mBAAA;EACF,gBAAA;A4B/vIE;A5BkzIF;E4BhzII,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;E5BiwIJ,eAAA;E4B9vIE,gBAAA;EACE,iBAAA;EACA,iBAAA;A5BizIJ;AACA;;;;;E4B3yII,cAAA;EACA,mBAAA;E5BgwIJ,eAAA;E4B7vIE,gBAAA;EACE,iBAAA;EACA,iBAAA;A5B+vIJ;A4B5vIE;;;;;EAME,cAAA;E5B6vIJ,mBAAA;E4B1vIE,eAAA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;A5B6yIJ;AAhDA;;;;;EAKA,yBAAA;E6Bp3IQ,cAAA;E1BUN,mBJhBqB;EIiBrB,eAAA;EACA,gB0BX6C;E1BY7C,sB0BZmD;E1BanD,iB0BbwD;A7B26I1D;AAhDA;;;;;E6Br3IQ,cAAA;EACE,mBAAA;E7B23IV,eAAA;E6Bz3IQ,gBAAA;EACE,iBAAA;EACA,iBAAA;A7B46IV;AAhDA;;;;EAIA,cAAA;E6Bx3IU,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;E7B03IZ,iBAAA;A6Bx3IU;A7B26IV;;;EGv7IE,aAAA;EACA,YAAA;EACA,gBAAA;EH04IF,kBAAA;A6B73IU;A7Bg7IV;;EGh8IE,cAAA;EACA,mB0BgBuC;E1BfvC,eAAA;EACA,gBAAA;E0BeU,iBAAA;EACA,iBAAA;A7Bq7IZ;AACA;;;;;;;;;;;;E6Bn6IE,cAAA;E7B+3IF,mBAAA;E6B93IE,eAAA;E1BzCA,gB0B0CgB;E1BzChB,iBAAA;EACA,iB0BwCyB;A7Bm7I3B;AACA;;;;;;;;;;;;EG99IE,c0BmDgB;E1BlDhB,mBAAA;EACA,e0BiDyB;E1BhDzB,gB0BgD+B;E1B/C/B,iB0B+CoC;E1B9CpC,iB0B8CuC;A7B67IzC;AAhDA;;;;;;E8Bn9IE,YAAA;EACA,gBAAA;EACA,UAAA;A9B09IF;AK72IE;;;;;;EyBxGE,YAAA;EACA,gBAAA;EACA,UAAA;A9B8gJJ;AACA;EACE,kB8B9gJE;E9B69IJ,YAAA;E8B39IE,aAAA;A9B+gJF;AACA;;;;;E8BzgJI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;E9B69IJ,mBAAA;E8B19IE,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;A9B49IJ;A8B19II;E3BZF,c2BakB;E3BZlB,mBAAA;EACA,e2BW2B;E3BV3B,gB2BUiC;E3BTjC,iB2BSsC;E3BRtC,iB2BQyC;E9Bi+I3C,YAAA;A8B/9II;A9BmhJJ;EGjiJE,gBAAA;AHmiJF;AACA;EGjiJE,kB2BYyC;E3BXzC,gE2BW4C;EACxC,WAAA;E9Bs+IN,aAAA;E8Bn+IE,cAAA;EACE,mBAAA;EACA,eAAA;E9Bq+IJ,gBAAA;E8Bp+II,iBAAA;EACE,iBAAA;E3BxBJ,YAAA;AHijJF;;AAEA;EG/iJE,cAAA;EACA,mB2BoB0C;E9B2+I5C,eAAA;E8Bz+II,iBAAA;EACE,iBAAA;E3B5BJ,iB2B6BkB;E3B5BlB,gBAAA;AH0jJF;AACA;EGxjJE,gBAAA;AH0jJF;;A8BhiJM;EACE,kBAAA;A9BmiJR;AACA;EAjDA,kBAAA;A8B/+IM;A9BmiJN;EAjDA,YAAA;E8B/+IM,WAAA;EACE,mBAAA;EACA,yBAAA;E9Bi/IR,kBAAA;E8B/+IM,gBAAA;EACE,YAAA;A9BmiJR;AACA;E8BjiJQ;IACA,aAAA;EACA;A9Bi/IR;AAmDA;E8B/hJA;IACE,kBAAA;EACA;A9BiiJF;AAjDA;E8B1+IE,kBAAA;EACE,kBAAA;E9B4+IJ,kBAAA;EAmDE,6DAA6D;E8B3hJ/D,kBAAA;A9B6hJA;AAjDA;;;;EAIE,aAAA;EACF,YAAA;EKv9IE,kBAAA;EyB1BF,yCAAA;A9BsiJA;AACA;EAjDA,aAAA;EK59IE,YAAA;EyB1BF,kBAAA;E9B2iJE,oB8BliJE;E9Bi/IF,iBAAA;AACF;AKj+IE;EyB1BF,kBAAA;E9BgjJE,gE8BpiJE;E9Bm/IF,gDAAA;EACF,kBAAA;EAmDE,kBAAkB;E8BniJpB,YAAA;EACE,aAAA;A9Bm/IF;AAmDA;E8BpiJA,qBAAA;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;E9Bo/IF,eAAA;EAmDE,iBAAiB;E8BpiJnB,iBAAA;EACE,iBAAA;A9Bo/IF;AKr/IE;EyBAF;IAGI,oCAAA;E9Bs/IF;EACF;IK1/IE,oCAAA;EyBAF;A9B+iJA;AACA;EAjDA,kBAAA;EK//IE,YAAA;EyBAF,WAAA;E9BojJE,mB8B3iJE;E9B0/IF,yBAAA;EACF,0BAAA;EAmDE,wBAAwB;E8B1iJ1B,kBAAA;A9B4iJA;AAjDA;EAmDE;I8B3iJF,YAAA;IACE,gBAAA;IACA,gBAAA;EAEA;A9B4iJF;AACA;E8B1iJE,cAAA;E9B0/IF,mBAAA;EAmDE,eAAe;E8B3iJjB,gBAAA;EACE,iBAAA;EACA,iBAAA;A9B6iJF;AACA;E8B5iJE,cAAA;EACA,mBAAA;E9B2/IF,eAAA;EAoDE,gBAAgB;E8B7iJlB,oBAAA;EACE,iBAAA;A9B+iJF;AACA;E8B7iJE,cAAA;E9B4/IF,mBAAA;EAoDE,eAAe;E8B9iJjB,gBAAA;EACE,oBAAA;E3BnIA,iB2BoIc;A9BgjJhB;AACA;EGlrJE,SAAA;EACA,iB2BgIqC;E3B/HrC,kB2B+HwC;E9BkgJ1C,cAAA;EAoDE,mBAAmB;E8BpjJrB,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;A9BsjJF;AACA;E8BpjJE,cAAA;EACA,mBAAA;EACA,eAAA;E3B9IA,gB2B+Ic;E3B9Id,iBAAA;EACA,iB2B6IuB;A9BwjJzB;AACA;EGnsJE,YAAA;EHkpJF,WAAA;EAoDE,mBAAmB;E8BzjJrB,kDAAA;EACE,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;E9BwgJF,kBAAA;A8BvgJE;A9B4jJF;EAlDA;I8BtgJE,YAAA;I3B3JA,mB2B4JgB;I3B3JhB,gBAAA;EACA;AHutJF;AACA;EGrtJE,SAAA;E2BwJE,iBAAA;EACA,kBAAA;EACA,cAAA;E9B6gJJ,mBAAA;E8B5gJI,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;A9BikJN;AACA;EACE,c8BjkJI;E9B8gJN,mBAAA;E8B5gJI,eAAA;E3BvKF,gB2BwKkB;E3BvKlB,iBAAA;EACA,iB2BsK2B;A9BokJ7B;AACA;EGxuJE,kB2BmKyC;EACrC,MAAA;EACA,QAAA;A9BukJN;AACA;E8BrkJM,cAAA;E9BmhJN,mBAAA;E8BhhJE,eAAA;E3BhLA,gB2BiLgB;E3BhLhB,oBAAA;EACA,iB2B+KyB;A9BwkJ3B;AACA;EGrvJE,cAAA;EHmsJF,mBAAA;E8BthJI,eAAA;EACE,gBAAA;EACA,oBAAA;EACA,iBAAA;A9BwhJN;A8BthJI;E3BvLF,YAAA;EACA,kBAAA;EACA,WAAA;AHowJF;AACA;EGlwJE,YAAA;EHgtJF,2BAAA;A8B1hJE;A9BglJF;EG1wJE,kBAAA;AH4wJF;AACA;EG1wJE,YAAA;EACA,YAAA;E2BwLE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;E9BiiJJ,eAAA;EAqDE,gBAAgB;E8BllJlB,iBAAA;EACE,iBAAA;A9BolJF;AACA;E8BllJE,mBAAA;EACA,gEAAA;E9BgiJF,cAAA;EAqDE,mBAAmB;E8BnlJrB,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;A9BiiJF;AAqDA;E8BplJA,kBAAA;EACE,yBAAA;EACA,4CAAA;EACA,uBAAA;A9BslJF;AACA;E8BplJE,cAAA;A9BslJF;AACA;E8BplJE,cAAA;A9BslJF;AACA;EAnDA,SAAA;E8BjiJE,kBAAA;A9BulJF;AACA;E8BrlJI,cAAA;EACA,mBAAA;E9BulJF,e8BvlJE;E9BmiJJ,iBAAA;EAsDE,iBAAiB;E8BtlJnB,iBAAA;A9BwlJA;AACA;E8BtlJE,eAAA;A9BwlJF;AACA;EGj0JE;IACA,UAAA;IACA,qB2ByOuB;E3BxOvB;AHm0JF;AACA;EApDA,gBAAA;AAsDA;A8B5lJA;EACE;IACA,UAAA;EACA;A9B8lJF;AApDA;EK9rJE,mBAAA;EyBiJF,eAAA;E9BqmJE,gB8B/lJE;E9B2iJF,iBAAA;EACF,iBAAA;A8B1iJE;A9BimJF;E8B/lJI,cAAA;E9B4iJJ,mBAAA;E8BziJE,eAAA;EACE,iBAAA;EACA,iBAAA;E3B5PF,iB2B6PgB;E3B5PhB,mBAAA;EACA,qB2B2PyB;E3B1PzB,SAAA;EACA,gBAAA;AH61JF;AApDA;E8B9iJE,SAAA;EACE,qBAAA;A9BqmJJ;AACA;E8BnmJI,SAAA;A9BqmJJ;AApDA;E8B9iJE,qBAAA;EACE,qBAAA;A9BqmJJ;AACA;E8BnmJI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;A9BgjJJ;AAsDA;E8BnmJA,mBAAA;EACE,4CAAA;E9BgjJF,YAAA;AAsDA;A8BpmJA;;;;;;EAKE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;A9BumJF;AACA;;;;;;EKzyJE,YAAA;EyB0LF,gBAAA;A9BunJA;AACA;;;;;;EA/CA,iBAAA;A8BnjJE;A9B0mJF;;;;;;EAME,yBAAyB;E8BtmJrB,YAAA;EACE,gBAAA;A9BwmJR;AACA;;;;;;E8B9lJM,yBAAA;EACA,2BAAA;A9BqmJN;AACA;;;;;;;EA9CA,oBAAA;EAsDE,kDAAkD;E8BjmJpD,mBAAA;A9BmmJA;AApDA;;;;;;;EG13JE,cAAA;E2B+UE,mBAAA;E9BojJJ,eAAA;EAsDE,gBAAgB;E8BtmJlB,iBAAA;EACE,iBAAA;A9BmjJF;AAsDA;;;;;;;E8BhmJE,cAAA;EACA,mBAAA;E9BmjJF,eAAA;EK1zJE,gBAAA;EyBoQF,iBAAA;E9B8mJE,iB8BzmJE;E9BqjJF,gBAAA;EACF,gBAAA;EK/zJE,aAAA;EyBoQF,mBAAA;A9BmnJA;AACA;;;;;;;;E8BpnJA,WAAA;A9B6nJA;AACA;EApDA,gBAAA;AK90JE;ALq4JF;EACE,yB8BjnJE;E9B6jJF,kBAAA;EACF,gBAAA;EKn1JE,kBAAA;AL04JF;AACA;EApDE,cAAA;EACF,mBAAA;EKx1JE,eAAA;EyBoQF,gBAAA;E9B4oJE,iB8BrnJE;E9BikJF,iBAAA;AACF;AAsDA;E8BrnJA,cAAA;EACE,mBAAA;E9BkkJF,eAAA;EKj2JE,gBAAA;EyB8RF,iBAAA;E9B2nJE,iB8BxnJE;A9BynJJ;AApDA;EAsDE,cAAc;E8BvnJhB,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;A9BynJF;;AKn6JE;EyBqSF,YAAA;E9BkoJE,e8BznJE;E9BqkJF,mBAAA;EACF,yBAAA;EKp3JE,yBAAA;EyBqSF,4CAAA;A9BuoJA;AACA;EApDA;IKz3JE,eAAA;EyBqSF;A9B4oJA;AACA;EApDA,kBAAA;EK93JE,WAAA;EyBqSF,aAAA;E9BipJE,mB8B/nJE;E9B2kJF,oBAAA;EACF,iBAAA;AAsDA;A8B/nJA;E3BtZE,kB2BuZc;E3BtZd,aAAA;EACA,sB2BqZuB;E3BpZvB,uB2BoZ6B;A9BooJ/B;AACA;E8BpoJE,kBAAA;EACA,aAAA;E9BilJF,sBAAA;EAsDE,8BAA8B;A8BpoJhC;A9BsoJA;EApDA,aAAA;EAsDE,8BAA8B;E8BroJhC,mBAAA;A9BuoJA;AApDA;EAsDE,cAAc;E8BtoJhB,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;E9BmlJF,iBAAA;AAsDA;A8BpoJA;EACE,cAAA;E9BsoJA,mB8BtoJA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;E9BilJF,iBAAA;EAuDE,mBAAmB;A8BtoJrB;A9BwoJA;EACE,gB8BxoJA;EACA,kBAAA;A9ByoJF;AACA;EAtDA,qBAAA;EAwDE,cAAc;E8BxoJhB,mBAAA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;A9B0oJF;AAtDA;EAwDE,qBAAqB;A8BzoJvB;A9B2oJA;E8BzoJE,gBAAA;EACA,cAAA;EACA,mBAAA;EAEA,eAAA;E9BmlJF,mBAAA;EAwDE,iBAAiB;E8BzoJnB,iBAAA;A9B2oJA;AAtDA;EAwDE,WAAW;E8B1oJb,YAAA;EACE,kBAAA;A9BqlJF;AAwDA;E8B3oJA,aAAA;A9B6oJA;AAtDA;EAwDE,qBAAqB;E+BjnKvB,mBAAA;A/BmnKA;AACA;EOrkKE,cAAA;EACA,mBAAA;EACA,ewB1CE;ExB2CF,iBAAA;EACA,iBwB3CE;ExB4CF,SAAA;APukKF;;AAEA;EAtDA,UAAA;EAwDE,YAAY;E+BlnKd,mBAAA;A/BonKA;AACA;EO1mKE,YAAA;AP4mKF;;AAEA;EO1mKE,WAAA;AP4mKF;AACA;EO1mKE;IACA,UAAA;EwBjBA;A/BukKF;AAwDA;EgCvnKE;IACE,UAAA;EhCkkKJ;AAwDA;AgC3nKE;EACE;IhCskKJ,iBAAA;EAwDE;AgC/nKA;AhCioKF;EAtDA;IAwDI,WAAW;EgCnoKb;AhCqoKF;;AAEA;EgCvoKE,gBAAA;AhCyoKF;;AAEA;EgC3oKE,aAAA;EACE,sBAAA;EhCslKJ,8BAAA;EAwDE,YAAY;AgC/oKZ;;AhC2lKF;EAwDE,aAAa;AgCnpKb;AhCqpKF;EAtDA;IAwDI,YAAY;EgCvpKd;AhCypKF;AAtDA;EAwDE;IgC3pKA,aAAA;EACE;AhCsmKJ;AAwDA;EiCtrKA;IACE,cAAA;EjCioKF;AAwDA;;AAEA;EiCvrKE,kBAAA;AjCkoKF;;AAyDA;EGxqKE,aAAA;EACA,mB8BhByB;E9BiBzB,yB8BjB+B;E9BkB/B,kB8BlBoC;E9BmBpC,WAAA;EHmnKF,kBAAA;AiCpoKE;;AjC8rKF;EGjrKE,sBAAA;EACA,uB8BZyB;E9BazB,oB8Bb+B;E9Bc/B,iB8BdoC;E9BepC,kB8BfuC;EjC2oKzC,iBAAA;AAwDA;;AAEA;EAtDA,iBAAA;EKziKE,gBAAA;E4BnGF,aAAA;EjCssKE,mBiCnsKE;AjCosKJ;;AKpmKE;E4BnGF,iBAAA;EjC2sKE,ciCrsKE;EjC+oKF,mBAAA;EACF,eAAA;EKnjKE,mBAAA;E4BnGF,iBAAA;EjCgtKE,iBiCvsKE;AjCwsKJ;;AK9mKE;E4BnGF,oBAAA;EjCqtKE,WiCzsKE;EjCmpKF,YAAA;EACF,kBAAA;EAwDE,6DAA6D;EiCxsK7D,iBAAA;EACE,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EjCmpKJ,iBAAA;EKtkKE,iBAAA;AL+nKF;;AAEA;EACE,aiC3sKI;EjCqpKJ,8BAAA;EACF,mBAAA;EAwDE,mBAAmB;AiC1sKrB;AjC4sKA;EGluKE,kBAAA;AHouKF;AACA;EGluKE,cAAA;EACA,mB8BmB0C;EAC1C,eAAA;EjC0pKF,gBAAA;EAwDE,iBAAiB;EiChtKnB,iBAAA;E9B3BE,aAAA;EACA,qBAAA;EACA,mB8B0BuB;AjCotKzB;AACA;EG5uKE,YAAA;EHurKF,sBAAA;EAwDE,kBAAkB;EiCttKpB,iBAAA;E9B9BE,oB8B+Bc;E9B9Bd,iBAAA;AHuvKF;AACA;EGrvKE,cAAA;EACA,mB8B0B0C;EAC1C,eAAA;EjCsqKF,gBAAA;EAwDE,iBAAiB;EiC5tKnB,iBAAA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AjC8tKF;AACA;EGtwKE,c8B0Cc;E9BzCd,mBAAA;EACA,e8BwCuB;E9BvCvB,iB8BuC6B;E9BtC7B,iBAAA;EACA,iB8BqC0C;AjC4qK5C;AiC3qKE;EACE,WAAA;EjC6qKJ,YAAA;EAwDE,iBAAiB;AiCluKnB;AjCouKA;EiCluKE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EjCouKA,iBiCpuKA;EjC6qKF,iBAAA;AAyDA;AiCpuKA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EjCsuKA,iBiCtuKA;EjC8qKF,YAAA;EA0DE,iBAAiB;EiCtuKnB,kBAAA;EACE,gEAAA;AjCwuKF;;AAvDA;EiC9qKE,kBAAA;EACE,WAAA;EACA,aAAA;EjCgrKJ,mBAAA;EA0DE,+DAA+D;AiCvuKjE;;AjC0uKA;EG9yKE,kB8BqEuB;E9BpEvB,WAAA;EACA,aAAA;EACA,mB8BkEuC;EACvC,+DAAA;AjCqrKF;;AiClrKA;EACE,YAAA;EjCqrKF,aAAA;EKrqKE,kBAAA;E4BjBF,QAAA;EjCkvKE,SiC/uKE;EjCurKF,gCAAA;EACF,qBAAA;EA0DE,uBAAuB;EiC/uKzB,yBAAA;EACE,mBAAA;EACA,kBAAA;AjCivKF;AAxDA;EA0DE,mBAAmB;EiChvKrB,WAAA;EACE,YAAA;EACA,sBAAA;EjCyrKF,mBAAA;AA0DA;;AAEA;EG50KE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gC8BuFkC;E9BtFlC,kB8BsFqC;EACrC,cAAA;EjC+rKF,mBAAA;EA0DE,eAAe;EiCvvKjB,gBAAA;EACE,iBAAA;EjCgsKF,iBAAA;AA0DA;;AAEA;EiCxvKE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AjCisKF;AK3sKE;E4BKF;IAOI,gBAAA;EjC4vKF;EAxDA;IACF,2BAAA;IA0DI,8BAA8B;EiC3vKlC;EACE;IACA,4BAAA;IACA,6BAAA;EACA;EACA;IjCosKF,6BAAA;EiClsKE;EACE;IACA,mBAAA;EjCosKJ;EA0DE;IiC3vKF,gDAAA;EACE;EACA;IjCosKF,gBAAA;EiCnsKE;EACE;IjCqsKJ,oBAAA;IA0DI,sBAAsB;EiC5vK1B;EACE;IACA,qBAAA;EACA;EACA;IjCqsKF,sBAAA;EA0DE;EiC7vKF;IACE,0BAAA;EACA;EACA;IjCssKF,0BAAA;EA0DE;AiC9vKF;AjCgwKA;EAxDA;IA0DI,gBAAgB;EiC/vKpB;EACE;IACA,2BAAA;IACA,8BAAA;EjCwsKF;EA0DE;IiChwKF,4BAAA;IACE,6BAAA;EACA;EACA;IACA,6BAAA;EACA;;EAEA;IACA,gBAAA;IjCysKF,mBAAA;IA0DI,iBAAiB;EiCjwKrB;EACE;IACA,gDAAA;EACA;EACA;IACA,gBAAA;E9BjKA;EACA;IACA,wB8BgKuB;E9B/JvB;EACA;IACA,oB8B6JqC;IjC+sKvC,sBAAA;EA0DE;EiCvwKF;IACE,sBAAA;EACA;EACA;IACA,0BAAA;E9BxKA;EACA;IACA,qB8BuKuB;E9BtKvB;EACA;IACA,gC8BoKqC;EjCqtKvC;EA0DE;IiC7wKF,0BAAA;EACE;AjCstKF;AiCrtKE;EACE;IjCutKJ,gBAAA;EA0DE;EkCt9KF;IACE,2BAAA;IACA,8BAAA;EACA;EACA;IACA,4BAAA;IlC+5KF,6BAAA;EkC95KE;EACE;IlCg6KJ,6BAAA;EkC95KE;EACE;IACA,wBAAA;EACA;ElCg6KJ;IkC95KE,oBAAA;IACE,sBAAA;EACA;EACA;IlCg6KJ,qBAAA;EA0DE;AkCv9KF;AlCy9KA;EkCv9KE,YAAA;ElCg6KF,aAAA;AA0DA;AkCx9KA;EAEE,qBAAA;EACA,sBAAA;ElCg6KF,cAAA;EkC95KE,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ElCg6KJ,iBAAA;AA0DA;AkCv9KA;E/BZE,c+Bac;E/BZd,mBAAA;EACA,e+BWuB;E/BVvB,iB+BU6B;E/BT7B,iB+BSkC;AlC69KpC;AACA;EkC59KE,cAAA;EACA,mBAAA;ElCq6KF,eAAA;EKz1KE,gBAAA;E6BhFF,iBAAA;ElCq+KE,iBkC/9KE;ElCu6KF,kBAAA;AACF;;AkCr6KA;EACE,iBAAA;AlCi+KF;;AAvDA;EA0DE,4BAA4B;AkCh+K9B;;AlCm+KA;EkCh+KE,kBAAA;ElCy6KF,WAAA;EA0DE,QAAQ;EkCj+KV,2BAAA;E/B/BE,gB+BgCc;E/B/Bd,kBAAA;EACA,e+B8BuB;E/B7BvB,wB+B6B6B;E/B5B7B,iB+B4BkC;E/B3BlC,YAAA;EH08KF,aAAA;EA0DE,sBAAsB;EkCv+KxB,uBAAA;AlCy+KA;AACA;EkCv+KE;IACA,WAAA;EACA;AlCy+KF;AACA;EAxDA;IkC/6KE,WAAA;EACE;AlCi7KJ;AA0DA;EkCx+KA,UAAA;AlC0+KA;;AAEA;EmCjjLA,mBAAA;AnCmjLA;;AAEA;EmCjjLE,kBAAA;EACA,qBAAA;EnCmjLA,sBmCnjLA;EACA,kBAAA;EACA,iCAAA;AnCojLF;AAzDA;EmCx/KE,uBAAA;EACE,qBAAA;EACA,6BAAA;EACA,iCAAA;EACA,2BAAA;EACA,8BAAA;AnC0/KJ;;AA4DA;EACE,gBmCpjLI;EnCqjLJ,amCpjLI;AnCqjLN;;AmCjjLE;EACE,gBAAA;AnC0/KJ;AmCv/KE;EACE,cAAA;EACA,mBAAA;EnCy/KJ,eAAA;EmCx/KI,gBAAA;EACE,iBAAA;EACA,iBAAA;EnC0/KN,mBAAA;AmCv/KI;;AnCojLJ;EmCjjLM,gBAAA;AnCmjLN;;AAEA;EAzDA,cAAA;AmCt/KI;;AnCmjLJ;EmChjLM,UAAA;EACA,iBAAA;EnCw/KN,aAAA;AmCp/KE;AnCgjLF;EmC9iLI;IACA,UAAA;EnCs/KJ;AmCr/KI;AnCijLJ;EGjlLE;IACA,UAAA;EACA;AHmlLF;AACA;EmCpjLM;InC4/KN,iBAAA;EmCx/KE;AnCojLF;AACA;EmCjjLI;InCy/KJ,WAAA;EmCv/KI;AnCmjLJ;AACA;EmCjjLM;IACA,UAAA;EACA;AnCmjLN;AACA;EmCjjLM;IACA,UAAA;EACA;AnCmjLN;AAzDA;EA2DE;ImC1iLA,UAAA;EACE;AnC4iLJ;;AAEA;EAzDA,kBAAA;AmCh/KE;AnC4iLF;EmC1iLI;InCk/KJ,kBAAA;EmCj/KI;AnC6iLJ;;AmCxiLI;EACE,WAAA;EnCi/KN,kBAAA;EmCh/KM,QAAA;EACE,aAAA;EACA,8BAAA;EnCk/KR,aAAA;AmCj/KQ;AnC6iLR;EAzDA;ImCj/KQ,aAAA;EACE;AnC6iLV;AACA;EmC3iLU;IACA,aAAA;EACA;AnCm/KV;AmCh/KM;EACE;IACA,aAAA;EACA;AnC4iLR;AACA;EmC1iLQ;IACA,aAAA;EACA;AnC4iLR;;AAEA;EmC1iLQ,cAAA;EACA,mBAAA;EnCk/KR,eAAA;EmC/+KI,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AnC2iLN;;AAEA;EAzDA,gBAAA;AmCh/KM;;AnCm/KN;EmC/+KM,cAAA;AnC2iLN;;AAEA;EmCziLQ,WAAA;EACA,YAAA;EACA,iBAAA;AnC2iLR;;AAEA;EmCziLQ,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EnCi/KR,mBAAA;AmC/+KM;;AnC4iLN;EmCziLQ,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EnCi/KR,kBAAA;AmCh/KQ;;AnCm/KR;EmC7+KE,kBAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AnCyiLJ;;AAEA;EAzDA,kBAAA;EmC5+KE,mBAAA;EnCwiLA,WAAW;EmCtiLT,YAAA;EACA,YAAA;AnC8+KJ;;AA4DA;EAzDA,yBAAA;AmC5+KE;;AnCyiLF;EmCtiLI,yBAAA;AnCwiLJ;;AAEA;EmCpiLI,qEAAA;AnCsiLJ;;AAEA;EmCpiLI,YAAA;EACA,mBAAA;EnC4+KJ,iBAAA;EmC1+KE,gEAAA;EACE,cAAA;EnC4+KJ,mBAAA;EmC1+KE,eAAA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EnC4+KJ,gBAAA;AmCz+KE;;AnCsiLF;EmCniLI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EnCqiLF,kBmCriLE;EnCsiLF,WmCtiLE;EACA,gBAAA;EACA,8BAAA;AnCuiLJ;;AAEA;EA3DA,uBAAA;AmC1+KI;;AnCyiLJ;EmCtiLM,uBAAA;AnCwiLN;;AA1DA;EmC1+KI,uBAAA;AnCwiLJ;;AmCniLE;EACE,uBAAA;AnC0+KJ;;AmCp+KI;EACE,uBAAA;AnCu+KN;;AA8DA;EmCliLQ,uBAAA;AnCoiLR;;AAEA;EmCliLQ,uBAAA;AnCw+KR;;AA8DA;EmCliLQ,uBAAA;AnCoiLR;;AAEA;EmCliLQ,uBAAA;AnCoiLR;;AAEA;EmCliLQ,wBAAA;AnCoiLR;;AAEA;EA3DA,aAAA;AmCt+KM;;AnCqiLN;EmCliLQ,kBAAA;EACA,mBAAA;AnCoiLR;AACA;EmCliLQ,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AnCoiLR;AACA;EmCliLQ,gBAAA;EnCu+KR,cAAA;EA8DE,mBAAmB;EmChiLrB,eAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AnCq+KF;;AoChxLA;EACI,8BAAA;ApCg1LJ;AA7DA;EA+DE;IqCt1LF,4BAAA;EACE;ArCw1LF;AACA;EGj0LE;IACA,8BkCxB6B;ElCyB7B;AHm0LF;AACA;EqC31LE;IrC+xLF,4BAAA;EA+DE;AqC51LF;ArC81LA;EA7DA;IA+DI,4BAA4B;EqC71LhC;ArC+1LA;;AAEA;EqC91LA,kBAAA;EACE,WAAA;ErCkyLF,mBAAA;EA+DE,4BAA4B;EqC/1L9B,mBAAA;EACE,6CAAA;ArCmyLF;AA+DA;EqCh2LA;IACE,gBAAA;IrCoyLF,YAAA;IA+DI,mBAAmB;EqCj2LvB;ArCm2LA;;AAEA;EsC13LA,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EtC8zLF,sBAAA;EA+DE,iBAAiB;EsC33LnB,kBAAA;AtC63LA;;AAEA;EsC33LE,cAAA;EtC+zLF,mBAAA;EA+DE,eAAe;EsC33LjB,gBAAA;EACE,sBAAA;EACA,iBAAA;AtC63LF;;AA5DA;EA+DE,cAAc;EsC53LhB,mBAAA;EACE,eAAA;EtC83LA,gBsC93LA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AtCg0LF;;AsC9zLA;EACE,kBAAA;EtCg4LA,WsCh4LA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;EtCi0LF,gCAAA;EAiEE,kBAAkB;EsCh4LpB,cAAA;EACE,mBAAA;EACA,eAAA;EtCk0LF,gBAAA;EAiEE,sBAAsB;EsCj4LxB,iBAAA;AtCm4LA;AA/DA;EAiEE,cAAc;AsCl4LhB;;AtCq0LA;EAiEE,iBAAiB;EsCn4LnB,WAAA;EnCjBE,YAAA;EACA,oBAAA;EACA,oBmCgBuB;EnCfvB,iBmCe6B;AtCw4L/B;;AA9DA;EAiEE,iBAAiB;EuCp7LnB,WAAA;EpCuBE,YAAA;EACA,kBAAA;EACA,oBoCxBuB;EpCyBvB,iBoCzB6B;AvCy7L/B;;AAEA;EuCz7LE,kBAAA;EvC23LF,YAAA;EAiEE,UAAU;AuC17LZ;AvC47LA;EA/DA,WAAA;EAiEE,YAAY;AuC37Ld;;AvC87LA;EG76LE,cAAA;EACA,mBoCjB6B;EpCkB7B,eAAA;EACA,gBAAA;EoClBA,mBAAA;EvCk4LF,iBAAA;EAiEE,mBAAmB;AuCj8LrB;;AvCo8LA;EGv7LE,kBoCZuB;AvCq8LzB;AACA;EGv7LE;IHy3LF,2BAAA;EAiEE;AuCv8LF;;AvC08LA;EGl8LE,kBoCLc;EpCMd,yBAAA;EACA,4CoCPuB;AvC28LzB;;AAEA;EA/DA,4BAAA;EAiEE,kDAAkD;AuC78LpD;;AvCg9LA;EuC78LE,cAAA;EAEA,mBAAA;EvC84LF,eAAA;EuC74LE,gBAAA;EpCHA,iBoCIgB;EpCHhB,iBAAA;EACA,mBoCEyB;AvCi9L3B;;AAEA;EA/DA,4BAAA;AAiEA;;AAEA;EuCl9LE,kBAAA;EACA,SAAA;EvCo5LF,WAAA;EAiEE,YAAY;EuCn9Ld,6BAAA;AvCq9LA;AACA;EuCn9LE;IvCq9LE,SuCr9LF;IACA,WAAA;EvCq5LF;AAkEA;;AAEA;EuCr9LE,yBAAA;EACA,kBAAA;EvCs5LF,4BAAA;EAkEE,gBAAgB;EuCt9LlB,aAAA;AvCw9LA;AACA;EuCt9LE,yBAAA;EACA,iBAAA;AvCw9LF;;AAEA;EuCv9LA,sBAAA;EACE,aAAA;AvCw5LF;AAkEA;EuCx9LA,cAAA;AvC09LA;;AAEA;EuCx9LE,aAAA;EvCy5LF,sBAAA;EAkEE,mBAAmB;EuCz9LrB,eAAA;AvC29LA;;AA/DA;EAkEE,iBAAiB;EuC19LnB,oBAAA;EACE,+CAAA;AvC49LF;;AAEA;EuC39LA,4BAAA;AvC69LA;;AAEA;EAhEA,iBAAA;EuC35LE,eAAA;EACE,gBAAA;AvC89LJ;;AAEA;EuC39LE,WAAA;EACE,cAAA;EvC45LJ,mBAAA;EAkEE,eAAe;EuC39LjB,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AvC69LF;;AAEA;EG5hME,4BoC8D6B;EpC7D7B,iBoC6DkC;EpC5DlC,mBoC4DqC;EACrC,yBAAA;EvCi6LF,kBAAA;EuCh6LE,cAAA;EACE,mBAAA;EACA,eAAA;EvCk6LJ,gBAAA;EAkEE,iBAAiB;EuCj+LnB,iBAAA;AvCm+LA;;AAEA;EuCl+LA,4BAAA;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EpC9EA,coC+Ec;EpC9Ed,mBAAA;EACA,eoC6EuB;EpC5EvB,gBoC4E6B;EpC3E7B,iBoC2EkC;EpC1ElC,iBoC0EqC;AvCw6LvC;;AuCt6LA;EpCjFE,8BoCkFc;AvC0+LhB;AACA;EG1jME,kBoC+E6B;AvC6+L/B;;AAEA;EuC7+LE,kBAAA;EvC86LF,kBAAA;EAkEE,yBAAyB;EuC9+L3B,mBAAA;EACE,eAAA;AvCg/LF;AACA;EuC9+LE,kBAAA;AvCg/LF;AAhEA;EK96LE,aAAA;EkCNF,8BAAA;EvCw/LE,mBuCj/LE;AvCk/LJ;AAhEA;EAkEE,kBAAkB;EuCj/LpB,+CAAA;EACE,0BAAA;AvCm/LF;;AAEA;EuCl/LA,aAAA;EACE,mBAAA;AvCo/LF;;AAEA;EuCl/LE,kBAAA;EvCm7LF,kBAAA;AAkEA;AuCn/LA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AvCq/LF;;AAEA;EGpmME,cAAA;EACA,mBoC+GuB;EpC9GvB,eAAA;EACA,gBAAA;EACA,iBoC4GqC;EvCy7LvC,iBAAA;EAkEE,mBAAmB;EuCz/LrB,gBAAA;EACE,uBAAA;AvC2/LF;AACA;EAhEA;IAkEI,gBAAgB;EuC1/LpB;AvC4/LA;;AAEA;EuC3/LA,aAAA;EACE,mBAAA;EACA,oBAAA;AvC6/LF;;AA/DA;EAkEE,iBAAiB;EuC5/LnB,YAAA;EACE,WAAA;AvC8/LF;;AA/DA;EAkEE,cAAc;EuC7/LhB,mBAAA;EpCtIE,eoCuIc;EpCtId,gBAAA;EACA,iBoCqIuB;EpCpIvB,iBoCoI6B;AvCkgM/B;;AAEA;EuClgME,eAAA;EvCm8LF,YAAA;EAkEE,kBAAkB;EuCngMpB,YAAA;EACE,yBAAA;EpC5IA,iBoC6Ic;EpC5Id,yBAAA;AHkpMF;AACA;EGhpME,yBoCyIkC;AvCygMpC;;AAEA;EwC5lMA,kBAAA;AxC8lMA;;AAEA;EwC5lME,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;ExC6hMF,kCAAA;EAkEE,0BAA0B;EwC1jM5B,wBAAA;EACE,wCAAA;ExC2/LF,qBAAA;AAkEA;AwC1jMA;EAEE,SAAA;ExC0/LF,eAAA;EK5gME,QAAA;EmCgBF,gBAAA;ExCgkME,iBwC3jME;AxC4jMJ;AAhEA;EwCz/LE;IACE,sBAAA;IACA,0BzCpDI;EC+iMR;AKrhME;ALwlMF;EACE,iBwC5jMI;AxC6jMN;AACA;EAhEA,eAAA;EwCz/LE,sBAAA;AxC4jMF;AACA;EwC1jMI,6BAAA;ExC2/LJ,YAAA;AKhiME;ALmmMF;EACE,cwC5jMI;ExC6jMJ,mBwC5jMI;ExC4/LJ,eAAA;EACF,iBAAA;EAkEE,iBAAiB;EwC1jMnB,iBAAA;AxC4jMA;AAhEA;EAkEE,wBAAwB;EyC7tM1B,yBAAA;EACE,yBAAA;EzC8pMF,UAAA;AyC7pME;AzCguMF;EyC9tMI,eAAA;EACA,sBAAA;EzC+pMJ,gBAAA;AyC9pMI;AzCiuMJ;EwCxtME,cAAA;EACA,mBAAA;EACA,eAAA;ECRI,gBAAA;EzCkqMN,iBAAA;EyCjqMM,iBAAA;EtCWJ,mBsCVoB;AzCouMtB;AACA;EGxtME,UAAA;EACA,2BsCdyC;EtCezC,uBsCf4C;AzCyuM9C;AAhEA;EyCtqMM,WAAA;EtCOJ,kBsCNoB;EtCOpB,gEAAA;EACA,iBsCR6B;EtCS7B,YAAA;EACA,cAAA;EACA,mBsCX8C;EzC6qMhD,eAAA;EyC3qMM,gBAAA;EtCIJ,iBsCHoB;EtCIpB,iBAAA;AH2uMF;;AAEA;EGzuME,aAAA;EH0qMF,sBAAA;EyC9qME,8BAAA;EACE,2BAAA;AzCivMJ;AACA;EAhEA,SAAA;EAkEE,uBAAuB;A0C7wMzB;A1C+wMA;EAhEA,YAAA;A0C7sME;A1CgxMF;E0C9wMI,uBAAA;A1CgxMJ;AACA;;;;E0C5wMM,+BAAA;EACA,6CAAA;A1CgtMN;A0C/sMM;;;;;EvCgBJ,gCuCfyC;A1CsxM3C;AACA;;;;;EG1wME,yBuCT6B;EvCU7B,8BuCVmC;EvCWnC,0BuCX2C;EvCY3C,2BuCZ8C;E1C2tMhD,iBAAA;E0CztMM,4BAAA;A1C4xMN;AACA;EGtxME,WAAA;EACA,yBuCPmC;EvCQnC,8BuCRyC;EvCSzC,0BuCT4C;E1CguM9C,2BAAA;E0C9tMM,iBAAA;EvCEJ,4BuCDoB;EvCEpB,gBAAA;EACA,kBuCH6B;EvCI7B,iBAAA;EACA,6CuCL2C;EvCM3C,oBuCN8C;EACxC,aAAA;A1CquMR;A0CnuMM;EACE,cAAA;E1CquMR,8BAAA;EAkEE,0BAA0B;EsB3zM5B,2BAAA;EAwSE,iBAAA;EtBq9LF,4BAAA;EsB5vME,uBAAA;AtB+zMF;AACA;;;;EsB3zMM,gBAAA;AtBg0MN;AACA;EGpzME,WAAA;EACA,yBmBbiC;EnBcjC,8BmBdsC;EnBetC,0BmBfyC;EtBowM3C,2BAAA;EsBnwMM,iBAAA;EACE,4BAAA;EtBqwMR,gBAAA;EsBnwMM,kBAAA;EACE,iBAAA;EACA,6CAAA;EtBqwMR,oBAAA;EsBnwMM,aAAA;AtBs0MN;AACA;;;;EGh0ME,oBmBN2C;EACrC,gBAAA;EtB0wMR,kBAAA;EK9qME,iBAAA;EiBxFA,6CAAA;EtB00MA,6BsBx0MI;AtBy0MN;AAhEA;;;;;EsBnwMM,oBAAA;AtB00MN;AACA;EsBx0MM,cAAA;EtBywMN,mBAAA;EK5rME,eAAA;EiBpFE,iBAAA;EtBo1MF,iBsB30MM;EtB40MN,SsB30MM;EtB2wMN,uBAAA;AACF;AsBvwMM;;EAEE,wBAAA;EACA,SAAA;AtB00MR;AACA;EGp2ME,0BAAA;AHs2MF;AACA;EGp2ME,YAAA;EACA,kCmBuB0C;EACpC,kBAAA;EtB8wMR,UAAA;EsBxwMM,oBAAA;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EnBvCN,gBmB6CoB;EnB5CpB,iBAAA;EACA,iBmB2C6B;AtBw0M/B;AACA;EGj3ME,kBmBwC2C;AtB20M7C;AAhEA;EsBhxMQ,kBAAA;EACE,UAAA;EACA,oBAAA;AtBm1MV;AAhEA;EsB5wMI,WAAA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EtB8wMN,eAAA;EKtuME,gBAAA;EiB3CE,iBAAA;EtBq1MF,iBsBh1MM;EtBi1MN,kCsBh1MM;EtBgxMN,wBAAA;EACF,qBAAA;EK5uME,gBAAA;EiB3CE,6BAAA;EtB21MF,gBsBl1MM;EtBm1MN,iBsBl1MM;EtBkxMN,kBAAA;EACF,kBAAA;AsBjxMM;AtBo1MN;EsBl1MQ,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,iBAAA;EnB/CN,kBAAA;AHo4MF;AACA;EAhEA,cAAA;AK5vME;AL+zMF;EACE,gBsBv1MQ;AtBw1MV;;AA/DA;EsBtxMQ,kBAAA;AtBy1MR;AACA;EsBv1MU,kBAAA;EtBwxMV,qBAAA;EKvwME,QAAA;EiBpBM,UAAA;EtB+1MN,YsB11MU;EtB21MV,6BsB11MU;AtB21MZ;AAhEA;EsBzxMU,kBAAA;EACE,qBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EtB2xMZ,6BAAA;EsBzxMU,cAAA;EACE,mBAAA;EtB41MV,esB51MU;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EtB2xMZ,iBAAA;AsBvxMM;AtB21MN;EsBz1MQ,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EnBhFN,QAAA;EACA,UAAA;EACA,YAAA;EH02MF,6BAAA;EKnyME,cAAA;EiBEI,mBAAA;EtBs2MJ,esB/1MQ;EtBg2MR,kBsB/1MQ;EtB8xMR,gBAAA;EACF,iBAAA;EsB5xMQ,iBAAA;AtBg2MR;;AAEA;EGx7ME,gBAAA;EACA,UAAA;EACA,eAAA;AHw3MF;;AAoEA;EACE,mCsBj2MU;EtBk2MV,2BsBj2MU;AtBk2MZ;;AsBh2MU;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EtBiyMZ,gBAAA;EsB/xMU,iBAAA;EACE,iBAAA;EtBm2MV,mBsBn2MU;EACA,iBAAA;AtBo2MZ;;AAjEA;EsB5xMI,yBAAA;AtBi2MJ;;AAEA;EAlEA,yBAAA;AKx0ME;;AL84MF;EACE,yBsBl2MM;AtBm2MR;;AKh5ME;EiBuCE,yBAAA;AtB62MJ;;AAEA;EAlEA,yBAAA;AKp1ME;;AL05MF;EACE,yBsBt2MM;AtBu2MR;;AsBr2MM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AtBw2MR;;AAEA;EG3+ME,WAAA;EH06MF,YAAA;EKn2ME,kBAAA;EiBuDI,kBAAA;AtBk3MN;;AAEA;EAlEA,kBAAA;EKz2ME,YAAA;EiBuDI,UAAA;EtBw3MJ,6BsB52MQ;AtB62MV;;AAjEA;EsBzyMQ,oBAAA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EtB2yMV,kBAAA;AKp3ME;;AL07MF;EACE,oBsB/2MU;EtB6yMV,iBAAA;EACF,WAAA;EsB5yMU,YAAA;EACE,kBAAA;AtBi3MZ;;AAEA;EsBh3MY,iBAAA;EtB8yMZ,kBAAA;AsB1yMM;;AtBi3MN;EsB92MQ,eAAA;AtBg3MR;;AAEA;EGlhNE,iBAAA;AHg9MF;;AAsEA;EACE,csBn3MQ;EtBo3MR,mBsBn3MQ;EtBgzMR,eAAA;EACF,gBAAA;EsB/yMQ,iBAAA;EAEE,iBAAA;AtBo3MV;;AAEA;EGhiNE,cAAA;EACA,mBAAA;EH89MF,eAAA;EKv5ME,gBAAA;EiBgGM,iBAAA;EtB83MN,iBsBv3MU;EtBw3MV,mBsBv3MU;EtBozMV,gBAAA;AACF;;AAsEA;EACE,gDsBz3MU;AtB03MZ;;AAEA;EApEA,cAAA;EsBhzMI,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EtBkzMN,iBAAA;EKx6ME,0BAAA;AL++MF;;AAEA;EApEE,cAAA;EACF,mBAAA;EK96ME,eAAA;EiBmHE,gBAAA;EtBm4MF,iBsB13MM;EtB23MN,iBsB13MM;AtB23MR;;AKx/ME;EiBmHE,gBAAA;EtBy4MF,mBsB53MM;EtB63MN,csB53MM;EtBwzMN,mBAAA;EACF,eAAA;EsBvzMM,gBAAA;EACE,iBAAA;EACA,iBAAA;AtB83MR;;AAEA;EG7kNE,4BAAA;EACA,mBAAA;EH0gNF,kBAAA;EKn8ME,kBAAA;AL0gNF;AACA;EACE,csBj4MQ;EtB6zMR,mBAAA;EACF,eAAA;EsB5zMQ,gBAAA;EACE,iBAAA;EACA,iBAAA;AtBm4MV;;AKlhNE;EiB6IM,kBAAA;EtBy4MN,QsBp4MU;EtBq4MV,UsBp4MU;AtBq4MZ;;AsBn4MU;EACE,WAAA;EtBs4MV,YsBt4MU;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;AtBi0MZ;;AAwEA;EsBn4MQ,6BAAA;EACA,YAAA;EACA,WAAA;AtBq4MR;;AAEA;EArEA,kBAAA;EKn+ME,yBAAA;EiB6JI,4CAAA;EtB+4MJ,kBsBx4MQ;EtBy4MR,mBsBx4MQ;AtBy4MV;;AsBv4MQ;EAEE,gBAAA;AtBy4MV;;AAEA;EG5nNE,YAAA;EACA,WAAA;EHwjNF,kBAAA;EKj/ME,kBAAA;ALyjNF;;AAEA;EArEE,UAAA;EACF,kBAAA;AsBt0MU;;AtB+4MV;EsB74MY,UAAA;EACA,kBAAA;AtB+4MZ;;AsBv4ME;EnBxRA,gDJhBqB;EIiBrB,gBAAA;EACA,kBmBuRuC;AtB44MzC;AACA;EGjqNE,iBmBoRqD;EtBw0MvD,kBAAA;AsBr0ME;;AtB+4MF;EG1qNE,iBAAA;AH4qNF;;AAEA;EG1qNE,YAAA;EmB0RE,6BAAA;EtB40MJ,cAAA;EsB30MI,cAAA;EnBhSF,mBJhBqB;EIiBrB,eAAA;EACA,gBmB+RyC;EnB9RzC,iBmB8R+C;EnB7R/C,iBmB6RoD;EnB5RpD,mBmB4RuD;AtBk1MzD;AsBh1MI;EnBnSF,kBJhBqB;EIiBrB,aAAA;AH6rNF;;AAEA;EG3rNE,gBAAA;AHsnNF;;AAyEA;EGnsNE,qBAAA;EACA,gBmBsSuC;EnBrSvC,eAAA;EACA,cAAA;EACA,mBmBmSqD;EACnD,eAAA;EtB21MJ,gBAAA;EsB11MI,iBAAA;EnB1SF,iBJhBqB;AC8tNvB;;AAEA;EG5sNE,cAAA;EACA,mBmBsSuD;EtBi2MzD,eAAA;EsB/1MI,gBAAA;EnB7SF,iBJhBqB;EIiBrB,iBAAA;EACA,gBmB4SyC;EnB3SzC,kBmB2S+C;AtB26MjD;;AArEA;EAwEE,mBAAmB;EsB16MrB,iBAAA;EACE,0BAAA;EnBjUA,gBmBkUc;EnBjUd,YmBiUoB;AtB66MtB;AACA;EsB76ME;ItBw2MF,mBAAA;EsBv2ME;AtBg7MF;;AAEA;EGnvNE,gBAAA;EmBmUE,mBAAA;AtB42MJ;;AAyEA;EsBl7MM,yBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EtB62MN,mBAAA;AsB12ME;;AtBo7MF;EGjwNE,kBAAA;EACA,gBAAA;EmB8UE,mBAAA;EtB+2MJ,qBAAA;EsB92MI,0BAAA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EtBg3MN,iBAAA;AsB72ME;;AtBu7MF;EsBp7MI,mBAAA;EtB+2MJ,WAAA;EsB92MI,YAAA;AtBu7MJ;;AAEA;EsBr7MM,gBAAA;AtBu7MN;;AAEA;EsBr7MM,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AtBu7MN;;AAEA;EsBr7MM,iBAAA;EtBg3MN,YAAA;EsB92MI,WAAA;AtBu7MJ;;AAEA;EsBr7MM,cAAA;EtBg3MN,mBAAA;EAwEE,eAAe;EsBp7MjB,gBAAA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EtB+2MF,iBAAA;AAwEA;;AAEA;EAtEA,kBAAA;EsB/2ME,cAAA;EACE,mBAAA;EtBi3MJ,eAAA;EsB/2ME,gBAAA;EACE,iBAAA;EACA,iBAAA;AtBw7MJ;;AsBp7MI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AtBg3MN;;AAyEA;EsBr7MM,cAAA;AtBu7MN;;AAEA;EsBr7MM,aAAA;AtBu7MN;AACA;EAtEA;IsB32MI,sBAAA;EACE;AtBo7MN;AACA;EsBl7MM,UAAA;EACA,yBAAA;AtBo7MN;AAtEA;EsB32MM;IACE,WAAA;IACA,iCAAA;EACA;AtBo7MR;AACA;EG/0NE,UAAA;EACA,yBAAA;EACA,+CmB4Z6B;AtBq7M/B;AACA;EG/0NE;IH0wNF,WAAA;IKnrNE,yBAAA;EiB2TI;AtBk8MN;;AArEA;EsBj3MM,cAAA;AtB07MN;;AAEA;EAtEA,aAAA;AsBl3MQ;AtB27MR;EsBz7MU,kBAAA;EACA,4CAAA;EtB27MR,mBsB37MQ;AtB47MV;AAvEA;EsBj3MM,UAAA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EtBm3MR,kBAAA;AsBl3MQ;AtB47MR;EsB17MU,cAAA;EACA,mBAAA;EtB47MR,esB57MQ;EACA,iBAAA;EtBo3MV,iBAAA;EsBh3MM,iBAAA;EACE,oBAAA;AtB27MR;AACA;EGr3NE,cAAA;EACA,mBmBybmC;EnBxbnC,eAAA;EACA,mBmBub2C;EtBu3M7C,iBAAA;EsBr3MM,iBAAA;AtBg8MN;AACA;EG93NE,cAAA;EACA,mBmB8b2C;EnB7b3C,eAAA;EACA,iBmB4bsD;EnB3btD,iBmB2byD;EtB43M3D,iBAAA;AsB13MM;AtBq8MN;EsBn8MQ,YAAA;EtB43MR,WAAA;EsB33MQ,YAAA;AtBs8MR;;AAEA;EsBp8MU,aAAA;AtBs8MV;AACA;EsBp8MU,kBAAA;EtB63MV,4CAAA;EA0EE,mBAAmB;EsBh8MrB,uBAAA;AtBk8MA;AACA;EsBh8ME,gBAAA;EACA,mBAAA;EACA,iBAAA;AtBk8MF;AACA;EsBh8ME,cAAA;EtBy3MF,mBAAA;EA0EE,eAAe;EsBh8MjB,iBAAA;EACE,iBAAA;EACA,iBAAA;EtBy3MF,oBAAA;AA0EA;AsB75MA;EACE,cAAA;EtB+5MA,mBsB95ME;EtB+5MF,esB95ME;EtB+5MF,mBsB95ME;EtBs1MF,iBAAA;EsBp1MA,iBAAA;AtB+5MF;AACA;EAxEE,cAAA;EACF,mBAAA;EsBn1MA,eAAA;EACE,iBAAA;EtBq1MF,iBAAA;EA0EE,iBAAiB;AKz8NnB;AL28NA;EK38NA,cAAA;EA+UA,mBAAA;EL+nNE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EKjoNnB,iBAAA;EsC3UE,kBAAA;A3C+8NF;AACA;E2C78NI,gBAAA;A3C+8NJ;;AAEA;E2C78NI,kBAAA;A3Cs4NJ;A2Cp4NE;EACE,2BAAA;E3Cs4NJ,YAAA;E2Cr4NI,gBAAA;A3Cg9NJ;AACA;EGv8NE,sBwCT2B;ExCU3B,cAAA;EACA,mBwCXuC;ExCYvC,eAAA;EwCXI,gBAAA;EACA,iBAAA;E3C44NN,iBAAA;AA0EA;A2C98NE;EACE,iBAAA;A3Cg9NJ;AACA;E2C98NI,+BAAA;E3Cu4NJ,8BAAA;A2Ct4NI;A3Ci9NJ;E2C/8NM,cAAA;EACA,mBAAA;E3Cw4NN,eAAA;EKvzNE,gBAAA;EsC9EE,iBAAA;E3Ci9NF,iB2C/8NM;E3Cu4NN,kBAAA;AACF;A2Cr4NI;EACE;I3Cu4NN,mBAAA;E2Ct4NM;A3Ci9NN;AACA;EGr+NE,kBwCoB6B;ExCnB7B,4GwCmBmC;ExClBnC,iCwCkByC;ExCjBzC,4BwCiB4C;EACtC,qBAAA;EACA,WAAA;EACA,aAAA;A3C64NR;A2C14NI;ExC5BF;IACA,cAAA;IACA,YAAA;EACA;AHk/NF;AACA;EAxEA,eAAA;EA0EE,mBAAmB;E4C/gOrB,gBAAA;EACE,uBAAA;EACA,cAAA;EACA,mBAAA;E5Cw8NF,eAAA;E4Cv8NE,gBAAA;EzCmBA,iByClBgB;EzCmBhB,iBAAA;EACA,iByCpByB;A5CohO3B;AACA;EG9/NE,eAAA;EHu7NF,mBAAA;E4C58NE,gBAAA;EzCgBA,uByCfgB;EzCgBhB,cAAA;EACA,mByCjByB;EzCkBzB,eAAA;EACA,gBAAA;EACA,iByCpBwC;EACtC,iBAAA;E5Cm9NJ,aAAA;AA0EA;A6CtiOA;;;;;E7Cm+NA,WAAA;E6Ch+NE,YAAA;EACE,iBAAA;A7Ck+NJ;A6Ch+NE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;A7C2iOJ;AAxEA;E6Ch+NE;IACE,SAAA;I7Ck+NJ,UAAA;E6Ch+NE;A7C2iOF;AACA;EAxEA;IA0EI,SAAS;I6CxiOX,UAAA;EACE;A7Ci+NJ;AA0EA;;;;EArEA,kBAAA;EA0EE,2CAA2C;E6CxiO7C,YAAA;EACE,WAAA;E7Ci+NF,kBAAA;E6Ch+NE,aAAA;EACE,uBAAA;EACA,mBAAA;A7C2iOJ;AAxEA;EA0EE;;;;IGtjOA,YAAA;IACA,WAAA;EACA;AH2jOF;AAxEA;;;;;EGp/NE,YAAA;EACA,WAAA;EACA,kB0CeyC;A7CojO3C;AAxEA;E6C1+NI;;;;;IAKA,YAAA;I7C4+NJ,WAAA;EA0EE;A6CljOF;A7CojOA;;;;;;E6C5iOE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,8BAAA;A7C0+NF;A6Cz+NE;;;;;;EAKE,oBAAA;EACE,iBAAA;EACA,WAAA;E7C4+NN,YAAA;E6Cz+NE,kBAAA;A7CojOF;AACA;;;;EGtlOE,kBAAA;EACA,2CAAA;E0CmCE,YAAA;E7Cg/NJ,WAAA;E6C/+NI,kBAAA;EACE,aAAA;E7Ci/NN,uBAAA;E6C/+NI,mBAAA;A7C0jOJ;AACA;EAxEA;;;;IG3jOE,YAAA;IACA,WAAA;EA8BA;AH4mOF;AACA;;;;;E6CzjOI,YAAA;EACE,WAAA;EACA,kBAAA;E7Cs/NN,aAAA;E6Cn/NE,uBAAA;E1C1FA,mB0C2FgB;A7C8jOlB;AACA;EGvpOE;;;;;IA+BA,YAAA;IACA,WAAA;EHsjOF;A6Cx/NI;A7CmkOJ;;;;;;E6C3jOE,kBAAA;E1C3FA,UAAA;EACA,UAAA;EACA,8B0C0FyB;A7CokO3B;AACA;;;;;;E8CtrOE,oBAAA;EACA,iBAAA;EACA,WAAA;E9C6rOA,Y8C7rOA;E9ConOF,kBAAA;A8ClnOE;A9C8rOF;E8C5rOI,kBAAA;EACA,UAAA;EACA,UAAA;A9C8rOJ;AAzEA;EK5gOE;IyC7GA,UAAA;IAQI,UAAA;E9C+rOJ;AACF;AAzEA;E8ClnOE;IACE,UAAA;I9ConOJ,UAAA;E8CjnOE;A9C6rOF;AACA;EAzEA;I8CjnOI,SAAA;IACE,UAAA;EACA;A9C6rON;AACA;;;;E8CxrOA,2CAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;A9C6rOJ;AACA;EAzEA;;;;I8C7mOM,UAAA;IACA,UAAA;E9CknON;A8C9mOE;A9C0rOF;E8CxrOI;;;;IAGE,YAAA;IACA,WAAA;EACA;A9C2rON;AAzEA;;;;;EGrpOE,YAAA;EACA,WAAA;EACA,kB2CqCyC;A9CgsO3C;AAzEA;E8ClnOE;;;;;IAKE,YAAA;IACE,WAAA;EACA;A9C8rON;AACA;;;;;;E8CtrOM,oBAAA;E9CmnON,iBAAA;EA2EE,WAAW;E8C1rOb,YAAA;EACE,kBAAA;A9CknOF;AA2EA;;;;EG7wOE,2C4CV2B;E5CW3B,YAAA;E4CPA,WAAA;E/CgtOF,kBAAA;E+C5sOE,aAAA;EACE,uBAAA;E/C8sOJ,mBAAA;A+C5sOE;A/CwxOF;EGzvOE;;;;I4C3BE,YAAA;I5COF,WAAA;EACA;AHoxOF;AACA;;;;;E+CxxOE,YAAA;EAEE,WAAA;E/CmtOJ,kBAAA;E+CltOI,aAAA;EACE,uBAAA;EACA,mBAAA;A/C8xON;AACA;EGhyOE;;;;;I4CIE,YAAA;IACE,WAAA;EACA;A/CytON;A+CxtOM;;;;;;EAME,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A/CoyOR;AACA;EGxzOE,kB4CsBoB;E5CrBpB,UAAA;EACA,WAAA;AH0zOF;AACA;EGxzOE;IHgvOF,UAAA;I+C9tOQ,WAAA;E5CvBN;AHk0OF;AACA;EGh0OE;IACA,UAAA;IACA,WAAA;EHwvOF;A+CnuOQ;A/C+yOR;EGx0OE;IACA,UAAA;IACA,UAAA;EACA;AH00OF;AAzEA;;;;EAIA,2CAAA;E+CruOQ,YAAA;EACE,WAAA;E5CrCR,kB4CsCsB;E5CrCtB,aAAA;EACA,uB4CoC+B;E5CnC/B,mB4CmCqC;A/CozOvC;AACA;EAzEA;;;;I+CtuOQ,YAAA;IACA,WAAA;E/C2uOR;A+CvuOE;A/CmzOF;;;;;E+C7yOI,YAAA;EACA,WAAA;EACA,kBAAA;A/CmzOJ;AAzEA;E+CxuOI;;;;;I5CxDF,YAAA;IACA,WAAA;EACA;AHi3OF;AACA;;;;;;E+CnzOM,oBAAA;E5CpEJ,iB4CqEoB;E5CpEpB,WAAA;EACA,YAAA;EACA,kB4CkEmC;A/C6zOrC;AACA;;;;EGl4OE,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EHqzOF,uBAAA;E+CjvOE,mBAAA;A/Cq0OF;AACA;E+Cn0OI;;;;I5CzDF,YAAA;IACA,WAAA;EACA;AHk4OF;AAjFA;;;;;E+C/uOM,YAAA;E5CvFJ,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uB4CqFiC;E5CpFjC,mB4CoFsC;A/C20OxC;AAjFA;EAmFE;;;;;IgD57OF,YAAA;IACE,WAAA;EACA;AhDk8OF;AAjFA;;;;;;EGx1OE,oB6CtBoC;E7CuBpC,iB6CvBuC;EACrC,WAAA;EhDs3OJ,YAAA;EgDp3OE,kBAAA;AhDw8OF;AACA;EgDt8OI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AhDs3OJ;AgDp3OE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EhDs3OJ,iBAAA;EAmFE,uBAAuB;AgDt8OzB;AhDw8OA;EgDt8OE,cAAA;EACF,mBAAA;EAEA,eAAA;EhDq3OA,gBAAA;EAmFE,iBAAiB;EgDr8OnB,iBAAA;AhDu8OA;AAjFA;EAmFE,cAAc;EgDt8OhB,mBAAA;EACE,eAAA;EhDs3OF,gBAAA;EAmFE,iBAAiB;EgDv8OnB,iBAAA;AhDy8OA;AAjFA;EAmFE,cAAc;EgDx8OhB,mBAAA;EACE,eAAA;EhDw3OF,gBAAA;EAmFE,iBAAiB;EiDx/OnB,iBAAA;EACE,kBAAA;AjD0/OF;AACA;EAjFA,cAAA;EiDv6OE,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AjD2/OJ;AACA;EiDx/OI,cAAA;EACA,mBAAA;EjDw6OJ,eAAA;EAmFE,gBAAgB;EiDx/OlB,iBAAA;EACE,iBAAA;AjD0/OF;;AAhFA;EiDt6OA,kBAAA;EACE,YAAA;EACA,WAAA;EjDw6OF,mBAAA;EAmFE,yBAAyB;EiDx/O3B,yBAAA;AjD0/OA;AACA;EiDx/OE,YAAA;EACA,WAAA;EACA,mBAAA;EjDw6OF,yBAAA;EiDt6OE,iBAAA;AjD0/OF;AACA;EiDx/OI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EjDw6OJ,kBAAA;AiDt6OE;AjD0/OF;EAjFA,YAAA;EiDt6OE,WAAA;EACE,mBAAA;EjDw6OJ,sBAAA;EiDt6OE,iBAAA;AjD0/OF;AAjFA;EiDt6OE,kBAAA;EACE,aAAA;EjDw6OJ,aAAA;EAmFE,cAAc;EiDv/OhB,kBAAA;AjDy/OA;AACA;EiDv/OE,kBAAA;EACA,SAAA;EACA,WAAA;AjDu6OF;AAmFA;EiDv/OA,kBAAA;EACE,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EjDu6OF,mBAAA;EiDr6OE,kBAAA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EjDu6OJ,wBAAA;AiDr6OE;AjDy/OF;EAjFA,kBAAA;EiDr6OE,QAAA;EACE,WAAA;EjDu6OJ,oBAAA;AiDr6OE;;AjDw6OF;EiDr6OE,WAAA;EACE,UAAA;EjDu6OJ,iBAAA;AAmFA;;AAEA;EACE,kBiDt/OE;AjDu/OJ;AACA;EACE,oCiDt/OE;AjDu/OJ;AAjFA;EiDl6OA,aAAA;EACE,mBAAA;EjDs/OA,yBiDr/OE;AjDs/OJ;AACA;EiDp/OE,cAAA;EjDs/OA,mBiDr/OE;EjDo6OF,eAAA;EiDj6OA,gBAAA;EjDq/OA,iBiDp/OE;EjDq/OF,iBiDp/OE;EjDm6OF,kBAAA;AACF;AiDh6OA;EACE,SAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EjDk6OF,kBAAA;AAmFA;AiDl/OA;EACE,aAAA;EjDo/OA,8BiDn/OE;EjDk6OF,aAAA;EiDh6OA,mBAAA;EjDo/OA,mBiDn/OE;EjDk6OF,yBAAA;AAmFF;AACA;;;;EiD9+OE,SAAA;EjDi6OF,mBAAA;EAmFE,gBAAgB;EiDj/OlB,uBAAA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EjDi6OF,iBAAA;EAmFE,iBAAiB;AiDl/OnB;AjDo/OA;EiDl/OE;;;;IjDq6OF,gBAAA;EAmFE;AiDl/OF;AjDo/OA;;;;EiD/+OE,WAAA;EjDo/OA,YiDn/OE;EjDk6OF,kBAAA;AAmFF;AACA;;;;EkDzpPI,WAAA;EACI,YAAA;ElD4kPR,oBAAA;EAmFE,iBAAiB;EmDjqPnB,kBAAA;AnDmqPA;AACA;;;;EmD/pPI,WAAA;EACE,YAAA;EACA,kBAAA;AnDklPN;AmDhlPI;;;;EhDcF,WAAA;EACA,YAAA;EACA,oBgDZ2B;EhDa3B,iBgDbiC;EhDcjC,kBAAA;AH0pPF;AACA;;;;EmDpqPM,SAAA;EnDulPN,cAAA;EmDrlPI,mBAAA;EhDGF,egDFkB;EhDGlB,gBAAA;EACA,iBgDJ2B;EhDK3B,iBgDLiC;AnD4qPnC;AACA;;;;EA9EA,SAAA;EmD3lPM,cAAA;EhDFJ,mBgDGoB;EhDFpB,eAAA;EACA,gBgDC6B;EhDA7B,iBAAA;EACA,iBgDDyC;AnDmrP3C;AAjFA;;;;EGnmPE,aAAA;EACA,mBgDIiC;AnDsrPnC;AACA;;;;;EA7EA,cAAA;EmDpmPI,mBAAA;EhDbF,egDckB;EhDblB,kBAAA;EACA,iBgDY2B;EhDX3B,iBgDWiC;EhDVjC,kBgDUuC;AnD4rPzC;;AAhFA;EmDzmPI,cAAA;EhDjBF,mBgDkBkB;EhDjBlB,gBAAA;EACA,egDgB2B;EhDf3B,iBgDeiC;EhDdjC,iBAAA;EACA,iBgDa8C;EAC1C,mBAAA;AnDgnPN;;AAoFA;EmDhsPM,UAAA;EACA,mCAAA;AnDksPN;;AAhFA;EmD9mPI;IhD5BF,UAAA;IACA,4BAAA;IACA,kBgD2B2B;EhD1B3B;EACA;IACA,UAAA;IgDyBI,wBAAA;EACA;AnDusPN;AAjFA;EAmFE,kBAAkB;AoD/vPpB;;ApDkwPA;;CAEC;AACD;;;;EoDhwPE;ApDqwPF;EG/tPE,kBAAA;EACA,mBAAA;EiDrCE,yBAAA;EpDqrPJ,6CAAA;EoDnrPE,aAAA;EjDiCA,aAAA;EACA,YAAA;AHuuPF;AACA;EoDvwPI,kBAAA;ApDywPJ;AACA;EG7vPE,cAAA;EACA,mBiDb+B;EjDc/B,eAAA;EACA,iBiDfwC;EpD4rP1C,iBAAA;EoD1rPE,iBAAA;EjD2BA,mBAAA;EACA,gBAAA;AHovPF;;AAEA;EAjFA,kBAAA;EoD5rPI,uBAAA;EjDXF,aiDYkB;EjDXlB,mBiDWwB;ApDixP1B;AACA;EoDjxPM,mBAAA;EACA,yBAAA;EACA,kBAAA;ApDisPN;AoD1rPI;EACE;IACA,iBAAA;EACA;ApD8wPN;AACA;EoD5wPM,aAAA;ApD4rPN;AAmFA;EqDpzPA,cAAA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oCAAA;ErDouPF,kBAAA;AKxnPE;AL4sPF;EACE,cqDvzPE;ErDsuPF,mBAAA;EACF,eAAA;EK7nPE,iBAAA;EgDnHF,iBAAA;ErDq0PE,iBqDzzPE;ArD0zPJ;;AKntPE;EgDnHF,kBAAA;ErD00PE,yBqD3zPE;ErD0uPF,aAAA;AACF;AqDzuPE;EACE,cAAA;ErD2uPJ,mBAAA;EqD1uPI,eAAA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;ArD8zPN;AACA;EqD5zPM,cAAA;EACA,mBAAA;ErD4uPN,eAAA;EqD1uPI,iBAAA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;ArD8zPN;;AqD5zPM;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArD6uPR;AqD5uPQ;EACE,aAAA;ArDg0PV;AACA;EACE,UqDh0PQ;EACA,eAAA;EACA,oBAAA;EACA,YAAA;ArDi0PV;AAlFA;EqD7uPU,SAAA;ArDk0PV;AACA;EqDh0PY,kBAAA;ErDk0PV,mBqDl0PU;ArDm0PZ;;AqD/zPQ;EACE,YAAA;ArDk0PV;;AAlFA;EqD1uPI,yBAAA;EACE,mBAAA;ArD4uPN;;AAsFA;EqD9zPM,gBAAA;ArDg0PN;AACA;EqD9zPM,WAAA;EACA,YAAA;EACA,mBAAA;ArDg0PN;;AAEA;EqD9zPM,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ErD4uPN,iBAAA;EqD3uPM,iBAAA;ArDi0PN;AACA;EqD/zPQ,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ErD6uPR,iBAAA;EqD1uPI,gBAAA;ArDg0PJ;AACA;EqD9zPM,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;ArDg0PN;;AAEA;EqD9zPM,YAAA;EACA,aAAA;EACA,oBAAA;ErD4uPN,mBAAA;EAqFE,YAAY;EqD5zPd,gBAAA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ArD8zPF;AACA;EqD5zPE,oCAAA;ArD0uPF;AAqFA;EqD5zPA,+BAAA;ArD8zPA;AACA;EAnFA,0BAAA;EAqFE,oCAAoC;AqD7zPtC;ArD+zPA;EqDzzPE,YAAA;ErDuuPF,WAAA;EAqFE,mBAAmB;EqD1zPrB,yBAAA;EACE,aAAA;EACA,uBAAA;ErDwuPF,mBAAA;EAqFE,YAAY;AqD3zPd;ArD6zPA;EqD3zPE,eAAA;ArDyuPF;AAqFA;EqD3zPA,eAAA;EACE,cAAA;ArD6zPF;AACA;EqD3zPE,YAAA;ErD6zPA,WqD5zPE;ErDyuPF,mBAAA;EACF,yBAAA;EsDx3PA,aAAA;EACE,uBAAA;EtD03PF,mBAAA;AsDz3PE;AtD+8PF;EsD78PI,eAAA;AtD+8PJ;AACA;EsD78PI,eAAA;EACA,cAAA;AtD23PJ;AsD13PI;EnDcF,YAAA;EACA,WAAA;EACA,mBmDf2B;EnDgB3B,sBmDhBiC;EnDiBjC,gEmDjBuC;EnDkBvC,YAAA;EH+2PF,WAAA;EsD/3PI,aAAA;EnDWF,uBmDVkB;EnDWlB,mBAAA;AH28PF;AACA;EGz8PE,eAAA;AH28PF;AAnFA;EsDn4PE,eAAA;EnDOA,cmDNgB;AtDy9PlB;AACA;EGj9PE,cAAA;EACA,mBmDVoC;EnDWpC,eAAA;EH+3PF,kBAAA;EsDz4PI,iBAAA;EnDKF,iBmDJkB;AtD+9PpB;;AAEA;EGz9PE,sBmDRsC;EnDStC,mBmDT2C;EtDg5P7C,qBAAA;EsD94PI,kCAAA;EnDEF,0BmDDkB;AtDo+PpB;AACA;EGj+PE,SAAA;EACA,eAAA;EACA,QAAA;EmDLI,gBAAA;EtDq5PN,iBAAA;AsDn5PI;AtDy+PJ;EG1+PE;IACA,sBmDC2B;InDA3B,0BAAA;EACA;AH4+PF;AACA;EAnFA,iBAAA;AsDx5PI;AtD8+PJ;EGn/PE,eAAA;EACA,sBmDK2B;AtDg/P7B;AACA;EGn/PE,cAAA;EmDGI,mBAAA;EtD+5PN,eAAA;EsD55PE,iBAAA;EnDXA,iBmDYgB;EnDXhB,iBAAA;AH8/PF;AACA;EG5/PE,gBAAA;EACA,cAAA;EmDQE,YAAA;EACA,eAAA;EtDm6PJ,iBAAA;EsDj6PE,iBAAA;EnDhBA,iBmDiBgB;EnDhBhB,mBAAA;AHwgQF;AACA;EGtgQE,wBmDaoC;EnDZpC,yBmDYyC;EACvC,yBAAA;EtDw6PJ,UAAA;AAqFA;AsDz/PA;EnDtBE,aAAA;EACA,sBAAA;EACA,mBmDqBuB;AtD6/PzB;AACA;EGhhQE,2BmDkBuC;EACvC,gBAAA;EtD46PF,kBAAA;EAqFE,mBAAmB;AsD9/PrB;AtDggQA;EG1hQE,cAAA;EACA,mBmD0BuB;EnDzBvB,eAAA;EACA,gBAAA;EACA,iBmDuBuC;EACvC,iBAAA;EtDi7PF,mBAAA;AsDh7PE;AtDsgQF;EAnFA,+BAAA;EAqFE,2BAA2B;EsDngQ7B,uBAAA;AtDqgQA;AACA;EGviQE,WAAA;EACA,kBmDiC6B;EnDhC7B,gEmDgCkC;EnD/BlC,iBmD+BuC;EACvC,cAAA;EtDs7PF,mBAAA;EAqFE,eAAe;EsDxgQjB,gBAAA;EnDxCE,iBmDyCc;EnDxCd,iBAAA;AHmjQF;;AAEA;EGjjQE,2BmDoCoC;AtD27PtC;;AAsFA;EGzjQE,YAAA;EACA,YAAA;EACA,mBmDwC4B;EnDvC5B,yBmDuCiC;EnDtCjC,YAAA;AH2jQF;AAnFA;EsDh8PI,aAAA;AtDshQJ;AAnFA;EAqFE,aAAa;EsDlhQf,uBAAA;EnDnDE,mBmDoDc;EnDnDd,sBAAA;AHwkQF;AACA;EGtkQE,cAAA;EACA,mBmD+CuC;EtDq8PzC,eAAA;EsDp8PE,iBAAA;EACE,iBAAA;EtDs8PJ,iBAAA;EAqFE,iBAAiB;AsDvhQnB;AtDyhQA;EGllQE,gBAAA;AHolQF;AACA;EGllQE,eAAA;EACA,kBmDsDuC;EtD08PzC,cAAA;EAqFE,mBAAmB;EsD5hQrB,eAAA;EnD9DE,gBmD+Dc;EnD9Dd,mBAAA;EACA,iBmD6DuB;AtDgiQzB;AACA;EG3lQE,WAAA;EHygQF,kBAAA;AAqFA;AsDjiQA;EACE,WAAA;AtD+8PF;AAqFA;EsDliQA,uBAAA;EACE,wBAAA;EtDg9PF,eAAA;EAqFE,eAAe;EsDliQjB,iBAAA;EnDzEE,gBmD0Ec;EnDzEd,gCAAA;EACA,mBmDwEuB;EnDvEvB,aAAA;EACA,cAAA;EACA,mBmDqEuC;EtDq9PzC,eAAA;EsDp9PE,gBAAA;EACE,mBAAA;EtDs9PJ,iBAAA;AsDp9PE;AtD0iQF;EGxnQE,cmDgFgB;EnD/EhB,mBAAA;EACA,emD8EsB;EnD7EtB,gBmD6E4B;EnD5E5B,mBmD4EiC;EnD3EjC,iBmD2EsC;AtD29PxC;AAqFA;;;;;EG7nQE,cAAA;EACA,mBmDiFkC;EnDhFlC,eAAA;EmDiFA,gBAAA;EACA,mBAAA;EtD+9PF,iBAAA;AsD99PE;AtDojQF;;;;;EG5oQE,iBmD8FgB;EnD7FhB,oBAAA;AHkpQF;AACA;;;;;EuD3qQA,yBAAA;EACE,cAAA;EACA,mBAAA;EvD6lQF,eAAA;EuD3lQE,gBAAA;EACE,sBAAA;EACA,iBAAA;AvDirQJ;AACA;EuD/qQI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,oBAAA;AvDirQJ;AACA;EAnFA,kBAAA;EuD3lQE,WAAA;EACE,WAAA;AvDirQJ;AACA;EAnFA,kBAAA;EAqFE,iBAAiB;EuD/qQnB,aAAA;EACE,uBAAA;AvD6lQF;AuD3lQE;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EvD6lQJ,iBAAA;EuD1lQE,yBAAA;EACE,kBAAA;EvD4lQJ,yBAAA;EuD3lQI,aAAA;EACE,WAAA;EvD6lQN,aAAA;AuD1lQE;AvDgrQF;EAnFA,cAAA;EAqFE,mBAAmB;EwD1tQrB,eAAA;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;AxD4tQF;AACA;EwD1tQE,cAAA;ExDwoQF,mBAAA;EAqFE,eAAe;EwD3tQjB,gBAAA;EACE,sBAAA;EAEA,iBAAA;AxDwoQF;AAqFA;EwD3tQA,gBAAA;EACE,UAAA;ExDyoQF,eAAA;EAqFE,iBAAiB;AwD3tQnB;AxD6tQA;EwD3tQE,aAAA;ExDyoQF,uBAAA;EAqFE,mBAAmB;EwD5tQrB,iBAAA;AxD8tQA;AACA;EwD5tQE,mBAAA;EACA,gEAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;ExD0oQF,mBAAA;EAqFE,eAAe;EwD7tQjB,gBAAA;EACE,iBAAA;EACA,iBAAA;AxD+tQF;;AAEA;EwD7tQE,6BAAA;AxD2oQF;;AwDzoQA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AxDguQF;AACA;EwD9tQE,cAAA;ExD4oQF,mBAAA;EAqFE,eAAe;EwD9tQjB,gBAAA;EACE,iBAAA;ExDguQA,iBwD/tQE;ExDguQF,oBwD/tQE;AxDguQJ;AACA;EACE,awD/tQE;ExDguQF,uBwD/tQE;ExD4oQF,mBAAA;EACF,uBAAA;EyDlsQE,iBAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AzDwxQJ;AACA;EGlxQE,cAAA;EACA,mBAAA;EHgsQF,eAAA;EAqFE,iBAAiB;EyDzxQnB,iBAAA;EtDeE,iBsDdc;AzD2xQhB;;AAEA;EG3wQE,cAAA;EACA,kBsDnBuC;EzD4sQzC,eAAA;EAqFE,cAAc;AyD/xQhB;;AzDkyQA;EGpxQE,yBsDbuB;AzDmyQzB;;AAEA;EyDpyQE,yBAAA;AzDktQF;;AyD/sQA;EACE,yBAAA;AzDsyQF;;AAEA;EyDpyQE,yBAAA;AzDktQF;;AAsFA;EAnFA,aAAA;EyD/sQE,uBAAA;EtDJA,mBsDKgB;AzDqyQlB;AACA;EGxyQE,WAAA;EACA,WAAA;EACA,YAAA;EsDCE,yBAAA;EACA,yBAAA;EzDstQJ,4BAAA;EyDptQE,uCAAA;EACE,kBAAA;AzD0yQJ;;AAEA;EAnFA;IyDrtQI,wBAAA;EtDdF;AH0zQF;AACA;EGxzQE,gBsDYiC;EtDXjC,mBsDWsC;AzD+yQxC;;AAEA;EyD9yQM,WAAA;EACA,YAAA;EzD4tQN,aAAA;EAqFE,uBAAuB;EyD7yQzB,mBAAA;AzD+yQA;AACA;EyD7yQE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EzD2tQF,kCAAA;AyD1tQE;AzDgzQF;EG90QE,mBAAA;AHg1QF;AACA;EG90QE,sBsD4BoC;AzDozQtC;AACA;EAnFA,qBAAA;AyDhuQI;AzDszQJ;EyDpzQM,sBAAA;AzDkuQN;;AAsFA;EAnFA,WAAA;EyD/tQE,YAAA;EtD1CA,mBsD2CgB;EtD1ChB,yBAAA;EACA,4DsDyCyB;AzDuzQ3B;;AAEA;EAnFA,WAAA;EyDruQI,YAAA;EACE,aAAA;EzDuuQN,uBAAA;EyDnuQE,mBAAA;AzDyzQF;AACA;EyDvzQI,WAAA;EzDquQJ,YAAA;EAqFE,yBAAyB;EyDtzQ3B,gBAAA;EACE,kBAAA;EACA,kCAAA;AzDwzQF;AACA;EyDtzQE,mBAAA;AzDwzQF;AACA;EyDtzQE,sBAAA;AzDwzQF;AAnFA;EyDnuQE,qBAAA;AzDyzQF;AACA;EyDvzQI,sBAAA;AzDquQJ;;AAsFA;EGh4QE;;IAEA,mBsDsE2B;EtDrE3B;EACA;IACA,qBsDmE2C;EACvC;AzD2uQN;AAqFA;EyD3zQA;IACE,YAAA;IACA,wBAAA;EACA;EzDyuQF;IyDxuQE,YAAA;EACE;EACA;IzD0uQJ,YAAA;IyDzuQI,wBAAA;EACE;AzD+zQN;AACA;EAnFA,WAAA;EyD1uQM,aAAA;EtDzFJ,yBsD0FoB;EtDzFpB,uCAAA;EACA,wCsDwF6B;EtDvF7B,mBsDuFmC;EtDtFnC,YAAA;AH05QF;;AyDl0QM;EtD5FJ;IACA,UAAA;EACA;EACA;IACA,YAAA;EACA;EH80QF;IyDnvQI,UAAA;EACE;AzDy0QN;AACA;EAnFA,aAAA;AyDpvQM;;AzD20QN;EyDx0QQ,WAAA;EzD00QN,YyD10QM;EzDsvQR,yBAAA;EAsFE,mBAAmB;EyDv0QrB,wCAAA;AzDy0QA;;AAnFA;EAsFE,aAAa;EyDv0Qf,cAAA;EAEE,yBAAA;EACA,mBAAA;EzDmvQF,wCAAA;AAsFA;;AAEA;EG97QE;IACA,YAAA;IACA,wBsDoH6B;EtDnH7B;EACA;IsDmHA,YAAA;EACA;EzDyvQF;IAsFI,YAAY;IyD70QhB,wBAAA;EtD3HE;AH28QF;AACA;EGz8QE,2BsDyH6B;AzDk1Q/B;;AAEA;EApFA,oCAAA;EAsFE,WAAW;EyDn1Qb,aAAA;EtD/HE,aAAA;AHq9QF;AACA;EGn9QE,mBsD6H6B;EtD5H7B,yBsD4HkC;AzDy1QpC;AApFA;EAsFE,sBAAsB;AyDz1QxB;AzD21QA;EApFA,cAAA;EyDrwQE,mBAAA;EACE,eAAA;EzDuwQJ,gBAAA;EyDrwQE,oBAAA;EACE,iBAAA;EzDuwQJ,kBAAA;AAsFA;AyD11QA;EtD3IE,YAAA;EACA,aAAA;AHw+QF;AACA;EGt+QE,cAAA;EACA,mBsDuIuC;EzD4wQzC,eAAA;EAsFE,gBAAgB;EyDh2QlB,iBAAA;EtD9IE,iBsD+Ic;EtD9Id,kBAAA;EACA,mBsD6IuB;EtD5IvB,gBsD4I6B;AzDq2Q/B;AACA;EApFA,cAAA;EAsFE,mBAAmB;EyDt2QrB,eAAA;EACE,iBAAA;EACA,iBAAA;EzDmxQF,iBAAA;AyDjxQI;AzDw2QJ;EG5/QE,cAAA;EACA,mBsDoJ2B;EtDnJ3B,eAAA;EACA,iBsDkJsC;EtDjJtC,sBsDiJyC;EACrC,iBAAA;EzDwxQN,kBAAA;EAsFE,aAAa;EyDz2Qf,uBAAA;EACE,mBAAA;AzDsxQF;AAsFA;EyD12QA,cAAA;EACE,mBAAA;EtDhKA,esDiKc;EtDhKd,iBAAA;EACA,iBsD+JuB;EtD9JvB,iBsD8J6B;EtD7J7B,kBAAA;AH6gRF;AApFA;EAsFE,cAAc;EyDh3QhB,mBAAA;EACE,eAAA;EACA,iBAAA;EzD6xQF,qBAAA;EAsFE,iBAAiB;EyDj3QnB,kBAAA;AzDm3QA;AApFA;EAsFE,YAAY;EyDl3Qd,mBAAA;EACE,gEAAA;EtD3KA,YAAA;EACA,YAAA;AHgiRF;AACA;EG9hRE,0DsDwKkC;EtDvKlC,wCsDuKuC;EzDoyQzC,+CAAA;AAsFA;;AAEA;EApFA,mBAAA;EAsFE,eAAe;EyDz3QjB,iBAAA;EACE,iBAAA;EzDsyQF,iBAAA;EAsFE,gBAAgB;EyD13QlB,YAAA;EACE,oBAAA;AzD43QF;;AAEA;EGhjRE,YAAA;EACA,UAAA;EACA,mBsDiLuC;EzD4yQzC,yBAAA;EAsFE,kBAAkB;EyDh4QpB,UAAA;EACE,YAAA;AzD6yQF;AAsFA;EyDh4QA,aAAA;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;AzDk4QF;AACA;EApFA,aAAA;EAsFE,uBAAuB;EyDh4QzB,mBAAA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EzD6yQF,mBAAA;EAsFE,eAAe;EyDj4QjB,iBAAA;EACE,iBAAA;EACA,iBAAA;AzDm4QF;AACA;EyDj4QE,aAAA;EACA,uBAAA;EzD8yQF,mBAAA;EAsFE,iBAAiB;EyDl4QnB,oBAAA;AzDo4QA;AACA;EyDl4QE,YAAA;EACA,UAAA;EzD+yQF,mBAAA;EAsFE,yBAAyB;EyDn4Q3B,YAAA;EAEE,yBAAA;EACA,cAAA;AzDo4QF;AACA;EyDl4QE,YAAA;EACA,UAAA;EACA,mBAAA;EzD+yQF,gEAAA;EyD9yQE,cAAA;EACE,YAAA;AzDq4QJ;;AAEA;EyDn4QI,YAAA;EACA,UAAA;EzDgzQJ,mBAAA;EyD9yQE,yBAAA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AzDq4QJ;AACA;EyDn4QI;IACA,UAAA;EzDgzQJ;AyD9yQE;AzDq4QF;EyDn4QI;IACA,UAAA;EACA;AzDq4QJ;AACA;EyDn4QI;IzDgzQJ,UAAA;EAsFE;AyDl4QF;AzDo4QA;EyDl4QE,aAAA;AzDo4QF;AACA;EyDl4QE,mBAAA;EACA,eAAA;EACA,gBAAA;EzD+yQF,iBAAA;EAsFE,iBAAiB;EyDn4QnB,kBAAA;EACE,cAAA;AzDq4QF;AACA;EyDn4QE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AzDgzQF;AAsFA;;;;EyDj4QE,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;AzDs4QF;AApFA;;;;;EyD5yQE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EzDkzQF,mBAAA;EAsFE,kBAAkB;EyDr4QpB,yBAAA;AzDu4QA;AACA;;;;;EyDl4QI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AzDw4QJ;AApFA;;;;;EyD7yQI,kBAAA;EACA,QAAA;EzDmzQJ,WAAA;AAsFA;AyDr4QA;EACE,gBAAA;AzDkzQF;AAsFA;EyDt4QA,WAAA;EACE,kBAAA;EzDmzQF,iBAAA;EAsFE,oBAAoB;EyDv4QtB,mBAAA;EACE,yBAAA;EzDozQF,yBAAA;EAsFE,cAAc;EyDx4QhB,mBAAA;EACE,eAAA;EzDqzQF,gBAAA;EAsFE,iBAAiB;EyDz4QnB,iBAAA;EACE,kBAAA;AzDszQF;AAsFA;;;;EAIE,eAAe;EyD34QjB,kBAAA;EACE,OAAA;EzDwzQF,MAAA;EAsFE,WAAW;EyD54Qb,YAAA;EACE,UAAA;AzDyzQF;AAsFA;E0DnvRA,WAAA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;E1DgqRF,yBAAA;E0D/pRE,yBAAA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;A1DiqRJ;;AAuFA;E0DrvRM,WAAA;E1DkqRN,YAAA;E0DhqRI,kBAAA;EACE,mBAAA;E1DkqRN,YAAA;E0DjqRM,kBAAA;EvDKJ,sCuDJoB;A1DwvRtB;;AAEA;EGlvRE,6DuDRwC;EvDSxC,gDuDT2C;A1D6vR7C;;AAnFA;E0DtqRM;;;;GvDGJ;EACA,iDuDHwC;A1DiwR1C;;AAnFA;E0DzqRE,6DAAA;EACE,iDAAA;A1DgwRJ;;AAEA;E0D9vRI,6DAAA;EACA,kDAAA;A1DgwRJ;;AAEA;E0D7vRA;IACE,oCAAA;EACA;EACA;IACA,oCAAA;E1D0qRF;A0DzqRE;A1DgwRF;EApFA,aAAA;A0D1qRI;A1DiwRJ;EApFA,aAAA;E0D3qRM,8BAAA;EvD1BJ,mBuD2BoB;EvD1BpB,kDAAA;EACA,oBuDyB6B;EvDxB7B,mBuDwBmC;A1DqwRrC;AACA;E0DrwRQ,cAAA;EACA,mBAAA;E1DkrRR,eAAA;E0DhrRM,iBAAA;EvD/BJ,mBuDgCoB;EvD/BpB,iBAAA;AHuyRF;AACA;EGryRE,cAAA;EACA,mBuD2B2C;EACrC,eAAA;EACA,gBAAA;EACA,mBAAA;E1DurRR,iBAAA;AAsFA;A0DxwRA;EACE,cAAA;E1DqrRF,mBAAA;EAsFE,eAAe;E0DxwRjB,gBAAA;EACE,mBAAA;EACA,iBAAA;A1D0wRF;AACA;EApFA,cAAA;E0DprRE,mBAAA;EvDjDA,euDkDgB;EvDjDhB,gBAAA;EACA,mBuDgDyB;EvD/CzB,iBuD+C+B;A1D8wRjC;AACA;EApFA,cAAA;E0DzrRE,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;E1D2rRJ,6BAAA;A0DzrRE;A1DgxRF;E0D9wRI,cAAA;EACA,mBAAA;EACA,eAAA;E1D2rRJ,gBAAA;E0DzrRE,mBAAA;EACE,iBAAA;E1D2rRJ,+BAAA;A0D1rRI;A1DixRJ;E0D/wRM,cAAA;E1D4rRN,mBAAA;E0D3rRM,eAAA;EvDrEJ,gBuDsEoB;EvDrEpB,mBAAA;EACA,iBuDoE6B;EvDnE7B,+BuDmEmC;A1DqxRrC;AACA;E0DrxRQ,cAAA;E1DksRR,mBAAA;E0DhsRM,eAAA;EvDzEJ,iBuD0EoB;EvDzEpB,mBAAA;EACA,iBuDwE6B;EvDvE7B,oBuDuEmC;EvDtEnC,gBAAA;AHi2RF;AACA;E0D1xRQ,cAAA;E1DusRR,mBAAA;EAsFE,eAAe;E0DvxRjB,gBAAA;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;A1DyxRF;;A0DvxRE;EACE,cAAA;E1DqsRJ,mBAAA;E0DpsRI,eAAA;EACE,gBAAA;E1DssRN,mBAAA;E0DrsRM,iBAAA;EvD3FJ,mBuD4FoB;A1D4xRtB;;AAEA;EGt3RE,cAAA;EACA,mBuDuF2C;E1D4sR7C,eAAA;E0D1sRM,gBAAA;EACE,mBAAA;EvD/FN,iBuDgGoB;EvD/FpB,mBAAA;AHi4RF;AACA;EG/3RE,cAAA;AHi4RF;;AAnFA;EAsFE,cAAc;E2D15RhB,mBAAA;EACE,eAAA;EACA,gBAAA;E3Du0RF,mBAAA;E2Dt0RE,iBAAA;ExDeA,6BJhBqB;AC+5RvB;;AAEA;EG74RE,WAAA;EACA,mBwDnBqD;EACnD,eAAA;EACA,gBAAA;EACA,mBAAA;E3D60RJ,iBAAA;A2D30RE;A3Dk6RF;EGx5RE,WAAA;EACA,mBwDVuC;ExDWvC,eAAA;EACA,gBAAA;EACA,mBwDbqD;EACnD,iBAAA;E3Dk1RJ,eAAA;A2Dh1RE;A3Du6RF;EGj6RE,0BAAA;AHm6RF;;AAEA;EGj6RE,cAAA;EwDRE,mBAAA;E3Du1RJ,eAAA;E2Dr1RE,gBAAA;EACE,mBAAA;EACA,iBAAA;A3D46RJ;AACA;E2D16RI,cAAA;A3D46RJ;;A2Dz6RE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;A3Du1RJ;;AAuFA;E2D16RI,cAAA;E3Du1RJ,mBAAA;E2Dr1RE,eAAA;ExDnBA,gBJhBqB;EIiBrB,mBAAA;EACA,iBwDkBuC;A3D86RzC;;AAEA;E2D/6RI,gBAAA;A3Di7RJ;;A2D96RE;ExDxBA,eJhBqB;AC09RvB;;AAEA;EGx8RE,cAAA;EACA,mBwDoBqD;EACnD,eAAA;EACA,gBAAA;E3Di2RJ,mBAAA;E2D/1RE,iBAAA;A3Ds7RF;AACA;EGl9RE,cAAA;AHo9RF;AACA;EGl9RE,sBwDyBqD;EACnD,WAAA;EACA,mBAAA;EACA,eAAA;E3Ds2RJ,gBAAA;E2Dr2RI,mBAAA;ExDlCF,iBJhBqB;AC++RvB;;AAEA;EG79RE,cAAA;EACA,mBwD8BuD;EACnD,eAAA;E3D42RN,gBAAA;E2Dz2RE,mBAAA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;A3Dg8RJ;AACA;E2D97RI,aAAA;EACA,yBAAA;A3Dg8RJ;AACA;EApFA,aAAA;E2Dz2RE,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;A3Dg8RJ;;AAEA;E2D97RI,sBAAA;E3D22RJ,yBAAA;A2Dz2RE;A3Dg8RF;E2D97RI,iCAAA;E3D22RJ,gCAAA;E2Dz2RE,yBAAA;EAEE,mBAAA;EACA,yBAAA;E3D02RJ,yBAAA;E2Dx2RE,eAAA;EACE,gBAAA;E3D02RJ,iBAAA;E2Dx2RM,iBAAA;A3D+7RN;AApFA;E2Dx2RM,yBAAA;EACE,kBAAA;EACA,UAAA;A3D+7RR;;AAEA;E2D57RQ,yBAAA;A3Dy2RR;A2Dv2RM;EACE,kBAAA;E3D87RN,yB2D77RQ;E3Dy2RR,mBAAA;EACF,gBAAA;E2Dv2RM,uBAAA;EACE,gBAAA;A3D87RR;AACA;E2D57RQ,yBAAA;A3D87RR;AApFA;E2Dv2RM,wBAAA;A3D87RN;AACA;E2D57RQ,yBAAA;A3D87RR;;AAEA;E2D57RQ,cAAA;EACA,mBAAA;E3Dy2RR,eAAA;E2Dv2RM,iBAAA;EACE,iBAAA;E3Dy2RR,iBAAA;A2Dt2RM;;A3D87RN;EGzjSE,aAAA;EACA,mBAAA;AH2jSF;;A2D97RQ;ExDhIN,oCwDiIsB;A3Di8RxB;;AAEA;E2Dl8RU,UAAA;E3D+2RV,qCAAA;AAsFA;;AAEA;EApFA,cAAA;EAsFE,mBAAmB;E2Dh8RrB,eAAA;EACE,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;A3Dk8RF;;AAnFA;EAsFE,cAAc;E2Dh8RhB,mBAAA;EACE,eAAA;E3D62RF,gBAAA;EAsFE,iBAAiB;E2Dh8RnB,iBAAA;A3Dk8RA;;AAEA;E2Dh8RE,cAAA;E3D62RF,mBAAA;EAsFE,eAAe;E2Dj8RjB,gBAAA;EACE,iBAAA;E3D82RF,iBAAA;AAsFA;;AAEA;E2Dl8RE;I3D+2RF,UAAA;IAsFI,qBAAqB;E2Dn8RzB;EACE;IACA,UAAA;IACA,mBAAA;E3Dg3RF;A2D92RI;A3Dq8RJ;EApFA,kBAAA;E2D72RE,gBAAA;EACE,aAAA;EACA,YAAA;E3D+2RJ,WAAA;E2D92RI,mBAAA;EACE,yBAAA;A3Dq8RN;;AAEA;E2Dn8RM,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;E3Dg3RN,mBAAA;E2D72RE,iBAAA;A3Do8RF;;AAnFA;E2D92RI,cAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;A3Dq8RN;;AAEA;EApFA,kBAAA;E2D92RI,yBAAA;EACE,4CAAA;EACA,mBAAA;EACA,eAAA;A3Dq8RN;AACA;E2Dn8RM,4BAAA;A3Dq8RN;AACA;EApFA,cAAA;E2D72RE,mBAAA;EACE,eAAA;EACA,gBAAA;E3D+2RJ,mBAAA;E2D92RI,iBAAA;EACE,gBAAA;EACA,qBAAA;A3Dq8RN;AACA;E2Dn8RM,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;A3Dg3RN;A2D72RE;EACE,cAAA;EACA,mBAAA;E3D+2RJ,eAAA;E2D92RI,gBAAA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A3Dq8RN;;AAnFA;EAsFE,kBAAkB;E2Dj8RpB,0CAAA;EACE,0BAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;A3Dm8RF;AApFA;EAsFE,cAAc;E2Dl8RhB,mBAAA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;A3Do8RF;AApFA;EAsFE,WAAW;E2Dl8Rb,YAAA;A3Do8RA;AACA;E2Dl8RE,kBAAA;A3Do8RF;AACA;EApFA,cAAA;EAsFE,mBAAmB;E2Dn8RrB,eAAA;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;A3Dq8RF;AACA;EApFA,cAAA;AAsFA;A2Dp8RA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;A3Ds8RF;;AAnFA;EAsFE,4BAA4B;E4DvuS9B,kBAAA;EACI,yBAAA;E5DopSJ,4CAAA;E4DlpSI,mBAAA;EACI,YAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;A5DyuSR;AACA;EApFA,aAAA;E4DlpSQ,8BAAA;EACI,mBAAA;A5DyuSZ;AApFA;E4DlpSY,UAAA;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A5DyuShB;;A4DtuSgB;EACI,yBAAA;EACA,UAAA;E5DopSpB,mBAAA;A4D/oSQ;A5DsuSR;E4DpuSY,yBAAA;EACA,mBAAA;A5DipSZ;A4D/oSY;EACI,4BAAA;EACA,yBAAA;EACA,4BAAA;A5DsuShB;AACA;E4DpuSgB,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;A5DsuShB;AACA;E4DpuSgB,cAAA;E5DipShB,mBAAA;E4D/oSgB,eAAA;EACI,gBAAA;EACA,mBAAA;E5DipSpB,iBAAA;A4D9oSY;A5DquSZ;E4DnuSgB,4BAAA;E5DgpShB,yBAAA;E4D9oSY,aAAA;A5DquSZ;AACA;EApFA,aAAA;E4D9oSY,qCAAA;EACI,qBAAA;EACA,gBAAA;A5DgpShB;;AAuFA;E4DluSgB,mBAAA;E5D+oShB,2CAAA;AAsFA;;AAEA;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;EAC3C,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,+CAA+C;AACjD;AACA;;;;EAIE,SAAS;AACX;AACA;;;;;EAKE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE;;;;;IAKE,WAAW;EACb;AACF;AACA;;;;;;EAME,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;;;EAOE,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;;;;;;;EAOE,iBAAiB;AACnB;AACA;;;;EAIE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;;;;EAIE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,YAAY;AACd;AACA;;EAEE,YAAY;AACd,EAAE,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
